import React, { Fragment, useRef } from "react";
import { useState, useEffect } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import MainTopFilters from "../App/MainTopFilters";
import { type } from "os";
import { json } from "d3";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import InputMask from "../App/InputMask";
import {
  GetSelectedIDsFromList,
  GetSelectedIDsFromListWithSpace,
  getAccessSettings,
  removeNonNumeric,
} from "../Shared/Utility";
import DragDrop from "../DragDrop/DragDrop";
import DonutChart from "../Charts/DonutChart";
import Confirmation from "../App/Confirmation";
import LockUnlock from "../App/LockUnlock";
import moment from "moment";
import ApprovalsScreen from "./ApprovalsScreen";

function Scorecard() {
  const globalState = useGlobalState();

  const [HideActual, setHideActual] = useState(false);
  const handleHideActualChange = () => {
    setHideActual(!HideActual); // Toggle the checkbox state
    //setSomeVariable(!isChecked); // Update the variable based on the checkbox state
  };

  const [showAnimation, setShowAnimation] = useState(false);
  const [reEarnableModal, setReEarnableModal] = useState(false);
  const [ShowEditModeActual, setShowEditModeActual] = useState(true);
  const [ShowEditMode, setShowEditMode] = useState(true);
  const ShowEditControls = () => {
    setShowEditMode(true);
  };
  const HideEditControls = () => {
    setShowEditMode(false);
  };

  const [reEarnableObject, setReEarnableObject] = useState({
    SectionID: 0,
    IBBDepartmentID: 0,
    Title: "",
    ShortTitle: "",
    Description: "",
    Type: 0,
    Value: 0,
    ValueDescription: "",
    PTOrderBy: 0,
    ExtraTextField1: "",
    ExtraTextField2: "",
  });

  const [entriesModal, setEntriesModal] = useState(false);
  const [entriesObject, setEntriesObject] = useState({
    PID: 0,
    SectionID: 0,
    ParentID: 0,
    Title: "",
    Description: "2",
    SerialNumber: "",
    IsInputLevel: false,
    FormattingOptions: "",
    SplitPercentage: 0,
    IBBProgramCriteriaQuestionID: 0,
    Name: "",
    QuestionType: 0,
    NumberOfTargets: 0,
    IsShowTargetSN: false,
    IsShowTextTarget: false,
    IsShowActualNotes: false,
    TargetValueFormat: 0,
    LinkTargetTo: 0,
    IsHideActual: false,
    ActualValueFormat: 0,
    LinkActualTo: 0,
    IsDisplayPercentage: false,
    IsShowHeader: true,
    DataLevelType: 1,
    IsDoubleActual: false,
    Actual1Title: "",
    Actual1PassPercentage: 0,
    Actual2Title: "",
    Actual2PassPercentage: 0,
  });

  const [exceptionObject, setExceptionObject] = useState({
    IBBProgramCriteriaQuestionInputExceptionID: 0,
    IBBProgramCriteriaQuestionInputID: 0,
    Name: "",
    Description: "",
    Status: 0,
    UpdatedStatus: 0,
    BusinessCase: "",
    FinancialValue: 0,
    ApprovedValue: 0,
    ConditionText: "",
  });

  const [copyModal, setCopyModal] = useState(false);
  const [AddException, setAddException] = useState(false);
  const [ViewException, setViewException] = useState(0);
  const [ViewExceptionData, setViewExceptionData] = useState([]);

  const [isAllSectionsExpanded, setIsAllSectionsExpanded] = useState(false);

  const [scorecardFilter, setScorecardFilter] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    IBBScorecardID: 0,
    PFIDealerID: 0,
    ShowInLC: false,
  });

  const [scorecardData, setScorecardData] = useState({
    ReearnablePercentage: 0,
    POT: 0,
    FinalPayout: 0,
    FinalPayoutPercentage: 0,
    ConditionalHold: 0,
    Status: 0,
    StatusText: "",
    CurrencyID: 1,
    PFIBrandID: 2,
    TotalPercentage: 0,
    JaguarPOTInLC: 0,
    JaguarPOTInUSD: 0,
    LandRoverPOTInLC: 0,
    LandRoverPOTInUSD: 0,
    TotalPercentageAchieved: 0,
    JaguarFinalPayoutInLC: 0,
    JaguarFinalPayoutInUSD: 0,
    LandRoverFinalPayoutInLC: 0,
    LandRoverFinalPayoutInUSD: 0,
    JaguarConditionalHoldInLC: 0,
    JaguarConditionalHoldInUSD: 0,
    LandRoverConditionalHoldInLC: 0,
    LandRoverConditionalHoldInUSD: 0,
    CanInputTargetsData: 1,
    CanInputActualsData: 1,
    CanAddException: 1,
  });

  const [programData, setProgramData] = useState<any>({
    Name: "",
    Description: "",
  });

  const [formattingOptionsArray1, setFormattingOptionsArray1] = useState([
    { Name: "Bold", ClassName: "score-bold" },
    { Name: "Normal", ClassName: "score-normal" },
    { Name: "Italic", ClassName: "score-italic" },
  ]);
  const [formattingOptionsArray2, setFormattingOptionsArray2] = useState([
    { Name: "Left", ClassName: "score-text-left" },
    { Name: "Right", ClassName: "score-text-right" },
    { Name: "Center", ClassName: "score-text-center" },
  ]);
  const [formattingOptionsArray3, setFormattingOptionsArray3] = useState([
    { Name: "X-Small", ClassName: "score-width-xs" },
    { Name: "Small", ClassName: "score-width-sm" },
    { Name: "Medium", ClassName: "score-width-md" },
    { Name: "Large", ClassName: "score-width-lg" },
  ]);
  const [formattingOptionsArray4, setFormattingOptionsArray4] = useState([
    { Name: "Border", ClassName: "score-border" },
  ]);
  const [formattingOptionsArray5, setFormattingOptionsArray5] = useState([
    { Name: "Font 10", ClassName: "font-10" },
    { Name: "Font 11", ClassName: "font-11" },
    { Name: "Font 12", ClassName: "font-12" },
    { Name: "Font 13", ClassName: "font-13" },
    { Name: "Font 14", ClassName: "font-14" },
    { Name: "Font 15", ClassName: "font-15" },
    { Name: "Font 16", ClassName: "font-16" },
    { Name: "Font 18", ClassName: "font-18" },
  ]);

  const [scorecardSectionData, setScorecardSectionData] = useState([]);

  const [programList, setProgramList] = useState<any>([]);

  const [quarterList, setQuarterList] = useState<any>([]);

  const [importerList, setImporterList] = useState<any>([]);

  const [departmentList, setDepartmentList] = useState({}) as any;

  const [sectionsListBK, setSectionsListBK] = useState<any>([]);
  const [sectionsList, setSectionsList] = useState<any>([]);

  const [gatewaysList, setGatewaysList] = useState<any>([]);

  const [programCriteriaData, setProgramCriteriaData] = useState<any>([]);

  const [programCriteriaQuestionData, setProgramCriteriaQuestionData] =
    useState<any>([]);

  const [
    programCriteriaQuestionInputData,
    setProgramCriteriaQuestionInputData,
  ] = useState<any>([]);

  const [
    programCriteriaQuestionInputDataRetailerLevel,
    setProgramCriteriaQuestionInputDataRetailerLevel,
  ] = useState<any>([]);

  const [
    programCriteriaQuestionInputExceptionData,
    setProgramCriteriaQuestionInputExceptionData,
  ] = useState<any>([]);

  const [
    programCriteriaQuestionInputExceptionAttachmentData,
    setProgramCriteriaQuestionInputExceptionAttachmentData,
  ] = useState<any>([]);

  const [showRetailerLevelDataIDs, setShowRetailerLevelDataIDs] = useState<any>(
    []
  );

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let isEditView = params.get("ms");
    if (isEditView != undefined && isEditView == "1") {
      setShowEditMode(true);
      setShowEditModeActual(true);
    } else {
      setShowEditMode(false);
      setShowEditModeActual(false);
    }

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = scorecardFilter.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = scorecardFilter.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = scorecardFilter.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = scorecardFilter.ProgramID;

    setScorecardFilter((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
    }));

    IBBProgramGetProgramListForScorecard(
      IBBProgramID,
      QuarterID,
      IBBScorecardID,
      PFIDealerID
    );
    if (isEditView) IBBDepartmentGetCompleteGridDataCustom();
  }, []);

  useEffect(() => {
    refineProgramCriteriaData();
    resetObjects(2);
  }, [programCriteriaData]);

  useEffect(() => {
    checkIsAllSectionsExpanded();
  }, [sectionsList]);

  useEffect(() => {
    if (scorecardFilter.ProgramID > 0) {
      IBBProgramGetProgramListForScorecard(
        scorecardFilter.ProgramID,
        scorecardFilter.QuarterID,
        scorecardFilter.IBBScorecardID,
        scorecardFilter.PFIDealerID
      );
      if (!ShowEditMode) IBBProgramGetScorecardListForScorecard();
    }
  }, [scorecardFilter.ProgramID, scorecardFilter.QuarterID]);

  useEffect(() => {
    if (scorecardFilter.IBBScorecardID > 0 && !ShowEditMode) {
      assignScorecardData(scorecardFilter.IBBScorecardID);
      IBBScorecardGetScorecardAndInputDataForImporter();
    }
  }, [
    scorecardFilter.ProgramID,
    scorecardFilter.QuarterID,
    scorecardFilter.IBBScorecardID,
  ]);

  useEffect(() => {
    if (scorecardFilter.IBBScorecardID > 0 && !ShowEditMode) {
      assignScorecardData(scorecardFilter.IBBScorecardID);
    }
  }, [scorecardFilter.ShowInLC]);

  useEffect(() => {
    refineProgramCriteriaData();
  }, [programCriteriaQuestionInputData]);

  useEffect(() => {
    assignScorecardData(scorecardFilter.IBBScorecardID);
  }, [programList, importerList]);

  useEffect(() => {
    setSectionsList([]);
    setSectionsListBK([]);
    setGatewaysList([]);
  }, [scorecardFilter.ProgramID]);

  function IBBDepartmentGetCompleteGridDataCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 100;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBDepartment/IBBDepartmentGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setDepartmentList(result[1]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number,
    IBBScorecardID: number,
    PFIDealerID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = scorecardFilter.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = QuarterID;
    object.pfidealerid = PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setScorecardFilter((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            IBBProgramGetSectionAndCriteriaDataForScorecard(IBBProgramID);

            if (IBBScorecardID == 0) {
              if (result[1].length > 0) {
                IBBScorecardID = result[1][0].PID;

                setScorecardFilter((prevState: any) => ({
                  ...prevState,
                  IBBScorecardID: IBBScorecardID,
                }));
              }
            }
            setImporterList(result[1]);

            setQuarterList(result[2]);
            if (QuarterID == 0) {
              let QuarterID = result[2][0].PID;
              setScorecardFilter((prevState: any) => ({
                ...prevState,
                QuarterID: QuarterID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetScorecardListForScorecard() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = scorecardFilter.ProgramID;
    object.numericquarter = scorecardFilter.QuarterID;
    object.pfidealerid = scorecardFilter.PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetScorecardListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            setImporterList(result[0]);

            if (scorecardFilter.IBBScorecardID == 0 && result[0].length > 0) {
              let IBBScorecardID = result[0][0].PID;
              setScorecardFilter((prevState: any) => ({
                ...prevState,
                IBBScorecardID: IBBScorecardID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBScorecardGetScorecardAndInputDataForImporter() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = scorecardFilter.ProgramID;
    object.ibbscorecardid = scorecardFilter.IBBScorecardID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecard/IBBScorecardGetScorecardAndInputDataForImporter",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          var filtered = result[0].filter((item: any) => item.ObjectType == 1);
          setProgramCriteriaQuestionInputData(filtered);
          filtered = result[0].filter((item: any) => item.ObjectType == 2);
          setProgramCriteriaQuestionInputDataRetailerLevel(filtered);
          if (
            (getAccessSettings(2, 27) > 0 &&
              globalState.AppAccessLevelData.DID > 0) ||
            globalState.AppAccessLevelData.DID == 0
          )
            setProgramCriteriaQuestionInputExceptionData(result[1]);
          else setProgramCriteriaQuestionInputExceptionData([]);

          setProgramCriteriaQuestionInputExceptionAttachmentData(result[2]);

          if (result.length > 3) {
            setScorecardSectionData(result[3]);
            let CanInputTargetsData = 0;
            let CanInputActualsData = 0;
            let CanAddException = 1;
            if (result[4] != null && result[4].length > 0) {
              CanInputTargetsData = result[4][0].CanInputTargetsData;
              CanInputActualsData = result[4][0].CanInputActualsData;
              CanAddException = result[4][0].CanAddException;
            }
            setScorecardData((prevState: any) => ({
              ...prevState,
              CanInputTargetsData: CanInputTargetsData,
              CanInputActualsData: CanInputActualsData,
              CanAddException: CanAddException,
            }));
          } else setScorecardSectionData([]);

          setExceptionsData([]);
          setExceptionsDocuments([]);
          setRequiredApprovalUser([]);
          if (globalState.AppAccessLevelData.DID == 0)
            IBBProgramCriteriaQuestionInputExceptionGetDataForApproval();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function assignScorecardData(IBBScorecardID: number) {
    let ReearnablePercentage = 0;
    var filtered = programList.filter(
      (item: any) => item.IBBProgramID == scorecardFilter.ProgramID
    );
    if (filtered.length > 0) {
      ReearnablePercentage = filtered[0].TotalPercentage;
    }

    setScorecardData((prevState: any) => ({
      ...prevState,
      ReearnablePercentage: ReearnablePercentage,
      POT: 0,
      FinalPayout: 0,
      FinalPayoutPercentage: 0,
      Status: 0,
      StatusText: "In Progress",
    }));

    filtered = importerList.filter((item: any) => item.PID == IBBScorecardID);
    if (scorecardFilter.ShowInLC && filtered.length > 0) {
      filtered[0].FinalPayoutPercentage = 0;
      if (filtered[0].POT > 0 && filtered[0].FinalPayout > 0)
        filtered[0].FinalPayoutPercentage =
          (filtered[0].FinalPayout / filtered[0].POT) * 100;
      setScorecardData((prevState: any) => ({
        ...prevState,
        ReearnablePercentage: ReearnablePercentage,
        POT: filtered[0].POT,
        FinalPayout: filtered[0].FinalPayout,
        FinalPayoutPercentage: Number(
          filtered[0].FinalPayoutPercentage
        ).toFixed(2),
        ConditionalHold: filtered[0].ConditionalHold,
        Status: filtered[0].Status,
        StatusText: filtered[0].StatusText,
        CurrencyID: filtered[0].CurrencyID,
        PFIBrandID: filtered[0].PFIBrandID,
      }));
    } else if (filtered.length > 0) {
      filtered[0].FinalPayoutPercentage = 0;
      if (filtered[0].POTInUSD > 0 && filtered[0].FinalPayoutInUSD > 0)
        filtered[0].FinalPayoutPercentage =
          (filtered[0].FinalPayoutInUSD / filtered[0].POTInUSD) * 100;
      setScorecardData((prevState: any) => ({
        ...prevState,
        ReearnablePercentage: ReearnablePercentage,
        POT: filtered[0].POTInUSD,
        FinalPayout: filtered[0].FinalPayoutInUSD,
        FinalPayoutPercentage: Number(
          filtered[0].FinalPayoutPercentage
        ).toFixed(2),
        Status: filtered[0].Status,
        StatusText: filtered[0].StatusText,
        CurrencyID: filtered[0].CurrencyID,
        PFIBrandID: filtered[0].PFIBrandID,
      }));
    }
  }

  function assignScorecardFinalCalculationsData(
    scorecardCalculationsData: any
  ) {
    if (
      scorecardCalculationsData != undefined &&
      scorecardCalculationsData.length > 0
    ) {
      let data = scorecardCalculationsData[0];

      setScorecardData((prevState: any) => ({
        ...prevState,
        TotalPercentage: data.TotalPercentage,
        JaguarPOTInLC: data.JaguarPOTInLC,
        JaguarPOTInUSD: data.JaguarPOTInUSD,
        LandRoverPOTInLC: data.LandRoverPOTInLC,
        LandRoverPOTInUSD: data.LandRoverPOTInUSD,
        TotalPercentageAchieved: data.TotalPercentageAchieved,
        JaguarFinalPayoutInLC: data.JaguarFinalPayoutInLC,
        JaguarFinalPayoutInUSD: data.JaguarFinalPayoutInUSD,
        LandRoverFinalPayoutInLC: data.LandRoverFinalPayoutInLC,
        LandRoverFinalPayoutInUSD: data.LandRoverFinalPayoutInUSD,
        JaguarConditionalHoldInLC: data.JaguarConditionalHoldInLC,
        LandRoverConditionalHoldInLC: data.LandRoverConditionalHoldInLC,
        JaguarConditionalHoldInUSD: data.JaguarConditionalHoldInUSD,
        LandRoverConditionalHoldInUSD: data.LandRoverConditionalHoldInUSD,
      }));
    }
  }
  function IBBProgramGetSectionAndCriteriaDataForScorecard(
    IBBProgramID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = scorecardFilter.ProgramID;

    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetSectionAndCriteriaDataForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          result[0] = expandPreviouslyExpandedSections(result[0]);
          setSectionsList(result[0]);
          setSectionsListBK(result[0]);
          setProgramCriteriaData(result[1]);
          setProgramCriteriaQuestionData(result[2]);
          if (result.length > 3 && result[3].length > 0)
            setProgramData(result[3][0]);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramSectionSaveCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = scorecardFilter.ProgramID;
    object.ibbdepartmentid = reEarnableObject.IBBDepartmentID;
    object.ibbprogramsectionid = reEarnableObject.SectionID;
    object.title = reEarnableObject.Title;
    object.shorttitle = reEarnableObject.ShortTitle;
    object.description = reEarnableObject.Description;
    object.type = reEarnableObject.Type;
    object.value = reEarnableObject.Value;
    object.valuedescription = reEarnableObject.ValueDescription;
    object.ptorderby = reEarnableObject.PTOrderBy;
    object.extratextfield1 = reEarnableObject.ExtraTextField1;
    object.extratextfield2 = reEarnableObject.ExtraTextField2;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramSection/IBBProgramSectionSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setReEarnableModal(false);
          IBBProgramGetSectionAndCriteriaDataForScorecard(0);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramCriteriaSave() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramcriteriaid = entriesObject.PID;
    object.ibbprogramsectionid = entriesObject.SectionID;
    object.title = entriesObject.Title;
    object.description = entriesObject.Description;
    object.parentid = entriesObject.ParentID;
    object.serialnumber = entriesObject.SerialNumber;
    object.isinputlevel = entriesObject.IsInputLevel;
    object.formattingoptions = entriesObject.FormattingOptions;
    object.splitpercentage = entriesObject.SplitPercentage;

    //MM:: IBBProgramCriteriaQuestionData
    object.ibbprogramcriteriaquestionid =
      entriesObject.IBBProgramCriteriaQuestionID;
    object.name = entriesObject.Name;
    object.questiontype = entriesObject.QuestionType;
    object.targetvalueformat = entriesObject.TargetValueFormat;
    object.linktargetto = entriesObject.LinkTargetTo;
    object.ishideactual = entriesObject.IsHideActual;
    object.actualvalueformat = entriesObject.ActualValueFormat;
    object.linkactualto = entriesObject.LinkActualTo;
    object.isdisplaypercentage = entriesObject.IsDisplayPercentage;
    object.numberoftargets = entriesObject.NumberOfTargets;
    object.isshowtargetsn = entriesObject.IsShowTargetSN;
    object.isshowtexttarget = entriesObject.IsShowTextTarget;
    object.isshowactualnotes = entriesObject.IsShowActualNotes;
    object.isshowheader = entriesObject.IsShowHeader;
    object.dataleveltype = entriesObject.DataLevelType;
    object.actual1title = entriesObject.Actual1Title;
    object.actual1passpercentage = entriesObject.Actual1PassPercentage;
    object.actual2title = entriesObject.Actual2Title;
    object.actual2passpercentage = entriesObject.Actual2PassPercentage;

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramCriteria/IBBProgramCriteriaSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setEntriesModal(false);
          IBBProgramGetSectionAndCriteriaDataForScorecard(0);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramCriteriaDeleteRecord(IBBProgramCriteriaID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramcriteriaid = IBBProgramCriteriaID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramCriteria/IBBProgramCriteriaDeleteRecord",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBProgramGetSectionAndCriteriaDataForScorecard(0);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramCriteriaQuestionInputSaveCustom(
    IBBProgramCriteriaQuestionInputID: number,
    IBBScorecardID: number,
    IBBProgramCriteriaQuestionID: number,
    Name: string,
    ObjectType: number,
    Target1: string,
    Target2: string,
    Actual1: string,
    Actual2: string,
    InitialResult: number,
    FinalResult: number,
    Type: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramcriteriaquestioninputid =
      IBBProgramCriteriaQuestionInputID;
    object.ibbscorecardid = IBBScorecardID;
    object.ibbprogramcriteriaquestionid = IBBProgramCriteriaQuestionID;
    object.name = Name;
    object.objecttype = ObjectType;
    object.objectid = 0;
    object.ObjectName = "";
    object.target1 = Target1;
    object.target2 = Target2;
    object.actual1 = Actual1;
    object.actual2 = Actual2;
    object.initialresult = InitialResult;
    object.finalresult = FinalResult;
    object.type = Type;

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramCriteriaQuestionInput/IBBProgramCriteriaQuestionInputSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          // setEntriesModal(false);
          // IBBProgramGetSectionAndCriteriaDataForScorecard(0);
          IBBScorecardGetScorecardAndInputDataForImporter();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramCriteriaQuestionInputExceptionSaveCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramcriteriaquestioninputexceptionid =
      exceptionObject.IBBProgramCriteriaQuestionInputExceptionID;
    object.ibbprogramcriteriaquestioninputid =
      exceptionObject.IBBProgramCriteriaQuestionInputID;
    object.name = exceptionObject.Name;
    object.description = exceptionObject.Description;
    object.status = exceptionObject.Status;
    object.businesscase = exceptionObject.BusinessCase;
    object.financialvalue = exceptionObject.FinancialValue;
    object.approvedvalue = exceptionObject.ApprovedValue;

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramCriteriaQuestionInputException/IBBProgramCriteriaQuestionInputExceptionSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setAddException(false);
          IBBScorecardGetScorecardAndInputDataForImporter();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramCriteriaQuestionInputExceptionDeleteRecordCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramcriteriaquestioninputexceptionid =
      exceptionObject.IBBProgramCriteriaQuestionInputExceptionID;

    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramCriteriaQuestionInputException/IBBProgramCriteriaQuestionInputExceptionDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setAddException(false);
          IBBScorecardGetScorecardAndInputDataForImporter();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function updateValueOfInputKey(Type: number, Value: any, PID: number) {
    let programCriteriaQuestionDataLocal = [...programCriteriaQuestionData];
    let Index = -1;
    for (let i = 0; i < programCriteriaQuestionDataLocal.length; i++) {
      if (programCriteriaQuestionDataLocal[i].PID == PID) {
        Index = i;
        break;
      }
    }

    if (Index > -1) {
      if (Type == 1) {
        programCriteriaQuestionDataLocal[Index].TargetValue = Value;
      } else if (Type == 2) {
        programCriteriaQuestionDataLocal[Index].ActualValue = Value;
      } else if (Type == 6) {
        programCriteriaQuestionDataLocal[Index].Actual2Value = Value;
      }

      if (
        (Type == 1 || Type == 2) &&
        programCriteriaQuestionDataLocal[Index].QuestionType == 2
      ) {
        programCriteriaQuestionDataLocal[Index].IsTargetAchieved = "0";
        if (
          programCriteriaQuestionDataLocal[Index].ActualValue >=
          programCriteriaQuestionDataLocal[Index].TargetValue
        )
          programCriteriaQuestionDataLocal[Index].IsTargetAchieved = "1";
      }

      if (Type == 3)
        programCriteriaQuestionDataLocal[Index].IsTargetAchieved = Value;
      if (Type == 4)
        programCriteriaQuestionDataLocal[Index].TargetTextValue = Value;
      if (Type == 5) {
        programCriteriaQuestionDataLocal[Index].Actual2Value = Value;
      }

      setProgramCriteriaQuestionData(programCriteriaQuestionDataLocal);
      checkGatewaysStatus();
      if (Type == 3) {
        saveInputData(programCriteriaQuestionDataLocal[Index], Type);
      }
    }
  }

  function saveInputData(
    programCriteriaQuestionDataInput: any,
    Type: number = 0
  ) {
    if (!ShowEditMode) {
      IBBProgramCriteriaQuestionInputSaveCustom(
        programCriteriaQuestionDataInput.IBBProgramCriteriaQuestionInputID,
        scorecardFilter.IBBScorecardID,
        programCriteriaQuestionDataInput.PID,
        "",
        1,
        programCriteriaQuestionDataInput.TargetValue,
        programCriteriaQuestionDataInput.TargetTextValue,
        programCriteriaQuestionDataInput.ActualValue,
        programCriteriaQuestionDataInput.Actual2Value,
        programCriteriaQuestionDataInput.IsTargetAchieved,
        programCriteriaQuestionDataInput.IsTargetAchieved,
        Type
      );
    }
  }

  function refineProgramCriteriaData() {
    const sectionsListLocal = [...sectionsList];

    let programCriteriaDataLocal = [...programCriteriaData];

    programCriteriaDataLocal = programCriteriaDataLocal.filter(
      (item: any) =>
        item.Description == 2 ||
        scorecardData.PFIBrandID == 2 ||
        item.Description == scorecardData.PFIBrandID
    );
    let programCriteriaQuestionDataLocal = [...programCriteriaQuestionData];

    for (var i = 0; i < sectionsListLocal.length; i++) {
      var filtered = programCriteriaDataLocal.filter(
        (item: any) =>
          item.SectionID === sectionsListLocal[i].SectionID &&
          item.ParentID === 0
      );
      sectionsListLocal[i].ChildData = filtered;
      sectionsListLocal[i].ExceptionData = [];
      let exceptionCount = [0, 0, 0];
      for (var j = 0; j < sectionsListLocal[i].ChildData.length; j++) {
        filtered = programCriteriaDataLocal.filter(
          (item: any) => item.ParentID === sectionsListLocal[i].ChildData[j].PID
        );
        sectionsListLocal[i].ChildData[j].ChildData = filtered;
        sectionsListLocal[i].ChildData[j].programCriteriaQuestionData = [];
        sectionsListLocal[i].ChildData[j].ExceptionData = {};

        if (sectionsListLocal[i].ChildData[j].IsInputLevel) {
          filtered = programCriteriaQuestionDataLocal.filter(
            (item: any) =>
              item.ParentID === sectionsListLocal[i].ChildData[j].PID
          );

          for (let input = 0; input < filtered.length; input++) {
            let filteredInput = programCriteriaQuestionInputData.filter(
              (item: any) =>
                item.IBBProgramCriteriaQuestionID ===
                filtered[input].IBBProgramCriteriaQuestionID
            );

            filtered[input].IBBProgramCriteriaQuestionInputID = 0;
            filtered[input].TargetValue = "";
            filtered[input].TargetTextValue = "";
            filtered[input].ActualValue = "";
            filtered[input].Actual2Value = "";
            filtered[input].IsTargetAchieved = -1;

            filtered[input].ExceptionData = {};
            if (filteredInput.length > 0) {
              filtered[input].IBBProgramCriteriaQuestionInputID =
                filteredInput[0].IBBProgramCriteriaQuestionInputID;
              filtered[input].TargetValue = filteredInput[0].Target1;
              filtered[input].TargetTextValue = filteredInput[0].Target2;
              filtered[input].ActualValue = filteredInput[0].Actual1;
              filtered[input].Actual2Value = filteredInput[0].Actual2;
              filtered[input].IsTargetAchieved = filteredInput[0].FinalResult;

              let filteredInputException =
                programCriteriaQuestionInputExceptionData.filter(
                  (item: any) =>
                    item.IBBProgramCriteriaQuestionInputID ===
                    filtered[input].IBBProgramCriteriaQuestionInputID
                );
              if (filteredInputException.length > 0) {
                filtered[input].ExceptionData = filteredInputException[0];
                for (
                  let inputException = 0;
                  inputException < filteredInputException.length;
                  inputException++
                ) {
                  if (filteredInputException[inputException].Status == 0)
                    exceptionCount[0] += 1;
                  else if (filteredInputException[inputException].Status == 1)
                    exceptionCount[1] += 1;
                  else if (filteredInputException[inputException].Status == 2)
                    exceptionCount[2] += 1;
                }
                sectionsListLocal[i].ExceptionData.push(
                  ...filteredInputException
                );
              }
            }
          }

          sectionsListLocal[i].ChildData[j].programCriteriaQuestionData =
            filtered;
        }

        for (
          var k = 0;
          k < sectionsListLocal[i].ChildData[j].ChildData.length;
          k++
        ) {
          filtered = programCriteriaDataLocal.filter(
            (item: any) =>
              item.ParentID ===
              sectionsListLocal[i].ChildData[j].ChildData[k].PID
          );
          sectionsListLocal[i].ChildData[j].ChildData[k].ChildData = filtered;
          sectionsListLocal[i].ChildData[j].ChildData[
            k
          ].programCriteriaQuestionData = [];
          sectionsListLocal[i].ChildData[j].ChildData[k].ExceptionData = {};

          if (sectionsListLocal[i].ChildData[j].ChildData[k].IsInputLevel) {
            filtered = programCriteriaQuestionDataLocal.filter(
              (item: any) =>
                item.ParentID ===
                sectionsListLocal[i].ChildData[j].ChildData[k].PID
            );

            for (let input = 0; input < filtered.length; input++) {
              let filteredInput = programCriteriaQuestionInputData.filter(
                (item: any) =>
                  item.IBBProgramCriteriaQuestionID ===
                  filtered[input].IBBProgramCriteriaQuestionID
              );

              filtered[input].IBBProgramCriteriaQuestionInputID = 0;
              filtered[input].TargetValue = "";
              filtered[input].TargetTextValue = "";
              filtered[input].ActualValue = "";
              filtered[input].Actual2Value = "";
              filtered[input].IsTargetAchieved = -1;

              filtered[input].ExceptionData = {};
              if (filteredInput.length > 0) {
                filtered[input].IBBProgramCriteriaQuestionInputID =
                  filteredInput[0].IBBProgramCriteriaQuestionInputID;
                filtered[input].TargetValue = filteredInput[0].Target1;
                filtered[input].TargetTextValue = filteredInput[0].Target2;
                filtered[input].ActualValue = filteredInput[0].Actual1;
                filtered[input].Actual2Value = filteredInput[0].Actual2;
                filtered[input].IsTargetAchieved = filteredInput[0].FinalResult;

                let filteredInputException =
                  programCriteriaQuestionInputExceptionData.filter(
                    (item: any) =>
                      item.IBBProgramCriteriaQuestionInputID ===
                      filtered[input].IBBProgramCriteriaQuestionInputID
                  );
                if (filteredInputException.length > 0) {
                  filtered[input].ExceptionData = filteredInputException[0];
                  for (
                    let inputException = 0;
                    inputException < filteredInputException.length;
                    inputException++
                  ) {
                    if (filteredInputException[inputException].Status == 0)
                      exceptionCount[0] += 1;
                    else if (filteredInputException[inputException].Status == 1)
                      exceptionCount[1] += 1;
                    else if (filteredInputException[inputException].Status == 2)
                      exceptionCount[2] += 1;
                  }

                  sectionsListLocal[i].ExceptionData.push(
                    ...filteredInputException
                  );
                }
              }
            }

            sectionsListLocal[i].ChildData[j].ChildData[
              k
            ].programCriteriaQuestionData = filtered;
          }

          for (
            var x = 0;
            x < sectionsListLocal[i].ChildData[j].ChildData[k].ChildData.length;
            x++
          ) {
            sectionsListLocal[i].ChildData[j].ChildData[k].ChildData[
              x
            ].programCriteriaQuestionData = [];
            sectionsListLocal[i].ChildData[j].ChildData[k].ChildData[
              x
            ].ExceptionData = {};
            if (
              sectionsListLocal[i].ChildData[j].ChildData[k].ChildData[x]
                .IsInputLevel
            ) {
              filtered = programCriteriaQuestionDataLocal.filter(
                (item: any) =>
                  item.ParentID ===
                  sectionsListLocal[i].ChildData[j].ChildData[k].ChildData[x]
                    .PID
              );

              for (let input = 0; input < filtered.length; input++) {
                let filteredInput = programCriteriaQuestionInputData.filter(
                  (item: any) =>
                    item.IBBProgramCriteriaQuestionID ===
                    filtered[input].IBBProgramCriteriaQuestionID
                );

                filtered[input].IBBProgramCriteriaQuestionInputID = 0;
                filtered[input].TargetValue = "";
                filtered[input].TargetTextValue = "";
                filtered[input].ActualValue = "";
                filtered[input].Actual2Value = "";
                filtered[input].IsTargetAchieved = -1;

                filtered[input].ExceptionData = {};
                if (filteredInput.length > 0) {
                  filtered[input].IBBProgramCriteriaQuestionInputID =
                    filteredInput[0].IBBProgramCriteriaQuestionInputID;
                  filtered[input].TargetValue = filteredInput[0].Target1;
                  filtered[input].TargetTextValue = filteredInput[0].Target2;
                  filtered[input].ActualValue = filteredInput[0].Actual1;
                  filtered[input].Actual2Value = filteredInput[0].Actual2;
                  filtered[input].IsTargetAchieved =
                    filteredInput[0].FinalResult;

                  let filteredInputException =
                    programCriteriaQuestionInputExceptionData.filter(
                      (item: any) =>
                        item.IBBProgramCriteriaQuestionInputID ===
                        filtered[input].IBBProgramCriteriaQuestionInputID
                    );
                  if (filteredInputException.length > 0) {
                    filtered[input].ExceptionData = filteredInputException[0];
                    for (
                      let inputException = 0;
                      inputException < filteredInputException.length;
                      inputException++
                    ) {
                      if (filteredInputException[inputException].Status == 0)
                        exceptionCount[0] += 1;
                      else if (
                        filteredInputException[inputException].Status == 1
                      )
                        exceptionCount[1] += 1;
                      else if (
                        filteredInputException[inputException].Status == 2
                      )
                        exceptionCount[2] += 1;
                    }

                    sectionsListLocal[i].ExceptionData.push(
                      ...filteredInputException
                    );
                  }
                }
              }
              sectionsListLocal[i].ChildData[j].ChildData[k].ChildData[
                x
              ].programCriteriaQuestionData = filtered;
            }
          }
        }
      }
      sectionsListLocal[i].exceptionCount = exceptionCount;
    }
    setSectionsList(sectionsListLocal);
    checkGatewaysStatus();
  }

  function saveReEarnableData() {
    IBBProgramSectionSaveCustom();
  }

  function saveEntriesData() {
    let selectedIdsGroup1 = GetSelectedIDsFromListWithSpace(
      "formatingClassName1"
    );
    let selectedIdsGroup2 = GetSelectedIDsFromListWithSpace(
      "formatingClassName2"
    );
    let selectedIdsGroup3 = GetSelectedIDsFromListWithSpace(
      "formatingClassName3"
    );
    let selectedIdsGroup4 = GetSelectedIDsFromListWithSpace(
      "formatingClassName4"
    );
    let selectedIdsGroup5 = GetSelectedIDsFromListWithSpace(
      "formatingClassName5"
    );
    entriesObject.FormattingOptions =
      selectedIdsGroup1 +
      selectedIdsGroup2 +
      selectedIdsGroup3 +
      selectedIdsGroup4 +
      selectedIdsGroup5;

    if (
      entriesObject.QuestionType == 1 ||
      entriesObject.QuestionType == 2 ||
      entriesObject.QuestionType == 4
    ) {
      entriesObject.NumberOfTargets = 1;
      entriesObject.IsShowTargetSN = false;
      entriesObject.IsShowTextTarget = false;
      entriesObject.IsShowActualNotes = false;
      if (entriesObject.QuestionType == 1 || entriesObject.QuestionType == 2) {
        //entriesObject.IsShowHeader = true;
        //entriesObject.DataLevelType = 1;
        entriesObject.Actual1Title = "Actual";
        entriesObject.Actual1PassPercentage = 100;
        entriesObject.Actual2Title = "Actual 2";
        entriesObject.Actual2PassPercentage = 100;
      }
    } else if (entriesObject.QuestionType == 3) {
      entriesObject.TargetValueFormat = 3;
      entriesObject.LinkTargetTo = 1;
      entriesObject.IsHideActual = false;
      entriesObject.ActualValueFormat = 3;
      entriesObject.LinkActualTo = 1;
      entriesObject.IsDisplayPercentage = false;
      entriesObject.IsShowHeader = true;
      entriesObject.DataLevelType = 1;
      entriesObject.Actual1Title = "Actual";
      entriesObject.Actual1PassPercentage = 0;
      entriesObject.Actual2Title = "Actual";
      entriesObject.Actual2PassPercentage = 0;
    }

    IBBProgramCriteriaSave();
  }

  function MainTopFiltersCallBack(p_selectedId: any) {}

  function resetObjects(Type: number) {
    setEntriesObject({
      PID: 0,
      SectionID: 0,
      ParentID: 0,
      Title: "",
      Description: "2",
      SerialNumber: "",
      IsInputLevel: false,
      FormattingOptions: "",
      SplitPercentage: 0,
      IBBProgramCriteriaQuestionID: 0,
      Name: "",
      NumberOfTargets: 0,
      IsShowTargetSN: false,
      IsShowTextTarget: false,
      IsShowActualNotes: false,
      QuestionType: 0,
      TargetValueFormat: 0,
      LinkTargetTo: 0,
      IsHideActual: false,
      ActualValueFormat: 0,
      LinkActualTo: 0,
      IsDisplayPercentage: false,
      IsShowHeader: true,
      DataLevelType: 1,
      IsDoubleActual: false,
      Actual1Title: "",
      Actual1PassPercentage: 0,
      Actual2Title: "",
      Actual2PassPercentage: 0,
    });

    setReEarnableObject({
      SectionID: 0,
      IBBDepartmentID: 0,
      Title: "",
      ShortTitle: "",
      Description: "",
      Type: Type,
      Value: 0,
      ValueDescription: "",
      PTOrderBy: 0,
      ExtraTextField1: "",
      ExtraTextField2: "",
    });
  }

  function assignprogramCriteriaQuestionData(PID: number) {
    let filtered = programCriteriaQuestionData.filter(
      (item: any) => item.ParentID == PID
    );
    if (filtered.length > 0) {
      entriesObject.IBBProgramCriteriaQuestionID =
        filtered[0].IBBProgramCriteriaQuestionID;
      entriesObject.Name = filtered[0].Name;
      entriesObject.QuestionType = filtered[0].QuestionType;
      entriesObject.TargetValueFormat = filtered[0].TargetValueFormat;
      entriesObject.LinkTargetTo = filtered[0].LinkTargetTo;
      entriesObject.IsHideActual = filtered[0].IsHideActual;
      entriesObject.ActualValueFormat = filtered[0].ActualValueFormat;
      entriesObject.LinkActualTo = filtered[0].LinkActualTo;
      entriesObject.IsDisplayPercentage = filtered[0].IsDisplayPercentage;
      entriesObject.NumberOfTargets = filtered[0].NumberOfTargets;
      entriesObject.IsShowTargetSN = filtered[0].IsShowTargetSN;
      entriesObject.IsShowTextTarget = filtered[0].IsShowTextTarget;
      entriesObject.IsShowActualNotes = filtered[0].IsShowActualNotes;
      entriesObject.IsShowHeader = filtered[0].IsShowHeader;
      entriesObject.DataLevelType = filtered[0].DataLevelType;
      entriesObject.Actual1Title = filtered[0].Actual1Title;
      entriesObject.Actual1PassPercentage = filtered[0].Actual1PassPercentage;
      entriesObject.Actual2Title = filtered[0].Actual2Title;
      entriesObject.Actual2PassPercentage = filtered[0].Actual2PassPercentage;
    }
  }

  function checkGatewaysStatus() {
    let isAllGatewaysPassed = true;
    let filteredGateWays = sectionsList.filter((item: any) => item.Type == 1);
    if (filteredGateWays.length > 0) {
      let filteredGateWaysCriterias = programCriteriaData.filter(
        (item: any) => item.SectionID == filteredGateWays[0].SectionID
      );
      for (let i = 0; i < filteredGateWaysCriterias.length; i++) {
        let filteredData = programCriteriaQuestionData.filter(
          (item: any) => item.ParentID == filteredGateWaysCriterias[i].PID
        );
        let isCriteriaPassed = "";
        for (let j = 0; j < filteredData.length; j++) {
          isCriteriaPassed = filteredData[j].IsTargetAchieved;
          if (isCriteriaPassed != "1") isAllGatewaysPassed = false;
          if (isCriteriaPassed == "") {
            break;
          }
        }
        filteredGateWaysCriterias[i].isCriteriaPassed = isCriteriaPassed;

        if (filteredGateWaysCriterias[i].ParentID > 0) {
          let indexOfParent = -1;
          let isCriteriaPassed = "";
          for (let j = 0; j < filteredGateWaysCriterias.length; j++) {
            if (
              filteredGateWaysCriterias[j].PID ==
              filteredGateWaysCriterias[i].ParentID
            ) {
              indexOfParent = j;
            }
            if (
              filteredGateWaysCriterias[j].ParentID ==
              filteredGateWaysCriterias[i].ParentID
            ) {
              isCriteriaPassed = filteredGateWaysCriterias[j].isCriteriaPassed;
              if (isCriteriaPassed != "1") {
                break;
              }
            }
          }
          if (indexOfParent > -1)
            filteredGateWaysCriterias[indexOfParent].isCriteriaPassed =
              isCriteriaPassed;
        }
      }

      if (filteredGateWaysCriterias.length > 0) {
        filteredGateWaysCriterias[0].isAllGatewaysPassed = isAllGatewaysPassed;
      }
      filteredGateWaysCriterias = filteredGateWaysCriterias.filter(
        (item: any) => item.ParentID == 0
      );
      let gatewaysListLocal = [...gatewaysList];
      gatewaysListLocal = filteredGateWaysCriterias;
      setGatewaysList(gatewaysListLocal);
    }
  }

  function expandPreviouslyExpandedSections(sectionsListParam: any) {
    if (sectionsList.length == sectionsListParam.length) {
      for (let i = 0; i < sectionsList.length; i++) {
        sectionsListParam[i].IsAccordianOpened =
          sectionsList[i].IsAccordianOpened;
      }
    }
    return sectionsListParam;
  }

  function checkIsAllSectionsExpanded() {
    let isAllSectionsExpanded = true;
    for (let i = 0; i < sectionsList.length; i++) {
      if (!sectionsList[i].IsAccordianOpened) {
        isAllSectionsExpanded = false;
        break;
      }
    }
  }

  function expandCollapseSections() {
    let sectionsListLocal = [...sectionsList];
    for (let i = 0; i < sectionsListLocal.length; i++) {
      sectionsListLocal[i].IsAccordianOpened = !isAllSectionsExpanded;
    }
    setIsAllSectionsExpanded(!isAllSectionsExpanded);
    setSectionsList(sectionsListLocal);
  }

  function assignExceptionDataToObject(
    section: any,
    programCriteriaItem: any,
    programCriteriaQuestionDataItem: any
  ) {
    let exceptionObjectLocal = {} as any;
    exceptionObjectLocal.IBBProgramCriteriaQuestionInputExceptionID =
      programCriteriaQuestionDataItem?.ExceptionData?.IBBProgramCriteriaQuestionInputExceptionID;

    let criteriaPercentage = section.Value;
    if (section.ExtraTextField1 == 0) {
      //MM:: All Or Nothing
      criteriaPercentage = programCriteriaItem.SplitPercentage;
      //(section.Value / 100.0) * programCriteriaItem.SplitPercentage;
    }
    if (
      exceptionObjectLocal.IBBProgramCriteriaQuestionInputExceptionID ==
        undefined ||
      exceptionObjectLocal.IBBProgramCriteriaQuestionInputExceptionID == 0
    ) {
      //exceptionObjectLocal={} as any;
      exceptionObjectLocal.IBBProgramCriteriaQuestionInputID =
        programCriteriaQuestionDataItem.IBBProgramCriteriaQuestionInputID;
      exceptionObjectLocal.Name = programCriteriaItem.Title;
      exceptionObjectLocal.Description = programCriteriaQuestionDataItem.PID;
      exceptionObjectLocal.Status = 0;
      exceptionObjectLocal.UpdatedStatus = 0;
      exceptionObjectLocal.FinancialValue = 0;
      if (scorecardData.POT > 0) {
        exceptionObjectLocal.FinancialValue =
          (scorecardData.POT / scorecardData.ReearnablePercentage) *
          criteriaPercentage;
      }
      setAddException(true);
    } else {
      exceptionObjectLocal = programCriteriaQuestionDataItem.ExceptionData;
      exceptionObjectLocal.FinancialValue = 0;
      if (scorecardData.POT > 0) {
        exceptionObjectLocal.FinancialValue =
          (scorecardData.POT / scorecardData.ReearnablePercentage) *
          criteriaPercentage;
      }

      dragDropFeatures.PTUploadedFiles = [];
      setDragDropFeatures((prevState: any) => ({
        ...prevState,
        PTUploadedFiles: [],
      }));

      getAttachmentDataForObjectTypeAndObjectID(
        dragDropFeatures.ObjectType,
        programCriteriaQuestionDataItem.IBBProgramCriteriaQuestionInputID,
        -1
      );
    }
    setExceptionObject(exceptionObjectLocal);
  }

  function InputMaskOnChangeHandler(e: any) {
    updateValueOfInputKey(e.ColumnNames, removeNonNumeric(e.Value), e.PID);
  }

  function InputMaskOnBlurHandler(e: any) {
    updateRecord(e.ColumnNames, e.Value, e.PID);
  }

  function updateRecord(ColumnNames: any, Value: any, PID: any) {
    let filtered = programCriteriaQuestionData.filter(
      (item: any) => item.PID == PID
    );
    if (filtered.length > 0) {
      saveInputData(filtered[0]);
    }
  }

  //Dragdrop starts

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: 101,
    MaxAllowedFiles: 5,
    UploadType: 1,
    FolderName: "IBB-Scorecard-Exceptions-Data",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState<any>([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [showDragdrop, setShowDragdrop] = useState(true);

  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpFileURL, setPopUpFileURL] = useState("");

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  function showPopUpForSaveFiles() {
    //if (uploadFileList && uploadFileList.length > 0)
    SaveFiles();
    //else alert("Please select file to upload.");
  }

  function SaveFiles() {
    let uploadFileListArray = [];
    for (let index = 0; index < uploadFileList.length; index++) {
      if (!uploadFileList[index].AlreadyUploaded) {
        uploadFileListArray.push(uploadFileList[index]);
      }
    }

    if (uploadFileListArray && uploadFileListArray.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeatures.ObjectType;
      object.objectid = exceptionObject.IBBProgramCriteriaQuestionInputID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileListArray;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            let l_response = response.data.Data;

            let uploadFileArray = [];
            for (let index = 0; index < uploadFileList.length; index++) {
              if (uploadFileList[index].AlreadyUploaded) {
                uploadFileArray.push(uploadFileList[index]);
              }
            }
            for (let index = 0; index < l_response.length; index++) {
              uploadFileArray.push(l_response[index]);
            }

            saveAttachmentDataForObjectTypeIDObjectID(uploadFileArray);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      saveAttachmentDataForObjectTypeIDObjectID(uploadFileList);
    }
  }

  //Dragdrop ends

  function saveAttachmentDataForObjectTypeIDObjectID(uploadedFileList: any) {
    let object = {} as any;
    object.objecttype = dragDropFeatures.ObjectType;
    object.objectid = exceptionObject.IBBProgramCriteriaQuestionInputID;
    object.typeid = -1;
    object.filesdata = uploadedFileList;
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PTAttachment/SaveAttachmentDataForObjectTypeIDObjectID",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          //console.log("log", response.data.Message);
        } else {
          console.error("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getAttachmentDataForObjectTypeAndObjectID(
    objecttype: any,
    objectid: any,
    typeid: any
  ) {
    let object = {} as any;
    object.objecttype = objecttype;
    object.objectid = objectid;
    object.typeid = typeid;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PTAttachment/GetAttachmentDataForObjectTypeAndObjectID",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          dragDropFeatures.PTUploadedFiles = [];
          let gridData = response.data.Data;
          let attachments = [] as any;
          if (gridData && gridData[0] && gridData[0].length > 0) {
            for (let i = 0; i < gridData[0].length; i++) {
              attachments.push({
                ObjectID: gridData[0][i].ObjectID,
                Name: gridData[0][i].Name,
                FileURLDisplay: AppContext.GetFileIconToDisplay(
                  gridData[0][i].FileURLRaw
                ),
                FileURL: gridData[0][i].FileURLRaw,
                AlreadyUploaded: true,
                S3Path: gridData[0][i].S3Path,
                Identifier: gridData[0][i].Identifier,
                Title: gridData[0][i].Title,
                Tags: gridData[0][i].Tags,
              });
            }
          }
          dragDropFeatures.PTUploadedFiles = attachments;
          setDragDropFeatures((prevState: any) => ({
            ...prevState,
            PTUploadedFiles: attachments,
          }));
        } else {
          console.error("error", response.data.Message);
        }
        setAddException(true);
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function isThisChecked(formattingOptions: any, className: any) {
    if (formattingOptions != undefined && formattingOptions != "") {
      let ids = formattingOptions.split(" ");
      let bool = false;
      for (let index = 0; index < ids.length; index++) {
        if (ids[index] == className) {
          bool = true;
          break;
        }
      }

      return bool;
    }
    return false;
  }

  function selectOnlyOne(group: number, id: any, index: any) {
    if (group == 1) {
      for (let i = 0; i < formattingOptionsArray1.length; i++) {
        let element = document.getElementById(id + i) as any;
        if (index != i) {
          element.checked = false;
        } else {
          // element.checked = !element.checked;
        }
      }
    }
    if (group == 2) {
      for (let i = 0; i < formattingOptionsArray2.length; i++) {
        let element = document.getElementById(id + i) as any;
        if (index != i) {
          element.checked = false;
        } else {
          //element.checked = !element.checked;
        }
      }
    }
    if (group == 3) {
      for (let i = 0; i < formattingOptionsArray3.length; i++) {
        let element = document.getElementById(id + i) as any;
        if (index != i) {
          element.checked = false;
        } else {
          // element.checked = !element.checked;
        }
      }
    }
    if (group == 4) {
      for (let i = 0; i < formattingOptionsArray4.length; i++) {
        let element = document.getElementById(id + i) as any;
        if (index != i) {
          element.checked = false;
        } else {
          //element.checked = !element.checked;
        }
      }
    }
    if (group == 5) {
      for (let i = 0; i < formattingOptionsArray5.length; i++) {
        let element = document.getElementById(id + i) as any;
        if (index != i) {
          element.checked = false;
        } else {
          //element.checked = !element.checked;
        }
      }
    }
  }

  function hideDivAndShowInput(divID: any, inputID: any) {
    let divElement: any = document.getElementById(divID);
    let inputElement: any = document.getElementById(inputID);

    if (divElement) {
      divElement.style.display = "none";
    }

    if (inputElement) {
      inputElement.addEventListener("focusin", function (event: any) {});
    }
  }

  function displayDiv(divID: any) {
    let divElement: any = document.getElementById(divID);
    if (divElement) {
      divElement.style.display = "";
    }
  }

  function setShowRetailerLevelData(programCriteriaQuestionDataItem: any) {
    let showRetailerLevelDataIDsLocal = [...showRetailerLevelDataIDs];
    let index = showRetailerLevelDataIDsLocal.indexOf(
      programCriteriaQuestionDataItem.IBBProgramCriteriaQuestionID
    );
    if (index > -1) {
      showRetailerLevelDataIDsLocal.splice(index, 1);
    } else {
      showRetailerLevelDataIDsLocal.push(
        programCriteriaQuestionDataItem.IBBProgramCriteriaQuestionID
      );
    }
    setShowRetailerLevelDataIDs(showRetailerLevelDataIDsLocal);
  }

  function getShowRetailerLevelData(IBBProgramCriteriaQuestionID: any) {
    let showRetailerLevelDataIDsLocal = [...showRetailerLevelDataIDs];
    let index = showRetailerLevelDataIDsLocal.indexOf(
      IBBProgramCriteriaQuestionID
    );
    return index;
  }

  const [exceptionsData, setExceptionsData] = useState<any>([]);
  const [exceptionsDocuments, setExceptionsDocuments] = useState<any>([]);

  //MM:: Approval related data
  const [requiredApprovalUser, setRequiredApprovalUser] = useState([]) as any;

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  const [conditionModal, setConditionModal] = useState(false);
  const [conditionData, setConditionData] = useState<any>({});

  function IBBProgramCriteriaQuestionInputExceptionGetDataForApproval() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = scorecardFilter.ProgramID;
    object.quarterid = scorecardFilter.QuarterID;
    object.ibbscorecardid = scorecardFilter.IBBScorecardID;
    object.pfigroupids = "0";
    object.exceptionstatusid = -1;
    object.exceptionid = -1;
    object.ibbprogramstageid = 10;
    object.ibbprogramsectionid = 0;
    //setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramCriteriaQuestionInputException/IBBProgramCriteriaQuestionInputExceptionGetDataForApproval",
        object
      )
      .then((response) => {
        //setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;

          if (result.length > 2) {
            let exceptionsDataLocal = [];
            var filtered = result[0].filter((item: any) => item.Type == 1);
            if (filtered.length > 0)
              exceptionsDataLocal.push({
                SectionTypeName: "GATEWAY EXCEPTIONS",
                Data: filtered,
              });

            var filtered = result[0].filter((item: any) => item.Type == 2);
            if (filtered.length > 0)
              exceptionsDataLocal.push({
                SectionTypeName: "CRITERIA EXCEPTIONS",
                Data: filtered,
              });
            setExceptionsData(exceptionsDataLocal);
            setExceptionsDocuments(result[1]);
            setRequiredApprovalUser(result[2]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBConditionSaveCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbconditionid = conditionData.IBBConditionID;
    object.ibbscorecardid = conditionData.IBBScorecardID;
    object.ibbprogramcriteriaquestioninputexceptionid =
      conditionData.IBBProgramCriteriaQuestionInputExceptionID;
    object.name = conditionData.Name;
    object.name = conditionData.Deadline;
    object.conditiontext = conditionData.ConditionText;
    object.amount = conditionData.Amount;
    object.status = conditionData.Status;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBCondition/IBBConditionSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          setConditionModal(false);
          IBBProgramCriteriaQuestionInputExceptionGetDataForApproval();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBConditionDeleteRecordCustom(IBBConditionID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbconditionid = IBBConditionID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBCondition/IBBConditionDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBProgramCriteriaQuestionInputExceptionGetDataForApproval();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function triggerApprovalParent() {
    IBBProgramCriteriaQuestionInputExceptionGetDataForApproval();
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBProgramCriteriaDeleteRecord(obj.SelectedID);
      }
    }
    if (obj.ID === 101) {
      if (obj.isConfirm === true) {
        IBBConditionDeleteRecordCustom(obj.SelectedID);
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
    });
  }

  function GetClassNameForColorValue(p_intSectionID: any) {
    if (scorecardData.Status >= 5) {
      for (let index = 0; index < scorecardSectionData.length; index++) {
        var element: any = scorecardSectionData[index];

        if (element.IBBProgramSectionID == p_intSectionID) {
          if (element.PercentageAchievedActual > 0) {
            return "sc-g-b";
          } else if (
            element.ExceptionPercentage == 0 ||
            (element.ExceptionPercentage > 0 &&
              element.PercentageAchieved == 0 &&
              ((element.ConditionalHoldPercentageAchieved == 0 &&
                element.ConditionalHoldStatus != -1) ||
                element.ConditionalHoldPercentage == 0))
          )
            return "sc-r-b";
          else if (
            element.PercentageAchievedActual == 0 &&
            element.ExceptionPercentage > 0
          ) {
            return "sc-y-b";
          } else return "";
        }
      }
    }
    return "";
  }

  function AddHandToValue(p_intSectionID: any) {
    if (scorecardData.Status >= 5) {
      for (let index = 0; index < scorecardSectionData.length; index++) {
        var element: any = scorecardSectionData[index];
        if (element.IBBProgramSectionID == p_intSectionID) {
          if (element.ConditionalHoldPercentage > 0) {
            return true;
          } else return false;
        }
      }
    }
    return false;
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}

      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />
      <div className="page--contents">
        <div className="page--breadcrumb justify-btw">
          <a>scorecards</a>
          <a
            href={programData.Description}
            target="_blank"
            title="Click To Download Program Policy Document"
          >
            Program Policy Document{" "}
            <img src="/images/pdf.svg" width={25} height={30} alt="Documnet" />
          </a>
        </div>
        <div
          className={`${
            ShowEditMode ? "page--data pb-0" : "page--data view-mode pb-0"
          }`}
        >
          {globalState.ManageAdmin && (
            <div className="flex-container">
              {ShowEditModeActual && <b>{programData.Name}</b>}
              {!ShowEditModeActual && <span></span>}
              {ShowEditModeActual && (
                <div className="flex-btns">
                  <a
                    onClick={ShowEditControls}
                    className={`${ShowEditMode ? "btn-selected" : ""}`}
                  >
                    Edit
                  </a>
                  <a
                    onClick={HideEditControls}
                    className={`${ShowEditMode ? "" : "btn-selected"}`}
                  >
                    Preview
                  </a>
                </div>
              )}
            </div>
          )}

          {!ShowEditModeActual && (
            <>
              <div className="flex-container">
                <div style={{ width: "33.33%" }}>
                  <select
                    className="select-md"
                    value={scorecardFilter.ProgramID}
                    onChange={(e) => {
                      setScorecardFilter((prevState: any) => ({
                        ...prevState,
                        ProgramID: Number(e.target.value),
                        QuarterID: 0,
                        IBBScorecardID: 0,
                      }));
                      globalState.setTopFilterData((prevState: any) => ({
                        ...prevState,
                        IBBProgramID: Number(e.target.value),
                        QuarterID: 0,
                      }));
                      IBBProgramGetProgramListForScorecard(
                        Number(e.target.value),
                        0,
                        0,
                        0
                      );
                    }}
                  >
                    {programList &&
                      programList.map((Item: any, index: any) => (
                        <option value={Item.PID} key={"program" + Item.PID}>
                          {Item.Name}
                        </option>
                      ))}
                  </select>

                  <select
                    style={{ marginLeft: 5 }}
                    className="select-md"
                    value={scorecardFilter.QuarterID}
                    onChange={(e) => {
                      setScorecardFilter((prevState: any) => ({
                        ...prevState,
                        QuarterID: Number(e.target.value),
                        IBBScorecardID: 0,
                      }));
                      globalState.setTopFilterData((prevState: any) => ({
                        ...prevState,
                        QuarterID: Number(e.target.value),
                        IBBScorecardID: 0,
                      }));
                    }}
                  >
                    {quarterList &&
                      quarterList.map((Item: any, index: any) => (
                        <option value={Item.PID} key={"quarter" + Item.PID}>
                          {Item.Name}
                        </option>
                      ))}
                  </select>
                </div>
                {globalState.AppAccessLevelData.DID == 0 && (
                  <div>
                    <select
                      className="select-lg"
                      value={scorecardFilter.IBBScorecardID}
                      onChange={(e) => {
                        setScorecardFilter((prevState: any) => ({
                          ...prevState,
                          IBBScorecardID: Number(e.target.value),
                        }));
                        globalState.setTopFilterData((prevState: any) => ({
                          ...prevState,
                          IBBScorecardID: Number(e.target.value),
                        }));
                      }}
                    >
                      {importerList &&
                        importerList.map((Item: any, index: any) => (
                          <option value={Item.PID} key={"importer" + Item.PID}>
                            {Item.Name}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
                <span style={{ width: "33.33%" }}></span>
              </div>

              <div className="flex-container wrap-container">
                {globalState.AppAccessLevelData.DID == 0 && (
                  <div className="re-earn">
                    <span className="re-val1">CRITERIA %</span>
                    <span className="re-val2">
                      {Number(
                        scorecardData.ReearnablePercentage
                      )?.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                      %
                    </span>
                  </div>
                )}

                {globalState.AppAccessLevelData.DID > 0 && <div></div>}
                {((getAccessSettings(2, 26) > 0 &&
                  globalState.AppAccessLevelData.DID > 0) ||
                  globalState.AppAccessLevelData.DID == 0) &&
                  (scorecardData.Status >= 5 ||
                    globalState.AppAccessLevelData.DID == 0) && (
                    <div className="pot-fp fix-width-boxes">
                      <div className="re-earn">
                        <span className="re-val1">
                          <span>
                            Fund Available
                            {scorecardData.CurrencyID > 1 ? (
                              <>
                                <a
                                  className="usd-eu"
                                  onClick={() => {
                                    setScorecardFilter((prevState: any) => ({
                                      ...prevState,
                                      ShowInLC: !scorecardFilter.ShowInLC,
                                    }));
                                  }}
                                >
                                  {!scorecardFilter.ShowInLC ? (
                                    <>
                                      {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                        scorecardData.CurrencyID
                                      )}
                                    </>
                                  ) : (
                                    <>$</>
                                  )}
                                </a>
                              </>
                            ) : (
                              ""
                            )}
                          </span>{" "}
                          {/* <img src="images/eye.svg" width="20px" height="14px" /> */}
                        </span>
                        <span className="re-val2">
                          {scorecardFilter.ShowInLC ? (
                            <>
                              {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                scorecardData.CurrencyID
                              )}
                            </>
                          ) : (
                            <>$</>
                          )}

                          {Number(scorecardData.POT)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                      {scorecardSectionData &&
                        scorecardSectionData.map((item: any, index: any) => (
                          <React.Fragment key={"sectioncalcdatatotal" + index}>
                            {((item.IBBProgramSectionID == 10000004 &&
                              !scorecardFilter.ShowInLC) ||
                              (item.IBBProgramSectionID == 10000007 &&
                                scorecardFilter.ShowInLC)) && (
                              <div className="pot-fp fix-width-boxes">
                                <div className="boxes-fr-1">
                                  <div
                                    className={`boxes-fr-4 ${
                                      scorecardData.Status >= 5 &&
                                      scorecardData.Status < 8 &&
                                      globalState.AppAccessLevelData.DID > 0
                                        ? "boxes-fr-2-check"
                                        : ""
                                    }`}
                                  >
                                    <div className="re-earn">
                                      <span className="re-val1">
                                        {scorecardFilter.ShowInLC ? (
                                          <>
                                            {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                              scorecardData.CurrencyID
                                            )}
                                          </>
                                        ) : (
                                          <>$</>
                                        )}{" "}
                                        INITIAL ACHIEVEMENT
                                      </span>
                                      <span className="re-val2">
                                        {scorecardFilter.ShowInLC ? (
                                          <>
                                            {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                              scorecardData.CurrencyID
                                            )}
                                          </>
                                        ) : (
                                          <>$</>
                                        )}
                                        {item.USDAchievedActual?.toLocaleString(
                                          undefined,
                                          {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0,
                                          }
                                        )}
                                      </span>
                                    </div>

                                    {(scorecardData.Status >= 8 ||
                                      globalState.AppAccessLevelData.DID ==
                                        0) && (
                                      <>
                                        <div className="re-earn">
                                          <span className="re-val1">
                                            {scorecardFilter.ShowInLC ? (
                                              <>
                                                {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                  scorecardData.CurrencyID
                                                )}
                                              </>
                                            ) : (
                                              <>$</>
                                            )}{" "}
                                            Exception
                                          </span>
                                          <span className="re-val2">
                                            {scorecardFilter.ShowInLC ? (
                                              <>
                                                {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                  scorecardData.CurrencyID
                                                )}
                                              </>
                                            ) : (
                                              <>$</>
                                            )}
                                            {item.ExceptionInUSDActual?.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                              }
                                            )}
                                          </span>
                                        </div>
                                        <div className="re-earn">
                                          <span className="re-val1">
                                            {scorecardFilter.ShowInLC ? (
                                              <>
                                                {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                  scorecardData.CurrencyID
                                                )}
                                              </>
                                            ) : (
                                              <>$</>
                                            )}{" "}
                                            Conditional Hold
                                          </span>
                                          <span className="re-val2">
                                            {scorecardFilter.ShowInLC ? (
                                              <>
                                                {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                  scorecardData.CurrencyID
                                                )}
                                              </>
                                            ) : (
                                              <>$</>
                                            )}
                                            {item.ConditionalHoldInUSDActual?.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                              }
                                            )}
                                          </span>
                                        </div>
                                        <div className="re-earn">
                                          <span className="re-val1">
                                            {scorecardFilter.ShowInLC ? (
                                              <>
                                                {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                  scorecardData.CurrencyID
                                                )}
                                              </>
                                            ) : (
                                              <>$</>
                                            )}{" "}
                                            FINAL ACHIEVEMENT
                                          </span>
                                          <span className="re-val2">
                                            {scorecardFilter.ShowInLC ? (
                                              <>
                                                {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                  scorecardData.CurrencyID
                                                )}
                                              </>
                                            ) : (
                                              <>$</>
                                            )}
                                            {item.USDAchieved?.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                              }
                                            )}
                                          </span>
                                        </div>
                                      </>
                                    )}

                                    <div className="re-earn">
                                      <span className="re-val1">
                                        % INITIAL ACHIEVEMENT
                                      </span>
                                      <span className="re-val2">
                                        {item.PercentageAchievedActual?.toLocaleString(
                                          undefined,
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }
                                        )}
                                        %
                                      </span>
                                    </div>

                                    {(scorecardData.Status >= 8 ||
                                      globalState.AppAccessLevelData.DID ==
                                        0) && (
                                      <>
                                        <div className="re-earn">
                                          <span className="re-val1">
                                            % Exception
                                          </span>
                                          <span className="re-val2">
                                            {item.ExceptionPercentageActual?.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }
                                            )}
                                            %
                                          </span>
                                        </div>
                                        <div className="re-earn">
                                          <span className="re-val1">
                                            % Conditional Hold
                                          </span>
                                          <span className="re-val2">
                                            {item.ConditionalHoldPercentageActual?.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }
                                            )}
                                            %
                                          </span>
                                        </div>
                                        <div className="re-earn">
                                          <span className="re-val1">
                                            % Final Achievement
                                          </span>
                                          <span className="re-val2">
                                            {item.PercentageAchieved?.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }
                                            )}
                                            %
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </React.Fragment>
                        ))}

                      {(scorecardData.Status >= 10 ||
                        globalState.AppAccessLevelData.DID == 0) && (
                        <>
                          <div className="">
                            <DonutChart
                              data={[
                                {
                                  name: "Achieved",
                                  value:
                                    scorecardData.FinalPayoutPercentage?.toLocaleString(
                                      undefined,
                                      { minimumFractionDigits: 2 }
                                    ),
                                  color: "#98cb4a",
                                },
                                {
                                  name: "Not Achieved",
                                  value:
                                    100 -
                                    Number(scorecardData.FinalPayoutPercentage),
                                  color: "#f5f5f5",
                                },
                              ]}
                              totalValueToPrint={
                                scorecardData.FinalPayoutPercentage?.toLocaleString(
                                  undefined,
                                  { minimumFractionDigits: 2 }
                                ) + "%"
                              }
                              showTextOnGraph={0}
                              innerRadius={1.2}
                            ></DonutChart>
                          </div>
                          <div className="re-earn">
                            <span className="re-val1">
                              Quarter Result
                              {scorecardData.CurrencyID > 1 ? (
                                <>
                                  <a
                                    className="usd-eu"
                                    onClick={() => {
                                      setScorecardFilter((prevState: any) => ({
                                        ...prevState,
                                        ShowInLC: !scorecardFilter.ShowInLC,
                                      }));
                                    }}
                                  >
                                    {!scorecardFilter.ShowInLC ? (
                                      <>
                                        {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                          scorecardData.CurrencyID
                                        )}
                                      </>
                                    ) : (
                                      <>$</>
                                    )}
                                  </a>
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                            <span className="re-val2">
                              {scorecardFilter.ShowInLC ? (
                                <>
                                  {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                    scorecardData.CurrencyID
                                  )}
                                </>
                              ) : (
                                <>$</>
                              )}

                              {Number(
                                scorecardData.FinalPayout
                              )?.toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })}
                              {scorecardData.FinalPayout > 0 &&
                                ((getAccessSettings(2, 26) > 0 &&
                                  globalState.AppAccessLevelData.DID > 0) ||
                                  globalState.AppAccessLevelData.DID == 0) && (
                                  <>
                                    <a
                                      className="earn-eye"
                                      title="Add/View Invoices"
                                      href={
                                        "invoicesdata?pid=" +
                                        scorecardFilter.ProgramID +
                                        "&qid=" +
                                        scorecardFilter.QuarterID +
                                        "&scid=" +
                                        scorecardFilter.IBBScorecardID
                                      }
                                    >
                                      <img
                                        src="images/invoice.svg"
                                        width={20}
                                        height={20}
                                      />
                                    </a>
                                  </>
                                )}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                <div
                  className={`re-earn ${
                    scorecardData.Status == 1
                      ? ""
                      : scorecardData.Status == 2
                      ? ""
                      : ""
                  }`}
                >
                  <span className="re-val1">Status</span>
                  <span className="re-val2">{scorecardData.StatusText}</span>
                </div>
              </div>
            </>
          )}

          {sectionsList && sectionsList.length > 0 && (
            <div className="expand-all">
              {!isAllSectionsExpanded && (
                <a onClick={expandCollapseSections}>Expand All</a>
              )}
              {isAllSectionsExpanded && (
                <a onClick={expandCollapseSections}>Collapse All</a>
              )}
            </div>
          )}

          {programData.Status == 0 &&
            ShowEditMode &&
            sectionsList &&
            ((sectionsList.length > 0 && sectionsList[0].Type != 1) ||
              sectionsList.length == 0) && (
              <div
                className="re-earnable"
                style={{ float: "right", marginLeft: 10, marginBottom: 10 }}
              >
                <a
                  onClick={() => {
                    resetObjects(1);
                    setReEarnableModal(true);
                  }}
                >
                  Add Gateway
                </a>
              </div>
            )}

          {sectionsList &&
            sectionsList.length > 0 &&
            sectionsList[0].Type == 1 &&
            sectionsList.map((section: any, indexSection: any) => (
              <React.Fragment key={"GW" + indexSection}>
                {indexSection == 0 && section.Type == 1 && (
                  <>
                    <div
                      className={`gate-ways-tab ${
                        section.IsAccordianOpened ? "" : "gate-way-bot"
                      }`}
                    >
                      <div
                        className="tab-title-g tab-title-gsm"
                        onClick={() => {
                          let sectionsListLocal = [...sectionsList];
                          sectionsListLocal[indexSection].IsAccordianOpened =
                            !sectionsListLocal[indexSection].IsAccordianOpened;
                          setSectionsList(sectionsListLocal);
                        }}
                      >
                        {section.Title}
                      </div>
                      <div
                        className="tab-g-boxes"
                        onClick={() => {
                          let sectionsListLocal = [...sectionsList];
                          sectionsListLocal[indexSection].IsAccordianOpened =
                            !sectionsListLocal[indexSection].IsAccordianOpened;
                          setSectionsList(sectionsListLocal);
                        }}
                      >
                        {gatewaysList &&
                          gatewaysList.map(
                            (gateway: any, indexgateway: any) => (
                              <React.Fragment key={"GWC" + indexgateway}>
                                <span
                                  className={`${
                                    gateway.isCriteriaPassed == "1"
                                      ? "b-g"
                                      : gateway.isCriteriaPassed == "0"
                                      ? "b-r"
                                      : ""
                                  }`}
                                ></span>
                              </React.Fragment>
                            )
                          )}
                      </div>
                      <div className="tab-g-exceptions">
                        {!ShowEditMode && (
                          <div className="excp-left">
                            <div className="excp-1">
                              <img
                                src="images/excp.svg"
                                width="24px"
                                height="24px"
                              />
                              <span>Exceptions</span>
                            </div>
                            <div className="excp-2">
                              <span className="e-y">
                                {section.exceptionCount &&
                                  section.exceptionCount[0] > 0 && (
                                    <>{section.exceptionCount[0]}</>
                                  )}
                              </span>
                              <span className="e-g">
                                {section.exceptionCount &&
                                  section.exceptionCount[1] > 0 && (
                                    <>{section.exceptionCount[1]}</>
                                  )}
                              </span>
                              <span className="e-r">
                                {section.exceptionCount &&
                                  section.exceptionCount[2] > 0 && (
                                    <>{section.exceptionCount[2]}</>
                                  )}
                              </span>
                            </div>
                          </div>
                        )}
                        {ShowEditMode && (
                          <div className="g-buttons g-buttons2">
                            {/* <a title="Copy" onClick={() => setCopyModal(true)}>
                            <img
                              width="17px"
                              height="17px"
                              alt="Copy"
                              src="images/copy.svg"
                            />
                          </a> */}
                            <a
                              title="Add"
                              onClick={() => {
                                setEntriesModal(true);
                                let entriesObjectLocal = {} as any;
                                entriesObjectLocal.SectionID =
                                  section.SectionID;
                                entriesObjectLocal.ParentID = 0;
                                entriesObjectLocal.PID = 0;
                                entriesObjectLocal.Description = "2";
                                setEntriesObject(entriesObjectLocal);
                              }}
                            >
                              <img
                                width="17px"
                                height="17px"
                                alt="Add"
                                src="images/add.svg"
                              />
                            </a>
                          </div>
                        )}
                        <a
                          className="g-toggle-btn"
                          onClick={() => {
                            let sectionsListLocal = [...sectionsList];
                            sectionsListLocal[indexSection].IsAccordianOpened =
                              !sectionsListLocal[indexSection]
                                .IsAccordianOpened;
                            setSectionsList(sectionsListLocal);
                          }}
                        >
                          {section.IsAccordianOpened && (
                            <img
                              src="images/expand.svg"
                              className="rotate-180"
                              width="24px"
                              height="24px"
                            />
                          )}
                          {!section.IsAccordianOpened && (
                            <img
                              src="images/expand.svg"
                              width="24px"
                              height="24px"
                            />
                          )}
                        </a>
                      </div>
                    </div>
                    {section.IsAccordianOpened && (
                      <div className="g-accord">
                        {section.ChildData &&
                          section.ChildData.map(
                            (firstLevel: any, indexFirstLevel: any) => (
                              <React.Fragment
                                key={indexSection + "-" + firstLevel.PID}
                              >
                                <div
                                  className={`${
                                    ShowEditMode === true ? "hover-back" : ""
                                  }`}
                                >
                                  <div className="level-1">
                                    {firstLevel.programCriteriaQuestionData ==
                                      undefined ||
                                      (firstLevel.programCriteriaQuestionData
                                        .length == 0 && (
                                        <span
                                          className={
                                            "spn-alg " +
                                            firstLevel.FormattingOptions
                                          }
                                        >
                                          {firstLevel.SerialNumber !=
                                            undefined &&
                                            firstLevel.SerialNumber != "" && (
                                              <>{firstLevel.SerialNumber}-</>
                                            )}{" "}
                                          {firstLevel.Title}
                                        </span>
                                      ))}
                                    {/* <span></span> */}
                                    {ShowEditMode && (
                                      <div className="g-buttons">
                                        {/* <a title="Move Down">
                                    <img
                                      width="13px"
                                      height="13px"
                                      alt="Move Down"
                                      src="images/aw-down.svg"
                                    />
                                  </a>
                                  <a title="Move Up">
                                    <img
                                      width="13px"
                                      height="13px"
                                      alt="Move Up"
                                      src="images/aw-up.svg"
                                    />
                                  </a> */}
                                        <a
                                          title="Delete"
                                          // onClick={() =>
                                          //   IBBProgramCriteriaDeleteRecord(
                                          //     firstLevel.PID
                                          //   )
                                          // }
                                          onClick={() => {
                                            globalState.setConfirmationObject({
                                              ShowPopup: true,
                                              Heading: "Confirmation ",
                                              Message:
                                                "Are you sure you want to delete this record?",
                                              ID: 1,
                                              SelectedID: firstLevel.PID,
                                            });
                                          }}
                                        >
                                          <img
                                            width="17px"
                                            height="17px"
                                            alt="Delete"
                                            src="images/delete.svg"
                                          />
                                        </a>
                                        <a
                                          title="Edit"
                                          onClick={() => {
                                            setEntriesModal(true);
                                            entriesObject.SectionID =
                                              section.SectionID;
                                            entriesObject.ParentID =
                                              firstLevel.ParentID;
                                            entriesObject.Title =
                                              firstLevel.Title;
                                            entriesObject.Description =
                                              firstLevel.Description;
                                            entriesObject.SerialNumber =
                                              firstLevel.SerialNumber;
                                            entriesObject.PID = firstLevel.PID;
                                            entriesObject.IsInputLevel =
                                              firstLevel.IsInputLevel;
                                            entriesObject.FormattingOptions =
                                              firstLevel.FormattingOptions;
                                            entriesObject.SplitPercentage =
                                              firstLevel.SplitPercentage;
                                            assignprogramCriteriaQuestionData(
                                              entriesObject.PID
                                            );
                                          }}
                                        >
                                          <img
                                            width="17px"
                                            height="17px"
                                            alt="Edit"
                                            src="images/edit.svg"
                                          />
                                        </a>
                                        <a
                                          title="Add"
                                          onClick={() => {
                                            setEntriesModal(true);
                                            let entriesObjectLocal = {} as any;
                                            entriesObjectLocal.SectionID =
                                              section.SectionID;
                                            entriesObjectLocal.ParentID =
                                              firstLevel.PID;
                                            entriesObjectLocal.PID = 0;
                                            entriesObjectLocal.Description =
                                              "2";
                                            setEntriesObject(
                                              entriesObjectLocal
                                            );
                                          }}
                                        >
                                          <img
                                            width="17px"
                                            height="17px"
                                            alt="Add"
                                            src="images/add.svg"
                                          />
                                        </a>
                                      </div>
                                    )}
                                  </div>

                                  {firstLevel.programCriteriaQuestionData &&
                                    firstLevel.programCriteriaQuestionData.map(
                                      (
                                        programCriteriaQuestionDataItem: any,
                                        indexFirstLevelInput: any
                                      ) => (
                                        <React.Fragment
                                          key={
                                            indexSection +
                                            "-" +
                                            firstLevel.PID +
                                            "-" +
                                            programCriteriaQuestionDataItem.PID +
                                            "-" +
                                            indexFirstLevelInput
                                          }
                                        >
                                          <div className="level-1 t-01">
                                            {indexFirstLevelInput == 0 && (
                                              <span></span>
                                            )}
                                            {indexFirstLevelInput > 0 && (
                                              <span className="spn-alg"></span>
                                            )}
                                            <div className="t001">
                                              {!ShowEditMode && (
                                                <>
                                                  {programCriteriaQuestionDataItem
                                                    .ExceptionData
                                                    ?.ConditionText !=
                                                    undefined &&
                                                  programCriteriaQuestionDataItem
                                                    .ExceptionData
                                                    ?.ConditionText != "" ? (
                                                    <div className="g-buttons exp-trg">
                                                      {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                        "0" ||
                                                        programCriteriaQuestionDataItem
                                                          .ExceptionData
                                                          ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                          undefined) && (
                                                        <a
                                                          className={`${
                                                            programCriteriaQuestionDataItem
                                                              .ExceptionData
                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                            undefined
                                                              ? programCriteriaQuestionDataItem
                                                                  .ExceptionData
                                                                  ?.ConditionStatus ==
                                                                1
                                                                ? programCriteriaQuestionDataItem
                                                                    .ExceptionData
                                                                    ?.ConditionText !=
                                                                  ""
                                                                  ? "g-excep"
                                                                  : "g-excep"
                                                                : programCriteriaQuestionDataItem
                                                                    .ExceptionData
                                                                    ?.ConditionStatus ==
                                                                  2
                                                                ? "r-excep"
                                                                : "y-excep"
                                                              : ""
                                                          }`}
                                                          title={
                                                            programCriteriaQuestionDataItem
                                                              .ExceptionData
                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                            undefined
                                                              ? programCriteriaQuestionDataItem
                                                                  .ExceptionData
                                                                  ?.Status == 0
                                                                ? "Edit Exception"
                                                                : "View Exception"
                                                              : "Add Exception"
                                                          }
                                                          onClick={() => {
                                                            assignExceptionDataToObject(
                                                              section,
                                                              firstLevel,
                                                              programCriteriaQuestionDataItem
                                                            );
                                                          }}
                                                        >
                                                          <img
                                                            src="images/hold.svg"
                                                            width="17px"
                                                            height="17px"
                                                          />
                                                        </a>
                                                      )}
                                                    </div>
                                                  ) : (
                                                    <div className="g-buttons exp-trg">
                                                      {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                        "0" ||
                                                        programCriteriaQuestionDataItem
                                                          .ExceptionData
                                                          ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                          undefined) && (
                                                        <a
                                                          className={`${
                                                            programCriteriaQuestionDataItem
                                                              .ExceptionData
                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                            undefined
                                                              ? programCriteriaQuestionDataItem
                                                                  .ExceptionData
                                                                  ?.Status == 1
                                                                ? programCriteriaQuestionDataItem
                                                                    .ExceptionData
                                                                    ?.ConditionText !=
                                                                  ""
                                                                  ? "g-excep"
                                                                  : "g-excep"
                                                                : programCriteriaQuestionDataItem
                                                                    .ExceptionData
                                                                    ?.Status ==
                                                                  2
                                                                ? "r-excep"
                                                                : "y-excep"
                                                              : ""
                                                          }`}
                                                          title={
                                                            programCriteriaQuestionDataItem
                                                              .ExceptionData
                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                            undefined
                                                              ? programCriteriaQuestionDataItem
                                                                  .ExceptionData
                                                                  ?.Status == 0
                                                                ? "Edit Exception"
                                                                : "View Exception"
                                                              : "Add Exception"
                                                          }
                                                          onClick={() => {
                                                            assignExceptionDataToObject(
                                                              section,
                                                              firstLevel,
                                                              programCriteriaQuestionDataItem
                                                            );
                                                          }}
                                                        >
                                                          <img
                                                            src="images/exception.svg"
                                                            width="17px"
                                                            height="17px"
                                                          />
                                                        </a>
                                                      )}
                                                    </div>
                                                  )}
                                                </>
                                              )}
                                              {indexFirstLevelInput == 0 &&
                                                programCriteriaQuestionDataItem.QuestionType !=
                                                  3 && (
                                                  <span
                                                    className={
                                                      "spn-alg " +
                                                      firstLevel.FormattingOptions
                                                    }
                                                  >
                                                    {firstLevel.SerialNumber !=
                                                      undefined &&
                                                      firstLevel.SerialNumber !=
                                                        "" && (
                                                        <>
                                                          {
                                                            firstLevel.SerialNumber
                                                          }
                                                          -
                                                        </>
                                                      )}{" "}
                                                    {firstLevel.Title}
                                                  </span>
                                                )}

                                              {(programCriteriaQuestionDataItem.QuestionType ==
                                                2 ||
                                                programCriteriaQuestionDataItem.QuestionType ==
                                                  4 ||
                                                programCriteriaQuestionDataItem.QuestionType ==
                                                  3) && (
                                                <>
                                                  <div className="t-1 t-1-lg">
                                                    {indexFirstLevelInput ==
                                                      0 &&
                                                      programCriteriaQuestionDataItem.QuestionType ==
                                                        3 && (
                                                        <div className="t-2">
                                                          {firstLevel.SerialNumber !=
                                                            undefined &&
                                                            firstLevel.SerialNumber !=
                                                              "" && (
                                                              <>
                                                                {
                                                                  firstLevel.SerialNumber
                                                                }
                                                                -
                                                              </>
                                                            )}{" "}
                                                          {firstLevel.Title}
                                                        </div>
                                                      )}

                                                    {programCriteriaQuestionDataItem.QuestionType ==
                                                      3 && (
                                                      <div className="t-3 custom-tip">
                                                        {programCriteriaQuestionDataItem.IsShowTargetSN && (
                                                          <span className="tip-ab">
                                                            {indexFirstLevelInput +
                                                              1}
                                                            .{" "}
                                                          </span>
                                                        )}
                                                        <p
                                                          className="p-top"
                                                          onClick={() =>
                                                            hideDivAndShowInput(
                                                              "TargetTextValue" +
                                                                programCriteriaQuestionDataItem.PID,
                                                              "TargetTextValueInput" +
                                                                programCriteriaQuestionDataItem.PID
                                                            )
                                                          }
                                                          id={
                                                            "TargetTextValue" +
                                                            programCriteriaQuestionDataItem.PID
                                                          }
                                                        >
                                                          {
                                                            programCriteriaQuestionDataItem.TargetTextValue
                                                          }
                                                        </p>
                                                        <input
                                                          disabled={
                                                            programCriteriaQuestionDataItem.QuestionType !=
                                                              3 ||
                                                            globalState
                                                              .AppAccessLevelData
                                                              .DID > 0
                                                              ? true
                                                              : false
                                                          }
                                                          id={
                                                            "TargetTextValueInput" +
                                                            programCriteriaQuestionDataItem.PID
                                                          }
                                                          className="box-tag b-rg"
                                                          type="text"
                                                          value={
                                                            programCriteriaQuestionDataItem.TargetTextValue
                                                          }
                                                          onBlur={(e) => {
                                                            saveInputData(
                                                              programCriteriaQuestionDataItem
                                                            );
                                                            displayDiv(
                                                              "TargetTextValue" +
                                                                programCriteriaQuestionDataItem.PID
                                                            );
                                                          }}
                                                          onChange={(e) =>
                                                            updateValueOfInputKey(
                                                              4,
                                                              e.target.value,
                                                              programCriteriaQuestionDataItem.PID
                                                            )
                                                          }
                                                        ></input>
                                                      </div>
                                                    )}
                                                  </div>
                                                  <div className="t-1">
                                                    {indexFirstLevelInput ==
                                                      0 &&
                                                      programCriteriaQuestionDataItem.IsShowHeader &&
                                                      ((programCriteriaQuestionDataItem.QuestionType ==
                                                        3 &&
                                                        programCriteriaQuestionDataItem.IsShowTextTarget) ||
                                                        programCriteriaQuestionDataItem.QuestionType !=
                                                          3) && (
                                                        <span className="t-2">
                                                          Target
                                                        </span>
                                                      )}
                                                    <>
                                                      {(programCriteriaQuestionDataItem.QuestionType ==
                                                        2 ||
                                                        programCriteriaQuestionDataItem.QuestionType ==
                                                          4 ||
                                                        (programCriteriaQuestionDataItem.QuestionType ==
                                                          3 &&
                                                          programCriteriaQuestionDataItem.IsShowTextTarget)) && (
                                                        <div className="t-3 t-rg custom-tip tip-center">
                                                          {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                            1 &&
                                                            (programCriteriaQuestionDataItem.TargetValueFormat ==
                                                              1 ||
                                                              programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                2 ||
                                                              programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                4) && (
                                                              <>
                                                                <InputMask
                                                                  Disabled={
                                                                    programCriteriaQuestionDataItem.QuestionType !=
                                                                    3
                                                                      ? true
                                                                      : false
                                                                  }
                                                                  Prefix={
                                                                    programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                    4
                                                                      ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                      : ""
                                                                  }
                                                                  Suffix={
                                                                    programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                    2
                                                                      ? "%"
                                                                      : ""
                                                                  }
                                                                  ToFixed={0}
                                                                  ClassName=""
                                                                  ColumnName="1"
                                                                  Value={Number(
                                                                    programCriteriaQuestionDataItem.TargetValue
                                                                  )}
                                                                  PID={
                                                                    programCriteriaQuestionDataItem.PID
                                                                  }
                                                                  onChangeHandler={
                                                                    InputMaskOnChangeHandler
                                                                  }
                                                                  onBlurHandler={
                                                                    InputMaskOnBlurHandler
                                                                  }
                                                                />
                                                              </>
                                                            )}

                                                          {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                            1 &&
                                                            programCriteriaQuestionDataItem.TargetValueFormat ==
                                                              3 && (
                                                              <>
                                                                <p
                                                                  className="p-top"
                                                                  id={
                                                                    "TargetValue" +
                                                                    programCriteriaQuestionDataItem.PID
                                                                  }
                                                                  onClick={() =>
                                                                    hideDivAndShowInput(
                                                                      "TargetValue" +
                                                                        programCriteriaQuestionDataItem.PID,
                                                                      "TargetValueInput" +
                                                                        programCriteriaQuestionDataItem.PID
                                                                    )
                                                                  }
                                                                >
                                                                  {
                                                                    programCriteriaQuestionDataItem.TargetValue
                                                                  }
                                                                </p>
                                                                <input
                                                                  disabled={
                                                                    programCriteriaQuestionDataItem.QuestionType !=
                                                                      3 ||
                                                                    globalState
                                                                      .AppAccessLevelData
                                                                      .DID > 0
                                                                      ? true
                                                                      : false
                                                                  }
                                                                  id={
                                                                    "TargetValueInput" +
                                                                    programCriteriaQuestionDataItem.PID
                                                                  }
                                                                  className="box-tag"
                                                                  type="text"
                                                                  value={
                                                                    programCriteriaQuestionDataItem.TargetValue
                                                                  }
                                                                  onBlur={(
                                                                    e
                                                                  ) => {
                                                                    saveInputData(
                                                                      programCriteriaQuestionDataItem
                                                                    );
                                                                    displayDiv(
                                                                      "TargetValue" +
                                                                        programCriteriaQuestionDataItem.PID
                                                                    );
                                                                  }}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    updateValueOfInputKey(
                                                                      1,
                                                                      e.target
                                                                        .value,
                                                                      programCriteriaQuestionDataItem.PID
                                                                    )
                                                                  }
                                                                ></input>
                                                                {programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                  2 && (
                                                                  <span>%</span>
                                                                )}
                                                              </>
                                                            )}

                                                          {programCriteriaQuestionDataItem.LinkTargetTo !=
                                                            1 && (
                                                            <>
                                                              <span>
                                                                {
                                                                  programCriteriaQuestionDataItem.TargetValue
                                                                }
                                                              </span>
                                                              {programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                2 && (
                                                                <span>%</span>
                                                              )}
                                                            </>
                                                          )}
                                                        </div>
                                                      )}
                                                    </>
                                                  </div>

                                                  {(programCriteriaQuestionDataItem.ActualValueFormat !=
                                                    3 ||
                                                    (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                      3 &&
                                                      programCriteriaQuestionDataItem.IsShowActualNotes)) && (
                                                    <div className="t-1">
                                                      {indexFirstLevelInput ==
                                                        0 &&
                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                          0 &&
                                                        programCriteriaQuestionDataItem.IsShowHeader && (
                                                          <span className="t-2">
                                                            {
                                                              programCriteriaQuestionDataItem.Actual1Title
                                                            }
                                                          </span>
                                                        )}
                                                      {programCriteriaQuestionDataItem.IsHideActual ==
                                                        0 &&
                                                        programCriteriaQuestionDataItem.LinkActualTo ==
                                                          1 && (
                                                          <div className="t-3 custom-tip tip-center">
                                                            {programCriteriaQuestionDataItem.IsShowActualNotes && (
                                                              <>
                                                                <p
                                                                  className="p-top"
                                                                  id={
                                                                    "Actual2Value" +
                                                                    programCriteriaQuestionDataItem.PID
                                                                  }
                                                                  onClick={() =>
                                                                    hideDivAndShowInput(
                                                                      "Actual2Value" +
                                                                        programCriteriaQuestionDataItem.PID,
                                                                      "Actual2ValueInput" +
                                                                        programCriteriaQuestionDataItem.PID
                                                                    )
                                                                  }
                                                                >
                                                                  {
                                                                    programCriteriaQuestionDataItem.Actual2Value
                                                                  }
                                                                </p>
                                                                <input
                                                                  disabled={
                                                                    programCriteriaQuestionDataItem.QuestionType !=
                                                                      3 ||
                                                                    globalState
                                                                      .AppAccessLevelData
                                                                      .DID > 0
                                                                      ? true
                                                                      : false
                                                                  }
                                                                  id={
                                                                    "Actual2ValueInput" +
                                                                    programCriteriaQuestionDataItem.PID
                                                                  }
                                                                  className="box-act"
                                                                  type="text"
                                                                  value={
                                                                    programCriteriaQuestionDataItem.Actual2Value
                                                                  }
                                                                  onBlur={(
                                                                    e
                                                                  ) => {
                                                                    saveInputData(
                                                                      programCriteriaQuestionDataItem
                                                                    );
                                                                    displayDiv(
                                                                      "Actual2Value" +
                                                                        programCriteriaQuestionDataItem.PID
                                                                    );
                                                                  }}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    updateValueOfInputKey(
                                                                      5,
                                                                      e.target
                                                                        .value,
                                                                      programCriteriaQuestionDataItem.PID
                                                                    )
                                                                  }
                                                                ></input>
                                                              </>
                                                            )}
                                                            {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                              1 ||
                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                2 ||
                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                4) && (
                                                              <>
                                                                <InputMask
                                                                  Disabled={
                                                                    programCriteriaQuestionDataItem.QuestionType !=
                                                                      3 ||
                                                                    globalState
                                                                      .AppAccessLevelData
                                                                      .DID > 0
                                                                      ? true
                                                                      : false
                                                                  }
                                                                  Prefix={
                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                    4
                                                                      ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                      : ""
                                                                  }
                                                                  Suffix={
                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                    2
                                                                      ? "%"
                                                                      : ""
                                                                  }
                                                                  ToFixed={0}
                                                                  ClassName=""
                                                                  ColumnName="2"
                                                                  Value={Number(
                                                                    programCriteriaQuestionDataItem.ActualValue
                                                                  )}
                                                                  PID={
                                                                    programCriteriaQuestionDataItem.PID
                                                                  }
                                                                  onChangeHandler={
                                                                    InputMaskOnChangeHandler
                                                                  }
                                                                  onBlurHandler={
                                                                    InputMaskOnBlurHandler
                                                                  }
                                                                />
                                                              </>
                                                            )}
                                                          </div>
                                                        )}

                                                      {programCriteriaQuestionDataItem.IsHideActual ==
                                                        0 &&
                                                        programCriteriaQuestionDataItem.LinkActualTo !=
                                                          1 && (
                                                          <div className="t-3">
                                                            <span>
                                                              {
                                                                programCriteriaQuestionDataItem.ActualValue
                                                              }
                                                            </span>
                                                            {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                              2 && (
                                                              <span>%</span>
                                                            )}
                                                          </div>
                                                        )}
                                                    </div>
                                                  )}

                                                  {programCriteriaQuestionDataItem.QuestionType ==
                                                    4 && (
                                                    <div className="t-1">
                                                      {indexFirstLevelInput ==
                                                        0 &&
                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                          0 &&
                                                        programCriteriaQuestionDataItem.IsShowHeader && (
                                                          <span className="t-2">
                                                            {
                                                              programCriteriaQuestionDataItem.Actual2Title
                                                            }
                                                          </span>
                                                        )}
                                                      {programCriteriaQuestionDataItem.IsHideActual ==
                                                        0 &&
                                                        programCriteriaQuestionDataItem.LinkActualTo ==
                                                          1 && (
                                                          <div className="t-3">
                                                            {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                              1 ||
                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                2 ||
                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                4) && (
                                                              <>
                                                                <InputMask
                                                                  Disabled={
                                                                    programCriteriaQuestionDataItem.QuestionType !=
                                                                      3 ||
                                                                    globalState
                                                                      .AppAccessLevelData
                                                                      .DID > 0
                                                                      ? true
                                                                      : false
                                                                  }
                                                                  Prefix={
                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                    4
                                                                      ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                      : ""
                                                                  }
                                                                  Suffix={
                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                    2
                                                                      ? "%"
                                                                      : ""
                                                                  }
                                                                  ToFixed={0}
                                                                  ClassName=""
                                                                  ColumnName="6"
                                                                  Value={Number(
                                                                    programCriteriaQuestionDataItem.Actual2Value
                                                                  )}
                                                                  PID={
                                                                    programCriteriaQuestionDataItem.PID
                                                                  }
                                                                  onChangeHandler={
                                                                    InputMaskOnChangeHandler
                                                                  }
                                                                  onBlurHandler={
                                                                    InputMaskOnBlurHandler
                                                                  }
                                                                />
                                                              </>
                                                            )}
                                                          </div>
                                                        )}

                                                      {programCriteriaQuestionDataItem.IsHideActual ==
                                                        0 &&
                                                        programCriteriaQuestionDataItem.LinkActualTo !=
                                                          1 && (
                                                          <div className="t-3">
                                                            <span>
                                                              {
                                                                programCriteriaQuestionDataItem.ActualValue
                                                              }
                                                            </span>
                                                            {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                              2 && (
                                                              <span>%</span>
                                                            )}
                                                          </div>
                                                        )}
                                                    </div>
                                                  )}

                                                  <div className="t-1">
                                                    {indexFirstLevelInput ==
                                                      0 &&
                                                      programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                        1 &&
                                                      (programCriteriaQuestionDataItem.IsHideActual ==
                                                        0 ||
                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                          undefined) &&
                                                      programCriteriaQuestionDataItem.LinkActualTo ==
                                                        1 &&
                                                      (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                        1 ||
                                                        programCriteriaQuestionDataItem.ActualValueFormat ==
                                                          4) &&
                                                      programCriteriaQuestionDataItem.IsShowHeader && (
                                                        <span className="t-2 t-2a">
                                                          {programCriteriaQuestionDataItem.Actual1Title !=
                                                            "Actual" && (
                                                            <span>
                                                              {
                                                                programCriteriaQuestionDataItem.Actual1Title
                                                              }
                                                              &nbsp;
                                                            </span>
                                                          )}
                                                          %
                                                        </span>
                                                      )}
                                                    {programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                      1 &&
                                                      (programCriteriaQuestionDataItem.IsHideActual ==
                                                        0 ||
                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                          undefined) &&
                                                      programCriteriaQuestionDataItem.LinkActualTo ==
                                                        1 &&
                                                      (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                        1 ||
                                                        programCriteriaQuestionDataItem.ActualValueFormat ==
                                                          4) && (
                                                        <div className="t-emp-per">
                                                          {programCriteriaQuestionDataItem.TargetValue !=
                                                            undefined &&
                                                            programCriteriaQuestionDataItem.TargetValue !=
                                                              "" &&
                                                            programCriteriaQuestionDataItem.ActualValue !=
                                                              undefined &&
                                                            programCriteriaQuestionDataItem.ActualValue !=
                                                              "" && (
                                                              <div className="t-3">
                                                                {Number(
                                                                  (programCriteriaQuestionDataItem.ActualValue /
                                                                    programCriteriaQuestionDataItem.TargetValue) *
                                                                    100
                                                                ).toFixed(2)}
                                                                %
                                                              </div>
                                                            )}
                                                        </div>
                                                      )}
                                                  </div>

                                                  <div className="t-1">
                                                    {programCriteriaQuestionDataItem.QuestionType ==
                                                      4 &&
                                                      indexFirstLevelInput ==
                                                        0 &&
                                                      programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                        1 &&
                                                      (programCriteriaQuestionDataItem.IsHideActual ==
                                                        0 ||
                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                          undefined) &&
                                                      programCriteriaQuestionDataItem.LinkActualTo ==
                                                        1 &&
                                                      (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                        1 ||
                                                        programCriteriaQuestionDataItem.ActualValueFormat ==
                                                          4) &&
                                                      programCriteriaQuestionDataItem.IsShowHeader && (
                                                        <span className="t-2 t-2a">
                                                          {programCriteriaQuestionDataItem.Actual2Title !=
                                                            "Actual" && (
                                                            <span>
                                                              {
                                                                programCriteriaQuestionDataItem.Actual2Title
                                                              }
                                                              &nbsp;
                                                            </span>
                                                          )}
                                                          %
                                                        </span>
                                                      )}
                                                    {programCriteriaQuestionDataItem.QuestionType ==
                                                      4 &&
                                                      programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                        1 &&
                                                      (programCriteriaQuestionDataItem.IsHideActual ==
                                                        0 ||
                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                          undefined) &&
                                                      programCriteriaQuestionDataItem.LinkActualTo ==
                                                        1 &&
                                                      (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                        1 ||
                                                        programCriteriaQuestionDataItem.ActualValueFormat ==
                                                          4) && (
                                                        <div className="t-emp-per">
                                                          {programCriteriaQuestionDataItem.TargetValue !=
                                                            undefined &&
                                                            programCriteriaQuestionDataItem.TargetValue !=
                                                              "" &&
                                                            programCriteriaQuestionDataItem.Actual2Value !=
                                                              undefined &&
                                                            programCriteriaQuestionDataItem.Actual2Value !=
                                                              "" && (
                                                              <div className="t-3">
                                                                {Number(
                                                                  (programCriteriaQuestionDataItem.Actual2Value /
                                                                    programCriteriaQuestionDataItem.TargetValue) *
                                                                    100
                                                                ).toFixed(2)}
                                                                %
                                                              </div>
                                                            )}
                                                        </div>
                                                      )}
                                                  </div>
                                                </>
                                              )}

                                              <div className="t-1">
                                                {indexFirstLevel == 0 &&
                                                  programCriteriaQuestionDataItem
                                                    .ExceptionData
                                                    ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                    undefined &&
                                                  programCriteriaQuestionDataItem
                                                    .ExceptionData?.Status ==
                                                    1 &&
                                                  programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                    1 && (
                                                    <>
                                                      <div className="t-2 e-app">
                                                        Exception Applied
                                                      </div>
                                                    </>
                                                  )}
                                                <select
                                                  disabled={
                                                    globalState
                                                      .AppAccessLevelData.DID >
                                                    0
                                                      ? true
                                                      : false
                                                  }
                                                  className={`${
                                                    programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                    "1"
                                                      ? "GreenClass"
                                                      : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                        "0"
                                                      ? "RedClass"
                                                      : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                        "2"
                                                      ? "OrangeClass"
                                                      : ""
                                                  }`}
                                                  value={
                                                    programCriteriaQuestionDataItem.IsTargetAchieved
                                                  }
                                                  onChange={(e) =>
                                                    updateValueOfInputKey(
                                                      3,
                                                      Number(e.target.value),
                                                      programCriteriaQuestionDataItem.PID
                                                    )
                                                  }
                                                >
                                                  <option value="undefined">
                                                    Please Select
                                                  </option>
                                                  <option value="0">No</option>
                                                  <option value="1">Yes</option>
                                                  <option value="2">N/A</option>
                                                </select>
                                              </div>
                                            </div>
                                          </div>
                                        </React.Fragment>
                                      )
                                    )}
                                </div>

                                {firstLevel.ChildData &&
                                  firstLevel.ChildData.map(
                                    (
                                      secondLevel: any,
                                      indexSecondLevel: any
                                    ) => (
                                      <React.Fragment
                                        key={
                                          indexSection + "-" + secondLevel.PID
                                        }
                                      >
                                        <div
                                          className={`${
                                            ShowEditMode === true
                                              ? "hover-back"
                                              : ""
                                          }`}
                                        >
                                          <div className="level-1 level-2">
                                            {secondLevel.programCriteriaQuestionData ==
                                              undefined ||
                                              (secondLevel
                                                .programCriteriaQuestionData
                                                .length == 0 && (
                                                <span
                                                  className={
                                                    secondLevel.FormattingOptions
                                                  }
                                                >
                                                  {secondLevel.SerialNumber !=
                                                    undefined &&
                                                    secondLevel.SerialNumber !=
                                                      "" && (
                                                      <>
                                                        {
                                                          secondLevel.SerialNumber
                                                        }
                                                        -
                                                      </>
                                                    )}{" "}
                                                  {secondLevel.Title}
                                                </span>
                                              ))}
                                            {/* <span></span> */}
                                            {ShowEditMode && (
                                              <div className="g-buttons">
                                                {/* <a title="Move Down">
                                            <img
                                              width="13px"
                                              height="13px"
                                              alt="Move Down"
                                              src="images/aw-down.svg"
                                            />
                                          </a>
                                          <a title="Move Up">
                                            <img
                                              width="13px"
                                              height="13px"
                                              alt="Move Up"
                                              src="images/aw-up.svg"
                                            />
                                          </a> */}
                                                <a
                                                  title="Delete"
                                                  // onClick={() =>
                                                  //   IBBProgramCriteriaDeleteRecord(
                                                  //     secondLevel.PID
                                                  //   )
                                                  // }
                                                  onClick={() => {
                                                    globalState.setConfirmationObject(
                                                      {
                                                        ShowPopup: true,
                                                        Heading:
                                                          "Confirmation ",
                                                        Message:
                                                          "Are you sure you want to delete this record?",
                                                        ID: 1,
                                                        SelectedID:
                                                          secondLevel.PID,
                                                      }
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    width="17px"
                                                    height="17px"
                                                    alt="Delete"
                                                    src="images/delete.svg"
                                                  />
                                                </a>
                                                <a
                                                  title="Edit"
                                                  onClick={() => {
                                                    setEntriesModal(true);
                                                    entriesObject.SectionID =
                                                      section.SectionID;
                                                    entriesObject.ParentID =
                                                      secondLevel.ParentID;
                                                    entriesObject.Title =
                                                      secondLevel.Title;
                                                    entriesObject.Description =
                                                      secondLevel.Description;
                                                    entriesObject.SerialNumber =
                                                      secondLevel.SerialNumber;
                                                    entriesObject.PID =
                                                      secondLevel.PID;
                                                    entriesObject.IsInputLevel =
                                                      secondLevel.IsInputLevel;
                                                    entriesObject.FormattingOptions =
                                                      secondLevel.FormattingOptions;
                                                    entriesObject.SplitPercentage =
                                                      secondLevel.SplitPercentage;
                                                    assignprogramCriteriaQuestionData(
                                                      entriesObject.PID
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    width="17px"
                                                    height="17px"
                                                    alt="Edit"
                                                    src="images/edit.svg"
                                                  />
                                                </a>
                                                <a
                                                  title="Add"
                                                  onClick={() => {
                                                    setEntriesModal(true);
                                                    let entriesObjectLocal =
                                                      {} as any;
                                                    entriesObjectLocal.SectionID =
                                                      section.SectionID;
                                                    entriesObjectLocal.ParentID =
                                                      secondLevel.PID;
                                                    entriesObjectLocal.PID = 0;
                                                    entriesObjectLocal.Description =
                                                      "2";
                                                    setEntriesObject(
                                                      entriesObjectLocal
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    width="17px"
                                                    height="17px"
                                                    alt="Add"
                                                    src="images/add.svg"
                                                  />
                                                </a>
                                              </div>
                                            )}
                                          </div>

                                          {secondLevel.programCriteriaQuestionData &&
                                            secondLevel.programCriteriaQuestionData.map(
                                              (
                                                programCriteriaQuestionDataItem: any,
                                                indexSecondLevelInput: any
                                              ) => (
                                                <React.Fragment
                                                  key={
                                                    indexSection +
                                                    "-" +
                                                    secondLevel.PID +
                                                    "-" +
                                                    programCriteriaQuestionDataItem.PID +
                                                    "-" +
                                                    indexSecondLevelInput
                                                  }
                                                >
                                                  <div className="level-1 level-2 t-01">
                                                    {indexSecondLevelInput ==
                                                      0 && <span></span>}
                                                    {indexSecondLevelInput >
                                                      0 && (
                                                      <span className="spn-alg"></span>
                                                    )}
                                                    <div className="t001">
                                                      {!ShowEditMode && (
                                                        <>
                                                          {programCriteriaQuestionDataItem
                                                            .ExceptionData
                                                            ?.ConditionText !=
                                                            undefined &&
                                                          programCriteriaQuestionDataItem
                                                            .ExceptionData
                                                            ?.ConditionText !=
                                                            "" ? (
                                                            <div className="g-buttons exp-trg">
                                                              {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                "0" ||
                                                                programCriteriaQuestionDataItem
                                                                  .ExceptionData
                                                                  ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                  undefined) && (
                                                                <a
                                                                  className={`${
                                                                    programCriteriaQuestionDataItem
                                                                      .ExceptionData
                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                    undefined
                                                                      ? programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.ConditionStatus ==
                                                                        1
                                                                        ? programCriteriaQuestionDataItem
                                                                            .ExceptionData
                                                                            ?.ConditionText !=
                                                                          ""
                                                                          ? "g-excep"
                                                                          : "g-excep"
                                                                        : programCriteriaQuestionDataItem
                                                                            .ExceptionData
                                                                            ?.ConditionStatus ==
                                                                          2
                                                                        ? "r-excep"
                                                                        : "y-excep"
                                                                      : ""
                                                                  }`}
                                                                  title={
                                                                    programCriteriaQuestionDataItem
                                                                      .ExceptionData
                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                    undefined
                                                                      ? programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.Status ==
                                                                        0
                                                                        ? "Edit Exception"
                                                                        : "View Exception"
                                                                      : "Add Exception"
                                                                  }
                                                                  onClick={() => {
                                                                    assignExceptionDataToObject(
                                                                      section,
                                                                      secondLevel,
                                                                      programCriteriaQuestionDataItem
                                                                    );
                                                                  }}
                                                                >
                                                                  <img
                                                                    src="images/hold.svg"
                                                                    width="17px"
                                                                    height="17px"
                                                                  />
                                                                </a>
                                                              )}
                                                            </div>
                                                          ) : (
                                                            <div className="g-buttons exp-trg">
                                                              {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                "0" ||
                                                                programCriteriaQuestionDataItem
                                                                  .ExceptionData
                                                                  ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                  undefined) && (
                                                                <a
                                                                  className={`${
                                                                    programCriteriaQuestionDataItem
                                                                      .ExceptionData
                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                    undefined
                                                                      ? programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.Status ==
                                                                        1
                                                                        ? programCriteriaQuestionDataItem
                                                                            .ExceptionData
                                                                            ?.ConditionText !=
                                                                          ""
                                                                          ? "g-excep"
                                                                          : "g-excep"
                                                                        : programCriteriaQuestionDataItem
                                                                            .ExceptionData
                                                                            ?.Status ==
                                                                          2
                                                                        ? "r-excep"
                                                                        : "y-excep"
                                                                      : ""
                                                                  }`}
                                                                  title={
                                                                    programCriteriaQuestionDataItem
                                                                      .ExceptionData
                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                    undefined
                                                                      ? programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.Status ==
                                                                        0
                                                                        ? "Edit Exception"
                                                                        : "View Exception"
                                                                      : "Add Exception"
                                                                  }
                                                                  onClick={() => {
                                                                    assignExceptionDataToObject(
                                                                      section,
                                                                      secondLevel,
                                                                      programCriteriaQuestionDataItem
                                                                    );
                                                                  }}
                                                                >
                                                                  <img
                                                                    src="images/exception.svg"
                                                                    width="17px"
                                                                    height="17px"
                                                                  />
                                                                </a>
                                                              )}
                                                            </div>
                                                          )}
                                                        </>
                                                      )}
                                                      {indexSecondLevelInput ==
                                                        0 &&
                                                        programCriteriaQuestionDataItem.QuestionType !=
                                                          3 && (
                                                          <span
                                                            className={
                                                              "spn-alg " +
                                                              secondLevel.FormattingOptions
                                                            }
                                                          >
                                                            {secondLevel.SerialNumber !=
                                                              undefined &&
                                                              secondLevel.SerialNumber !=
                                                                "" && (
                                                                <>
                                                                  {
                                                                    secondLevel.SerialNumber
                                                                  }
                                                                  -
                                                                </>
                                                              )}{" "}
                                                            {secondLevel.Title}
                                                          </span>
                                                        )}

                                                      {(programCriteriaQuestionDataItem.QuestionType ==
                                                        2 ||
                                                        programCriteriaQuestionDataItem.QuestionType ==
                                                          4 ||
                                                        programCriteriaQuestionDataItem.QuestionType ==
                                                          3) && (
                                                        <>
                                                          <div className="t-1 t-1-lg">
                                                            {indexSecondLevelInput ==
                                                              0 &&
                                                              programCriteriaQuestionDataItem.QuestionType ==
                                                                3 && (
                                                                <div className="t-2">
                                                                  {secondLevel.SerialNumber !=
                                                                    undefined &&
                                                                    secondLevel.SerialNumber !=
                                                                      "" && (
                                                                      <>
                                                                        {
                                                                          secondLevel.SerialNumber
                                                                        }
                                                                        -
                                                                      </>
                                                                    )}{" "}
                                                                  {
                                                                    secondLevel.Title
                                                                  }
                                                                </div>
                                                              )}

                                                            {programCriteriaQuestionDataItem.QuestionType ==
                                                              3 && (
                                                              <div className="t-3 custom-tip">
                                                                {programCriteriaQuestionDataItem.IsShowTargetSN && (
                                                                  <span className="tip-ab">
                                                                    {indexSecondLevelInput +
                                                                      1}
                                                                    .{" "}
                                                                  </span>
                                                                )}
                                                                <p
                                                                  className="p-top"
                                                                  id={
                                                                    "TargetTextValue" +
                                                                    programCriteriaQuestionDataItem.PID
                                                                  }
                                                                  onClick={() =>
                                                                    hideDivAndShowInput(
                                                                      "TargetTextValue" +
                                                                        programCriteriaQuestionDataItem.PID,
                                                                      "TargetTextValueInput" +
                                                                        programCriteriaQuestionDataItem.PID
                                                                    )
                                                                  }
                                                                >
                                                                  {
                                                                    programCriteriaQuestionDataItem.TargetTextValue
                                                                  }
                                                                </p>
                                                                <input
                                                                  disabled={
                                                                    programCriteriaQuestionDataItem.QuestionType !=
                                                                      3 ||
                                                                    globalState
                                                                      .AppAccessLevelData
                                                                      .DID > 0
                                                                      ? true
                                                                      : false
                                                                  }
                                                                  id={
                                                                    "TargetTextValueInput" +
                                                                    programCriteriaQuestionDataItem.PID
                                                                  }
                                                                  className="box-tag b-rg"
                                                                  type="text"
                                                                  value={
                                                                    programCriteriaQuestionDataItem.TargetTextValue
                                                                  }
                                                                  onBlur={(
                                                                    e
                                                                  ) => {
                                                                    saveInputData(
                                                                      programCriteriaQuestionDataItem
                                                                    );
                                                                    displayDiv(
                                                                      "TargetTextValue" +
                                                                        programCriteriaQuestionDataItem.PID
                                                                    );
                                                                  }}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    updateValueOfInputKey(
                                                                      4,
                                                                      e.target
                                                                        .value,
                                                                      programCriteriaQuestionDataItem.PID
                                                                    )
                                                                  }
                                                                ></input>
                                                              </div>
                                                            )}
                                                          </div>

                                                          <div className="t-1">
                                                            {indexSecondLevelInput ==
                                                              0 &&
                                                              programCriteriaQuestionDataItem.IsShowHeader &&
                                                              ((programCriteriaQuestionDataItem.QuestionType ==
                                                                3 &&
                                                                programCriteriaQuestionDataItem.IsShowTextTarget) ||
                                                                programCriteriaQuestionDataItem.QuestionType !=
                                                                  3) && (
                                                                <span className="t-2">
                                                                  Target
                                                                </span>
                                                              )}
                                                            <>
                                                              {(programCriteriaQuestionDataItem.QuestionType ==
                                                                2 ||
                                                                programCriteriaQuestionDataItem.QuestionType ==
                                                                  4 ||
                                                                (programCriteriaQuestionDataItem.QuestionType ==
                                                                  3 &&
                                                                  programCriteriaQuestionDataItem.IsShowTextTarget)) && (
                                                                <div className="t-3 t-rg custom-tip tip-center">
                                                                  {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                                    1 &&
                                                                    (programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                      1 ||
                                                                      programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                        2 ||
                                                                      programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                        4) && (
                                                                      <>
                                                                        <InputMask
                                                                          Disabled={
                                                                            programCriteriaQuestionDataItem.QuestionType !=
                                                                              3 ||
                                                                            globalState
                                                                              .AppAccessLevelData
                                                                              .DID >
                                                                              0
                                                                              ? true
                                                                              : false
                                                                          }
                                                                          Prefix={
                                                                            programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                            4
                                                                              ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                              : ""
                                                                          }
                                                                          Suffix={
                                                                            programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                            2
                                                                              ? "%"
                                                                              : ""
                                                                          }
                                                                          ToFixed={
                                                                            0
                                                                          }
                                                                          ClassName=""
                                                                          ColumnName="1"
                                                                          Value={Number(
                                                                            programCriteriaQuestionDataItem.TargetValue
                                                                          )}
                                                                          PID={
                                                                            programCriteriaQuestionDataItem.PID
                                                                          }
                                                                          onChangeHandler={
                                                                            InputMaskOnChangeHandler
                                                                          }
                                                                          onBlurHandler={
                                                                            InputMaskOnBlurHandler
                                                                          }
                                                                        />
                                                                      </>
                                                                    )}

                                                                  {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                                    1 &&
                                                                    programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                      3 && (
                                                                      <>
                                                                        <p
                                                                          className="p-top"
                                                                          id={
                                                                            "TargetValue" +
                                                                            programCriteriaQuestionDataItem.PID
                                                                          }
                                                                          onClick={() =>
                                                                            hideDivAndShowInput(
                                                                              "TargetValue" +
                                                                                programCriteriaQuestionDataItem.PID,
                                                                              "TargetValueInput" +
                                                                                programCriteriaQuestionDataItem.PID
                                                                            )
                                                                          }
                                                                        >
                                                                          {
                                                                            programCriteriaQuestionDataItem.TargetValue
                                                                          }
                                                                        </p>
                                                                        <input
                                                                          disabled={
                                                                            programCriteriaQuestionDataItem.QuestionType !=
                                                                              3 ||
                                                                            globalState
                                                                              .AppAccessLevelData
                                                                              .DID >
                                                                              0
                                                                              ? true
                                                                              : false
                                                                          }
                                                                          id={
                                                                            "TargetValueInput" +
                                                                            programCriteriaQuestionDataItem.PID
                                                                          }
                                                                          className="box-tag"
                                                                          type="text"
                                                                          value={
                                                                            programCriteriaQuestionDataItem.TargetValue
                                                                          }
                                                                          onBlur={(
                                                                            e
                                                                          ) => {
                                                                            saveInputData(
                                                                              programCriteriaQuestionDataItem
                                                                            );
                                                                            displayDiv(
                                                                              "TargetValue" +
                                                                                programCriteriaQuestionDataItem.PID
                                                                            );
                                                                          }}
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            updateValueOfInputKey(
                                                                              1,
                                                                              e
                                                                                .target
                                                                                .value,
                                                                              programCriteriaQuestionDataItem.PID
                                                                            )
                                                                          }
                                                                        ></input>
                                                                      </>
                                                                    )}

                                                                  {programCriteriaQuestionDataItem.LinkTargetTo !=
                                                                    1 && (
                                                                    <>
                                                                      <span>
                                                                        {
                                                                          programCriteriaQuestionDataItem.TargetValue
                                                                        }
                                                                      </span>
                                                                      {programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                        2 && (
                                                                        <span>
                                                                          %
                                                                        </span>
                                                                      )}
                                                                    </>
                                                                  )}
                                                                </div>
                                                              )}
                                                            </>
                                                          </div>

                                                          {(programCriteriaQuestionDataItem.ActualValueFormat !=
                                                            3 ||
                                                            (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                              3 &&
                                                              programCriteriaQuestionDataItem.IsShowActualNotes)) && (
                                                            <div className="t-1">
                                                              {indexSecondLevelInput ==
                                                                0 &&
                                                                programCriteriaQuestionDataItem.IsHideActual ==
                                                                  0 &&
                                                                programCriteriaQuestionDataItem.IsShowHeader && (
                                                                  <span className="t-2">
                                                                    {
                                                                      programCriteriaQuestionDataItem.Actual1Title
                                                                    }
                                                                  </span>
                                                                )}
                                                              {programCriteriaQuestionDataItem.IsHideActual ==
                                                                0 &&
                                                                programCriteriaQuestionDataItem.LinkActualTo ==
                                                                  1 && (
                                                                  <div className="t-3 custom-tip tip-center">
                                                                    {programCriteriaQuestionDataItem.IsShowActualNotes && (
                                                                      <>
                                                                        <p
                                                                          className="p-top"
                                                                          id={
                                                                            "Actual2Value" +
                                                                            programCriteriaQuestionDataItem.PID
                                                                          }
                                                                          onClick={() =>
                                                                            hideDivAndShowInput(
                                                                              "Actual2Value" +
                                                                                programCriteriaQuestionDataItem.PID,
                                                                              "Actual2ValueInput" +
                                                                                programCriteriaQuestionDataItem.PID
                                                                            )
                                                                          }
                                                                        >
                                                                          {
                                                                            programCriteriaQuestionDataItem.Actual2Value
                                                                          }
                                                                        </p>
                                                                        <input
                                                                          disabled={
                                                                            programCriteriaQuestionDataItem.QuestionType !=
                                                                              3 ||
                                                                            globalState
                                                                              .AppAccessLevelData
                                                                              .DID >
                                                                              0
                                                                              ? true
                                                                              : false
                                                                          }
                                                                          id={
                                                                            "Actual2ValueInput" +
                                                                            programCriteriaQuestionDataItem.PID
                                                                          }
                                                                          className="box-act"
                                                                          type="text"
                                                                          value={
                                                                            programCriteriaQuestionDataItem.Actual2Value
                                                                          }
                                                                          onBlur={(
                                                                            e
                                                                          ) => {
                                                                            saveInputData(
                                                                              programCriteriaQuestionDataItem
                                                                            );
                                                                            displayDiv(
                                                                              "Actual2Value" +
                                                                                programCriteriaQuestionDataItem.PID
                                                                            );
                                                                          }}
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            updateValueOfInputKey(
                                                                              5,
                                                                              e
                                                                                .target
                                                                                .value,
                                                                              programCriteriaQuestionDataItem.PID
                                                                            )
                                                                          }
                                                                        ></input>
                                                                      </>
                                                                    )}
                                                                    {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      1 ||
                                                                      programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        2 ||
                                                                      programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        4) && (
                                                                      <>
                                                                        <InputMask
                                                                          Disabled={
                                                                            programCriteriaQuestionDataItem.QuestionType !=
                                                                              3 ||
                                                                            globalState
                                                                              .AppAccessLevelData
                                                                              .DID >
                                                                              0
                                                                              ? true
                                                                              : false
                                                                          }
                                                                          Prefix={
                                                                            programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                            4
                                                                              ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                              : ""
                                                                          }
                                                                          Suffix={
                                                                            programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                            2
                                                                              ? "%"
                                                                              : ""
                                                                          }
                                                                          ToFixed={
                                                                            0
                                                                          }
                                                                          ClassName=""
                                                                          ColumnName="2"
                                                                          Value={Number(
                                                                            programCriteriaQuestionDataItem.ActualValue
                                                                          )}
                                                                          PID={
                                                                            programCriteriaQuestionDataItem.PID
                                                                          }
                                                                          onChangeHandler={
                                                                            InputMaskOnChangeHandler
                                                                          }
                                                                          onBlurHandler={
                                                                            InputMaskOnBlurHandler
                                                                          }
                                                                        />
                                                                      </>
                                                                    )}
                                                                  </div>
                                                                )}

                                                              {programCriteriaQuestionDataItem.IsHideActual ==
                                                                0 &&
                                                                programCriteriaQuestionDataItem.LinkActualTo !=
                                                                  1 && (
                                                                  <div className="t-3">
                                                                    <span>
                                                                      {
                                                                        programCriteriaQuestionDataItem.ActualValue
                                                                      }
                                                                    </span>
                                                                    {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      2 && (
                                                                      <span>
                                                                        %
                                                                      </span>
                                                                    )}
                                                                  </div>
                                                                )}
                                                            </div>
                                                          )}

                                                          {programCriteriaQuestionDataItem.QuestionType ==
                                                            4 && (
                                                            <div className="t-1">
                                                              {indexSecondLevelInput ==
                                                                0 &&
                                                                programCriteriaQuestionDataItem.IsHideActual ==
                                                                  0 &&
                                                                programCriteriaQuestionDataItem.IsShowHeader && (
                                                                  <span className="t-2">
                                                                    {
                                                                      programCriteriaQuestionDataItem.Actual2Title
                                                                    }
                                                                  </span>
                                                                )}
                                                              {programCriteriaQuestionDataItem.IsHideActual ==
                                                                0 &&
                                                                programCriteriaQuestionDataItem.LinkActualTo ==
                                                                  1 && (
                                                                  <div className="t-3">
                                                                    {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      1 ||
                                                                      programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        2 ||
                                                                      programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        4) && (
                                                                      <>
                                                                        <InputMask
                                                                          Disabled={
                                                                            programCriteriaQuestionDataItem.QuestionType !=
                                                                              3 ||
                                                                            globalState
                                                                              .AppAccessLevelData
                                                                              .DID >
                                                                              0
                                                                              ? true
                                                                              : false
                                                                          }
                                                                          Prefix={
                                                                            programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                            4
                                                                              ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                              : ""
                                                                          }
                                                                          Suffix={
                                                                            programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                            2
                                                                              ? "%"
                                                                              : ""
                                                                          }
                                                                          ToFixed={
                                                                            0
                                                                          }
                                                                          ClassName=""
                                                                          ColumnName="6"
                                                                          Value={Number(
                                                                            programCriteriaQuestionDataItem.Actual2Value
                                                                          )}
                                                                          PID={
                                                                            programCriteriaQuestionDataItem.PID
                                                                          }
                                                                          onChangeHandler={
                                                                            InputMaskOnChangeHandler
                                                                          }
                                                                          onBlurHandler={
                                                                            InputMaskOnBlurHandler
                                                                          }
                                                                        />
                                                                      </>
                                                                    )}
                                                                  </div>
                                                                )}

                                                              {programCriteriaQuestionDataItem.IsHideActual ==
                                                                0 &&
                                                                programCriteriaQuestionDataItem.LinkActualTo !=
                                                                  1 && (
                                                                  <div className="t-3">
                                                                    <span>
                                                                      {
                                                                        programCriteriaQuestionDataItem.ActualValue
                                                                      }
                                                                    </span>
                                                                    {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      2 && (
                                                                      <span>
                                                                        %
                                                                      </span>
                                                                    )}
                                                                  </div>
                                                                )}
                                                            </div>
                                                          )}

                                                          <div className="t-1">
                                                            {indexSecondLevelInput ==
                                                              0 &&
                                                              programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                1 &&
                                                              (programCriteriaQuestionDataItem.IsHideActual ==
                                                                0 ||
                                                                programCriteriaQuestionDataItem.IsHideActual ==
                                                                  undefined) &&
                                                              programCriteriaQuestionDataItem.LinkActualTo ==
                                                                1 &&
                                                              (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                1 ||
                                                                programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                  4) &&
                                                              programCriteriaQuestionDataItem.IsShowHeader && (
                                                                <span className="t-2 t-2a">
                                                                  {programCriteriaQuestionDataItem.Actual1Title !=
                                                                    "Actual" && (
                                                                    <span>
                                                                      {
                                                                        programCriteriaQuestionDataItem.Actual1Title
                                                                      }
                                                                      &nbsp;
                                                                    </span>
                                                                  )}
                                                                  %
                                                                </span>
                                                              )}
                                                            {programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                              1 &&
                                                              (programCriteriaQuestionDataItem.IsHideActual ==
                                                                0 ||
                                                                programCriteriaQuestionDataItem.IsHideActual ==
                                                                  undefined) &&
                                                              programCriteriaQuestionDataItem.LinkActualTo ==
                                                                1 &&
                                                              (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                1 ||
                                                                programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                  4) && (
                                                                <div className="t-emp-per">
                                                                  {programCriteriaQuestionDataItem.TargetValue !=
                                                                    undefined &&
                                                                    programCriteriaQuestionDataItem.TargetValue !=
                                                                      "" &&
                                                                    programCriteriaQuestionDataItem.ActualValue !=
                                                                      undefined &&
                                                                    programCriteriaQuestionDataItem.ActualValue !=
                                                                      "" && (
                                                                      <div className="t-3">
                                                                        {Number(
                                                                          (programCriteriaQuestionDataItem.ActualValue /
                                                                            programCriteriaQuestionDataItem.TargetValue) *
                                                                            100
                                                                        ).toFixed(
                                                                          2
                                                                        )}
                                                                        %
                                                                      </div>
                                                                    )}
                                                                </div>
                                                              )}
                                                          </div>

                                                          <div className="t-1">
                                                            {programCriteriaQuestionDataItem.QuestionType ==
                                                              4 &&
                                                              indexSecondLevelInput ==
                                                                0 &&
                                                              programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                1 &&
                                                              (programCriteriaQuestionDataItem.IsHideActual ==
                                                                0 ||
                                                                programCriteriaQuestionDataItem.IsHideActual ==
                                                                  undefined) &&
                                                              programCriteriaQuestionDataItem.LinkActualTo ==
                                                                1 &&
                                                              (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                1 ||
                                                                programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                  4) &&
                                                              programCriteriaQuestionDataItem.IsShowHeader && (
                                                                <span className="t-2 t-2a">
                                                                  {programCriteriaQuestionDataItem.Actual2Title !=
                                                                    "Actual" && (
                                                                    <span>
                                                                      {
                                                                        programCriteriaQuestionDataItem.Actual2Title
                                                                      }
                                                                      &nbsp;
                                                                    </span>
                                                                  )}
                                                                  %
                                                                </span>
                                                              )}
                                                            {programCriteriaQuestionDataItem.QuestionType ==
                                                              4 &&
                                                              programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                1 &&
                                                              (programCriteriaQuestionDataItem.IsHideActual ==
                                                                0 ||
                                                                programCriteriaQuestionDataItem.IsHideActual ==
                                                                  undefined) &&
                                                              programCriteriaQuestionDataItem.LinkActualTo ==
                                                                1 &&
                                                              (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                1 ||
                                                                programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                  4) && (
                                                                <div className="t-emp-per">
                                                                  {programCriteriaQuestionDataItem.TargetValue !=
                                                                    undefined &&
                                                                    programCriteriaQuestionDataItem.TargetValue !=
                                                                      "" &&
                                                                    programCriteriaQuestionDataItem.Actual2Value !=
                                                                      undefined &&
                                                                    programCriteriaQuestionDataItem.Actual2Value !=
                                                                      "" && (
                                                                      <div className="t-3">
                                                                        {Number(
                                                                          (programCriteriaQuestionDataItem.Actual2Value /
                                                                            programCriteriaQuestionDataItem.TargetValue) *
                                                                            100
                                                                        ).toFixed(
                                                                          2
                                                                        )}
                                                                        %
                                                                      </div>
                                                                    )}
                                                                </div>
                                                              )}
                                                          </div>
                                                        </>
                                                      )}

                                                      <div className="t-1">
                                                        {indexSecondLevelInput ==
                                                          0 && (
                                                          <>
                                                            <div className="t-2 t-02"></div>
                                                          </>
                                                        )}
                                                        {indexSecondLevel ==
                                                          0 &&
                                                          programCriteriaQuestionDataItem
                                                            .ExceptionData
                                                            ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                            undefined &&
                                                          programCriteriaQuestionDataItem
                                                            .ExceptionData
                                                            ?.Status == 1 &&
                                                          programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                            1 && (
                                                            <>
                                                              <div className="t-2 e-app">
                                                                Exception
                                                                Applied
                                                              </div>
                                                            </>
                                                          )}
                                                        <div className="t-3 t-003">
                                                          <select
                                                            disabled={
                                                              globalState
                                                                .AppAccessLevelData
                                                                .DID > 0
                                                                ? true
                                                                : false
                                                            }
                                                            className={`${
                                                              programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                              "1"
                                                                ? "GreenClass"
                                                                : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                  "0"
                                                                ? "RedClass"
                                                                : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                  "2"
                                                                ? "OrangeClass"
                                                                : ""
                                                            }`}
                                                            value={
                                                              programCriteriaQuestionDataItem.IsTargetAchieved
                                                            }
                                                            onChange={(e) =>
                                                              updateValueOfInputKey(
                                                                3,
                                                                Number(
                                                                  e.target.value
                                                                ),
                                                                programCriteriaQuestionDataItem.PID
                                                              )
                                                            }
                                                          >
                                                            <option value="undefined">
                                                              Please Select
                                                            </option>
                                                            <option value="0">
                                                              No
                                                            </option>
                                                            <option value="1">
                                                              Yes
                                                            </option>
                                                            <option value="2">
                                                              N/A
                                                            </option>
                                                          </select>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </React.Fragment>
                                              )
                                            )}
                                        </div>

                                        {secondLevel.ChildData &&
                                          secondLevel.ChildData.map(
                                            (
                                              thirdLevel: any,
                                              indexThirdLevel: any
                                            ) => (
                                              <React.Fragment
                                                key={
                                                  indexSection +
                                                  "-" +
                                                  thirdLevel.PID
                                                }
                                              >
                                                <div
                                                  className={`${
                                                    ShowEditMode === true
                                                      ? "hover-back"
                                                      : ""
                                                  }`}
                                                >
                                                  <div className="level-1 level-3">
                                                    {thirdLevel.programCriteriaQuestionData ==
                                                      undefined ||
                                                      (thirdLevel
                                                        .programCriteriaQuestionData
                                                        .length == 0 && (
                                                        <span
                                                          className={
                                                            thirdLevel.FormattingOptions
                                                          }
                                                        >
                                                          {thirdLevel.SerialNumber !=
                                                            undefined &&
                                                            thirdLevel.SerialNumber !=
                                                              "" && (
                                                              <>
                                                                {
                                                                  thirdLevel.SerialNumber
                                                                }
                                                                -
                                                              </>
                                                            )}{" "}
                                                          {thirdLevel.Title}
                                                        </span>
                                                      ))}
                                                    {ShowEditMode && (
                                                      <div className="g-buttons">
                                                        {/* <a title="Move Down">
                                                    <img
                                                      width="13px"
                                                      height="13px"
                                                      alt="Move Down"
                                                      src="images/aw-down.svg"
                                                    />
                                                  </a>
                                                  <a title="Move Up">
                                                    <img
                                                      width="13px"
                                                      height="13px"
                                                      alt="Move Up"
                                                      src="images/aw-up.svg"
                                                    />
                                                  </a> */}
                                                        <a
                                                          title="Delete"
                                                          // onClick={() =>
                                                          //   IBBProgramCriteriaDeleteRecord(
                                                          //     thirdLevel.PID
                                                          //   )
                                                          // }
                                                          onClick={() => {
                                                            globalState.setConfirmationObject(
                                                              {
                                                                ShowPopup: true,
                                                                Heading:
                                                                  "Confirmation ",
                                                                Message:
                                                                  "Are you sure you want to delete this record?",
                                                                ID: 1,
                                                                SelectedID:
                                                                  thirdLevel.PID,
                                                              }
                                                            );
                                                          }}
                                                        >
                                                          <img
                                                            width="17px"
                                                            height="17px"
                                                            alt="Delete"
                                                            src="images/delete.svg"
                                                          />
                                                        </a>
                                                        <a
                                                          title="Edit"
                                                          onClick={() => {
                                                            setEntriesModal(
                                                              true
                                                            );
                                                            entriesObject.SectionID =
                                                              section.SectionID;
                                                            entriesObject.ParentID =
                                                              thirdLevel.ParentID;
                                                            entriesObject.Title =
                                                              thirdLevel.Title;
                                                            entriesObject.Description =
                                                              thirdLevel.Description;
                                                            entriesObject.SerialNumber =
                                                              thirdLevel.SerialNumber;
                                                            entriesObject.PID =
                                                              thirdLevel.PID;
                                                            entriesObject.IsInputLevel =
                                                              thirdLevel.IsInputLevel;
                                                            entriesObject.FormattingOptions =
                                                              thirdLevel.FormattingOptions;
                                                            entriesObject.SplitPercentage =
                                                              thirdLevel.SplitPercentage;
                                                            assignprogramCriteriaQuestionData(
                                                              entriesObject.PID
                                                            );
                                                          }}
                                                        >
                                                          <img
                                                            width="17px"
                                                            height="17px"
                                                            alt="Edit"
                                                            src="images/edit.svg"
                                                          />
                                                        </a>
                                                        <a
                                                          className="no-display"
                                                          title="Add"
                                                          onClick={() => {
                                                            setEntriesModal(
                                                              true
                                                            );
                                                            let entriesObjectLocal =
                                                              {} as any;
                                                            entriesObjectLocal.SectionID =
                                                              section.SectionID;
                                                            entriesObjectLocal.ParentID =
                                                              thirdLevel.PID;
                                                            entriesObjectLocal.PID = 0;
                                                            entriesObjectLocal.Description =
                                                              "2";
                                                            setEntriesObject(
                                                              entriesObjectLocal
                                                            );
                                                          }}
                                                        >
                                                          <img
                                                            width="17px"
                                                            height="17px"
                                                            alt="Add"
                                                            src="images/add.svg"
                                                          />
                                                        </a>
                                                      </div>
                                                    )}
                                                  </div>

                                                  {thirdLevel.programCriteriaQuestionData &&
                                                    thirdLevel.programCriteriaQuestionData.map(
                                                      (
                                                        programCriteriaQuestionDataItem: any,
                                                        indexThirdLevelInput: any
                                                      ) => (
                                                        <React.Fragment
                                                          key={
                                                            indexSection +
                                                            "-" +
                                                            thirdLevel.PID +
                                                            "-" +
                                                            programCriteriaQuestionDataItem.PID +
                                                            "-" +
                                                            indexThirdLevelInput
                                                          }
                                                        >
                                                          <div className="level-1 level-3 t-01">
                                                            {indexThirdLevelInput ==
                                                              0 && (
                                                              <span></span>
                                                            )}
                                                            {indexThirdLevelInput >
                                                              0 && (
                                                              <span className="spn-alg"></span>
                                                            )}
                                                            <div className="t001">
                                                              {!ShowEditMode && (
                                                                <>
                                                                  {programCriteriaQuestionDataItem
                                                                    .ExceptionData
                                                                    ?.ConditionText !=
                                                                    undefined &&
                                                                  programCriteriaQuestionDataItem
                                                                    .ExceptionData
                                                                    ?.ConditionText !=
                                                                    "" ? (
                                                                    <div className="g-buttons exp-trg">
                                                                      {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                        "0" ||
                                                                        programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                          undefined) && (
                                                                        <a
                                                                          className={`${
                                                                            programCriteriaQuestionDataItem
                                                                              .ExceptionData
                                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                            undefined
                                                                              ? programCriteriaQuestionDataItem
                                                                                  .ExceptionData
                                                                                  ?.ConditionStatus ==
                                                                                1
                                                                                ? programCriteriaQuestionDataItem
                                                                                    .ExceptionData
                                                                                    ?.ConditionText !=
                                                                                  ""
                                                                                  ? "g-excep"
                                                                                  : "g-excep"
                                                                                : programCriteriaQuestionDataItem
                                                                                    .ExceptionData
                                                                                    ?.ConditionStatus ==
                                                                                  2
                                                                                ? "r-excep"
                                                                                : "y-excep"
                                                                              : ""
                                                                          }`}
                                                                          title={
                                                                            programCriteriaQuestionDataItem
                                                                              .ExceptionData
                                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                            undefined
                                                                              ? programCriteriaQuestionDataItem
                                                                                  .ExceptionData
                                                                                  ?.Status ==
                                                                                0
                                                                                ? "Edit Exception"
                                                                                : "View Exception"
                                                                              : "Add Exception"
                                                                          }
                                                                          onClick={() => {
                                                                            assignExceptionDataToObject(
                                                                              section,
                                                                              thirdLevel,
                                                                              programCriteriaQuestionDataItem
                                                                            );
                                                                          }}
                                                                        >
                                                                          <img
                                                                            src="images/hold.svg"
                                                                            width="17px"
                                                                            height="17px"
                                                                          />
                                                                        </a>
                                                                      )}
                                                                    </div>
                                                                  ) : (
                                                                    <div className="g-buttons exp-trg">
                                                                      {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                        "0" ||
                                                                        programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                          undefined) && (
                                                                        <a
                                                                          className={`${
                                                                            programCriteriaQuestionDataItem
                                                                              .ExceptionData
                                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                            undefined
                                                                              ? programCriteriaQuestionDataItem
                                                                                  .ExceptionData
                                                                                  ?.Status ==
                                                                                1
                                                                                ? programCriteriaQuestionDataItem
                                                                                    .ExceptionData
                                                                                    ?.ConditionText !=
                                                                                  ""
                                                                                  ? "g-excep"
                                                                                  : "g-excep"
                                                                                : programCriteriaQuestionDataItem
                                                                                    .ExceptionData
                                                                                    ?.Status ==
                                                                                  2
                                                                                ? "r-excep"
                                                                                : "y-excep"
                                                                              : ""
                                                                          }`}
                                                                          title={
                                                                            programCriteriaQuestionDataItem
                                                                              .ExceptionData
                                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                            undefined
                                                                              ? programCriteriaQuestionDataItem
                                                                                  .ExceptionData
                                                                                  ?.Status ==
                                                                                0
                                                                                ? "Edit Exception"
                                                                                : "View Exception"
                                                                              : "Add Exception"
                                                                          }
                                                                          onClick={() => {
                                                                            assignExceptionDataToObject(
                                                                              section,
                                                                              thirdLevel,
                                                                              programCriteriaQuestionDataItem
                                                                            );
                                                                          }}
                                                                        >
                                                                          <img
                                                                            src="images/exception.svg"
                                                                            width="17px"
                                                                            height="17px"
                                                                          />
                                                                        </a>
                                                                      )}
                                                                    </div>
                                                                  )}
                                                                </>
                                                              )}
                                                              {indexThirdLevelInput ==
                                                                0 &&
                                                                programCriteriaQuestionDataItem.QuestionType !=
                                                                  3 && (
                                                                  <span
                                                                    className={
                                                                      "spn-alg " +
                                                                      thirdLevel.FormattingOptions
                                                                    }
                                                                  >
                                                                    {thirdLevel.SerialNumber !=
                                                                      undefined &&
                                                                      thirdLevel.SerialNumber !=
                                                                        "" && (
                                                                        <>
                                                                          {
                                                                            thirdLevel.SerialNumber
                                                                          }
                                                                          -
                                                                        </>
                                                                      )}{" "}
                                                                    {
                                                                      thirdLevel.Title
                                                                    }
                                                                  </span>
                                                                )}

                                                              {(programCriteriaQuestionDataItem.QuestionType ==
                                                                2 ||
                                                                programCriteriaQuestionDataItem.QuestionType ==
                                                                  4 ||
                                                                programCriteriaQuestionDataItem.QuestionType ==
                                                                  3) && (
                                                                <>
                                                                  <div className="t-1 t-1-lg">
                                                                    {indexThirdLevelInput ==
                                                                      0 &&
                                                                      programCriteriaQuestionDataItem.QuestionType ==
                                                                        3 && (
                                                                        <div className="t-2">
                                                                          {thirdLevel.SerialNumber !=
                                                                            undefined &&
                                                                            thirdLevel.SerialNumber !=
                                                                              "" && (
                                                                              <>
                                                                                {
                                                                                  thirdLevel.SerialNumber
                                                                                }

                                                                                -
                                                                              </>
                                                                            )}{" "}
                                                                          {
                                                                            thirdLevel.Title
                                                                          }
                                                                        </div>
                                                                      )}

                                                                    {programCriteriaQuestionDataItem.QuestionType ==
                                                                      3 && (
                                                                      <div className="t-3 custom-tip">
                                                                        {programCriteriaQuestionDataItem.IsShowTargetSN && (
                                                                          <span className="tip-ab">
                                                                            {indexThirdLevelInput +
                                                                              1}
                                                                            .{" "}
                                                                          </span>
                                                                        )}
                                                                        <p
                                                                          className="p-top"
                                                                          id={
                                                                            "TargetTextValue" +
                                                                            programCriteriaQuestionDataItem.PID
                                                                          }
                                                                          onClick={() =>
                                                                            hideDivAndShowInput(
                                                                              "TargetTextValue" +
                                                                                programCriteriaQuestionDataItem.PID,
                                                                              "TargetTextValueInput" +
                                                                                programCriteriaQuestionDataItem.PID
                                                                            )
                                                                          }
                                                                        >
                                                                          {
                                                                            programCriteriaQuestionDataItem.TargetTextValue
                                                                          }
                                                                        </p>
                                                                        <input
                                                                          disabled={
                                                                            programCriteriaQuestionDataItem.QuestionType !=
                                                                              3 ||
                                                                            globalState
                                                                              .AppAccessLevelData
                                                                              .DID >
                                                                              0
                                                                              ? true
                                                                              : false
                                                                          }
                                                                          id={
                                                                            "TargetTextValueInput" +
                                                                            programCriteriaQuestionDataItem.PID
                                                                          }
                                                                          className="box-tag b-rg"
                                                                          type="text"
                                                                          value={
                                                                            programCriteriaQuestionDataItem.TargetTextValue
                                                                          }
                                                                          onBlur={(
                                                                            e
                                                                          ) => {
                                                                            saveInputData(
                                                                              programCriteriaQuestionDataItem
                                                                            );
                                                                            displayDiv(
                                                                              "TargetTextValue" +
                                                                                programCriteriaQuestionDataItem.PID
                                                                            );
                                                                          }}
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            updateValueOfInputKey(
                                                                              4,
                                                                              e
                                                                                .target
                                                                                .value,
                                                                              programCriteriaQuestionDataItem.PID
                                                                            )
                                                                          }
                                                                        ></input>
                                                                      </div>
                                                                    )}
                                                                  </div>

                                                                  <div className="t-1">
                                                                    {indexThirdLevelInput ==
                                                                      0 &&
                                                                      programCriteriaQuestionDataItem.IsShowHeader &&
                                                                      ((programCriteriaQuestionDataItem.QuestionType ==
                                                                        3 &&
                                                                        programCriteriaQuestionDataItem.IsShowTextTarget) ||
                                                                        programCriteriaQuestionDataItem.QuestionType !=
                                                                          3) && (
                                                                        <span className="t-2">
                                                                          Target
                                                                        </span>
                                                                      )}
                                                                    <>
                                                                      {(programCriteriaQuestionDataItem.QuestionType ==
                                                                        2 ||
                                                                        programCriteriaQuestionDataItem.QuestionType ==
                                                                          4 ||
                                                                        (programCriteriaQuestionDataItem.QuestionType ==
                                                                          3 &&
                                                                          programCriteriaQuestionDataItem.IsShowTextTarget)) && (
                                                                        <div className="t-3 t-rg custom-tip tip-center">
                                                                          {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                                            1 &&
                                                                            (programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                              1 ||
                                                                              programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                2 ||
                                                                              programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                4) && (
                                                                              <>
                                                                                <InputMask
                                                                                  Disabled={
                                                                                    programCriteriaQuestionDataItem.QuestionType !=
                                                                                      3 ||
                                                                                    globalState
                                                                                      .AppAccessLevelData
                                                                                      .DID >
                                                                                      0
                                                                                      ? true
                                                                                      : false
                                                                                  }
                                                                                  Prefix={
                                                                                    programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                    4
                                                                                      ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                                      : ""
                                                                                  }
                                                                                  Suffix={
                                                                                    programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                    2
                                                                                      ? "%"
                                                                                      : ""
                                                                                  }
                                                                                  ToFixed={
                                                                                    0
                                                                                  }
                                                                                  ClassName=""
                                                                                  ColumnName="1"
                                                                                  Value={Number(
                                                                                    programCriteriaQuestionDataItem.TargetValue
                                                                                  )}
                                                                                  PID={
                                                                                    programCriteriaQuestionDataItem.PID
                                                                                  }
                                                                                  onChangeHandler={
                                                                                    InputMaskOnChangeHandler
                                                                                  }
                                                                                  onBlurHandler={
                                                                                    InputMaskOnBlurHandler
                                                                                  }
                                                                                />
                                                                              </>
                                                                            )}

                                                                          {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                                            1 &&
                                                                            programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                              3 && (
                                                                              <>
                                                                                <p
                                                                                  className="p-top"
                                                                                  id={
                                                                                    "TargetValue" +
                                                                                    programCriteriaQuestionDataItem.PID
                                                                                  }
                                                                                  onClick={() =>
                                                                                    hideDivAndShowInput(
                                                                                      "TargetValue" +
                                                                                        programCriteriaQuestionDataItem.PID,
                                                                                      "TargetValueInput" +
                                                                                        programCriteriaQuestionDataItem.PID
                                                                                    )
                                                                                  }
                                                                                >
                                                                                  {
                                                                                    programCriteriaQuestionDataItem.TargetValue
                                                                                  }
                                                                                </p>
                                                                                <input
                                                                                  disabled={
                                                                                    programCriteriaQuestionDataItem.QuestionType !=
                                                                                      3 ||
                                                                                    globalState
                                                                                      .AppAccessLevelData
                                                                                      .DID >
                                                                                      0
                                                                                      ? true
                                                                                      : false
                                                                                  }
                                                                                  id={
                                                                                    "TargetValueInput" +
                                                                                    programCriteriaQuestionDataItem.PID
                                                                                  }
                                                                                  className="box-tag"
                                                                                  type="text"
                                                                                  value={
                                                                                    programCriteriaQuestionDataItem.TargetValue
                                                                                  }
                                                                                  onBlur={(
                                                                                    e
                                                                                  ) => {
                                                                                    saveInputData(
                                                                                      programCriteriaQuestionDataItem
                                                                                    );
                                                                                    displayDiv(
                                                                                      "TargetValue" +
                                                                                        programCriteriaQuestionDataItem.PID
                                                                                    );
                                                                                  }}
                                                                                  onChange={(
                                                                                    e
                                                                                  ) =>
                                                                                    updateValueOfInputKey(
                                                                                      1,
                                                                                      e
                                                                                        .target
                                                                                        .value,
                                                                                      programCriteriaQuestionDataItem.PID
                                                                                    )
                                                                                  }
                                                                                ></input>
                                                                                {programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                  2 && (
                                                                                  <span>
                                                                                    %
                                                                                  </span>
                                                                                )}
                                                                              </>
                                                                            )}

                                                                          {programCriteriaQuestionDataItem.LinkTargetTo !=
                                                                            1 && (
                                                                            <>
                                                                              <span>
                                                                                {
                                                                                  programCriteriaQuestionDataItem.TargetValue
                                                                                }
                                                                              </span>
                                                                              {programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                2 && (
                                                                                <span>
                                                                                  %
                                                                                </span>
                                                                              )}
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                      )}
                                                                    </>
                                                                  </div>

                                                                  {(programCriteriaQuestionDataItem.ActualValueFormat !=
                                                                    3 ||
                                                                    (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      3 &&
                                                                      programCriteriaQuestionDataItem.IsShowActualNotes)) && (
                                                                    <div className="t-1">
                                                                      {indexThirdLevelInput ==
                                                                        0 &&
                                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                                          0 &&
                                                                        programCriteriaQuestionDataItem.IsShowHeader && (
                                                                          <span className="t-2">
                                                                            {
                                                                              programCriteriaQuestionDataItem.Actual1Title
                                                                            }
                                                                          </span>
                                                                        )}
                                                                      {programCriteriaQuestionDataItem.IsHideActual ==
                                                                        0 &&
                                                                        programCriteriaQuestionDataItem.LinkActualTo ==
                                                                          1 && (
                                                                          <div className="t-3 custom-tip tip-center">
                                                                            {programCriteriaQuestionDataItem.IsShowActualNotes && (
                                                                              <>
                                                                                <p
                                                                                  className="p-top"
                                                                                  id={
                                                                                    "Actual2Value" +
                                                                                    programCriteriaQuestionDataItem.PID
                                                                                  }
                                                                                  onClick={() =>
                                                                                    hideDivAndShowInput(
                                                                                      "Actual2Value" +
                                                                                        programCriteriaQuestionDataItem.PID,
                                                                                      "Actual2ValueInput" +
                                                                                        programCriteriaQuestionDataItem.PID
                                                                                    )
                                                                                  }
                                                                                >
                                                                                  {
                                                                                    programCriteriaQuestionDataItem.Actual2Value
                                                                                  }
                                                                                </p>
                                                                                <input
                                                                                  disabled={
                                                                                    programCriteriaQuestionDataItem.QuestionType !=
                                                                                      3 ||
                                                                                    globalState
                                                                                      .AppAccessLevelData
                                                                                      .DID >
                                                                                      0
                                                                                      ? true
                                                                                      : false
                                                                                  }
                                                                                  id={
                                                                                    "Actual2ValueInput" +
                                                                                    programCriteriaQuestionDataItem.PID
                                                                                  }
                                                                                  className="box-act"
                                                                                  type="text"
                                                                                  value={
                                                                                    programCriteriaQuestionDataItem.Actual2Value
                                                                                  }
                                                                                  onBlur={(
                                                                                    e
                                                                                  ) => {
                                                                                    saveInputData(
                                                                                      programCriteriaQuestionDataItem
                                                                                    );
                                                                                    displayDiv(
                                                                                      "Actual2Value" +
                                                                                        programCriteriaQuestionDataItem.PID
                                                                                    );
                                                                                  }}
                                                                                  onChange={(
                                                                                    e
                                                                                  ) =>
                                                                                    updateValueOfInputKey(
                                                                                      5,
                                                                                      e
                                                                                        .target
                                                                                        .value,
                                                                                      programCriteriaQuestionDataItem.PID
                                                                                    )
                                                                                  }
                                                                                ></input>
                                                                              </>
                                                                            )}
                                                                            {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              1 ||
                                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                2 ||
                                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                4) && (
                                                                              <>
                                                                                <InputMask
                                                                                  Disabled={
                                                                                    programCriteriaQuestionDataItem.QuestionType !=
                                                                                      3 ||
                                                                                    globalState
                                                                                      .AppAccessLevelData
                                                                                      .DID >
                                                                                      0
                                                                                      ? true
                                                                                      : false
                                                                                  }
                                                                                  Prefix={
                                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                    4
                                                                                      ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                                      : ""
                                                                                  }
                                                                                  Suffix={
                                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                    2
                                                                                      ? "%"
                                                                                      : ""
                                                                                  }
                                                                                  ToFixed={
                                                                                    0
                                                                                  }
                                                                                  ClassName=""
                                                                                  ColumnName="2"
                                                                                  Value={Number(
                                                                                    programCriteriaQuestionDataItem.ActualValue
                                                                                  )}
                                                                                  PID={
                                                                                    programCriteriaQuestionDataItem.PID
                                                                                  }
                                                                                  onChangeHandler={
                                                                                    InputMaskOnChangeHandler
                                                                                  }
                                                                                  onBlurHandler={
                                                                                    InputMaskOnBlurHandler
                                                                                  }
                                                                                />
                                                                              </>
                                                                            )}
                                                                          </div>
                                                                        )}

                                                                      {programCriteriaQuestionDataItem.IsHideActual ==
                                                                        0 &&
                                                                        programCriteriaQuestionDataItem.LinkActualTo !=
                                                                          1 && (
                                                                          <div className="t-3">
                                                                            <span>
                                                                              {
                                                                                programCriteriaQuestionDataItem.ActualValue
                                                                              }
                                                                            </span>
                                                                            {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              2 && (
                                                                              <span>
                                                                                %
                                                                              </span>
                                                                            )}
                                                                          </div>
                                                                        )}
                                                                    </div>
                                                                  )}

                                                                  {programCriteriaQuestionDataItem.QuestionType ==
                                                                    4 && (
                                                                    <div className="t-1">
                                                                      {indexThirdLevelInput ==
                                                                        0 &&
                                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                                          0 &&
                                                                        programCriteriaQuestionDataItem.IsShowHeader && (
                                                                          <span className="t-2">
                                                                            {
                                                                              programCriteriaQuestionDataItem.Actual2Title
                                                                            }
                                                                          </span>
                                                                        )}
                                                                      {programCriteriaQuestionDataItem.IsHideActual ==
                                                                        0 &&
                                                                        programCriteriaQuestionDataItem.LinkActualTo ==
                                                                          1 && (
                                                                          <div className="t-3">
                                                                            {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              1 ||
                                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                2 ||
                                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                4) && (
                                                                              <>
                                                                                <InputMask
                                                                                  Disabled={
                                                                                    programCriteriaQuestionDataItem.QuestionType !=
                                                                                      3 ||
                                                                                    globalState
                                                                                      .AppAccessLevelData
                                                                                      .DID >
                                                                                      0
                                                                                      ? true
                                                                                      : false
                                                                                  }
                                                                                  Prefix={
                                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                    4
                                                                                      ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                                      : ""
                                                                                  }
                                                                                  Suffix={
                                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                    2
                                                                                      ? "%"
                                                                                      : ""
                                                                                  }
                                                                                  ToFixed={
                                                                                    0
                                                                                  }
                                                                                  ClassName=""
                                                                                  ColumnName="6"
                                                                                  Value={Number(
                                                                                    programCriteriaQuestionDataItem.Actual2Value
                                                                                  )}
                                                                                  PID={
                                                                                    programCriteriaQuestionDataItem.PID
                                                                                  }
                                                                                  onChangeHandler={
                                                                                    InputMaskOnChangeHandler
                                                                                  }
                                                                                  onBlurHandler={
                                                                                    InputMaskOnBlurHandler
                                                                                  }
                                                                                />
                                                                              </>
                                                                            )}
                                                                          </div>
                                                                        )}

                                                                      {programCriteriaQuestionDataItem.IsHideActual ==
                                                                        0 &&
                                                                        programCriteriaQuestionDataItem.LinkActualTo !=
                                                                          1 && (
                                                                          <div className="t-3">
                                                                            <span>
                                                                              {
                                                                                programCriteriaQuestionDataItem.ActualValue
                                                                              }
                                                                            </span>
                                                                            {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              2 && (
                                                                              <span>
                                                                                %
                                                                              </span>
                                                                            )}
                                                                          </div>
                                                                        )}
                                                                    </div>
                                                                  )}
                                                                  <div className="t-1">
                                                                    {indexThirdLevelInput ==
                                                                      0 &&
                                                                      programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                        1 &&
                                                                      (programCriteriaQuestionDataItem.IsHideActual ==
                                                                        0 ||
                                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                                          undefined) &&
                                                                      programCriteriaQuestionDataItem.LinkActualTo ==
                                                                        1 &&
                                                                      (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        1 ||
                                                                        programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                          4) &&
                                                                      programCriteriaQuestionDataItem.IsShowHeader && (
                                                                        <span className="t-2 t-2a">
                                                                          {programCriteriaQuestionDataItem.Actual1Title !=
                                                                            "Actual" && (
                                                                            <span>
                                                                              {
                                                                                programCriteriaQuestionDataItem.Actual1Title
                                                                              }
                                                                              &nbsp;
                                                                            </span>
                                                                          )}
                                                                          %
                                                                        </span>
                                                                      )}
                                                                    {programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                      1 &&
                                                                      (programCriteriaQuestionDataItem.IsHideActual ==
                                                                        0 ||
                                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                                          undefined) &&
                                                                      programCriteriaQuestionDataItem.LinkActualTo ==
                                                                        1 &&
                                                                      (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        1 ||
                                                                        programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                          4) && (
                                                                        <div className="t-emp-per">
                                                                          {programCriteriaQuestionDataItem.TargetValue !=
                                                                            undefined &&
                                                                            programCriteriaQuestionDataItem.TargetValue !=
                                                                              "" &&
                                                                            programCriteriaQuestionDataItem.ActualValue !=
                                                                              undefined &&
                                                                            programCriteriaQuestionDataItem.ActualValue !=
                                                                              "" && (
                                                                              <div className="t-3">
                                                                                {Number(
                                                                                  (programCriteriaQuestionDataItem.ActualValue /
                                                                                    programCriteriaQuestionDataItem.TargetValue) *
                                                                                    100
                                                                                ).toFixed(
                                                                                  2
                                                                                )}

                                                                                %
                                                                              </div>
                                                                            )}
                                                                        </div>
                                                                      )}
                                                                  </div>

                                                                  <div className="t-1">
                                                                    {programCriteriaQuestionDataItem.QuestionType ==
                                                                      4 &&
                                                                      indexThirdLevelInput ==
                                                                        0 &&
                                                                      programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                        1 &&
                                                                      (programCriteriaQuestionDataItem.IsHideActual ==
                                                                        0 ||
                                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                                          undefined) &&
                                                                      programCriteriaQuestionDataItem.LinkActualTo ==
                                                                        1 &&
                                                                      (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        1 ||
                                                                        programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                          4) &&
                                                                      programCriteriaQuestionDataItem.IsShowHeader && (
                                                                        <span className="t-2 t-2a">
                                                                          {programCriteriaQuestionDataItem.Actual2Title !=
                                                                            "Actual" && (
                                                                            <span>
                                                                              {
                                                                                programCriteriaQuestionDataItem.Actual2Title
                                                                              }
                                                                              &nbsp;
                                                                            </span>
                                                                          )}
                                                                          %
                                                                        </span>
                                                                      )}
                                                                    {programCriteriaQuestionDataItem.QuestionType ==
                                                                      4 &&
                                                                      programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                        1 &&
                                                                      (programCriteriaQuestionDataItem.IsHideActual ==
                                                                        0 ||
                                                                        programCriteriaQuestionDataItem.IsHideActual ==
                                                                          undefined) &&
                                                                      programCriteriaQuestionDataItem.LinkActualTo ==
                                                                        1 &&
                                                                      (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        1 ||
                                                                        programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                          4) && (
                                                                        <div className="t-emp-per">
                                                                          {programCriteriaQuestionDataItem.TargetValue !=
                                                                            undefined &&
                                                                            programCriteriaQuestionDataItem.TargetValue !=
                                                                              "" &&
                                                                            programCriteriaQuestionDataItem.Actual2Value !=
                                                                              undefined &&
                                                                            programCriteriaQuestionDataItem.Actual2Value !=
                                                                              "" && (
                                                                              <div className="t-3">
                                                                                {Number(
                                                                                  (programCriteriaQuestionDataItem.Actual2Value /
                                                                                    programCriteriaQuestionDataItem.TargetValue) *
                                                                                    100
                                                                                ).toFixed(
                                                                                  2
                                                                                )}

                                                                                %
                                                                              </div>
                                                                            )}
                                                                        </div>
                                                                      )}
                                                                  </div>
                                                                </>
                                                              )}

                                                              <div className="t-1">
                                                                {indexThirdLevel ==
                                                                  0 &&
                                                                  programCriteriaQuestionDataItem
                                                                    .ExceptionData
                                                                    ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                    undefined &&
                                                                  programCriteriaQuestionDataItem
                                                                    .ExceptionData
                                                                    ?.Status ==
                                                                    1 &&
                                                                  programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                    1 && (
                                                                    <>
                                                                      <div className="t-2 e-app">
                                                                        Exception
                                                                        Applied
                                                                      </div>
                                                                    </>
                                                                  )}
                                                                <select
                                                                  disabled={
                                                                    globalState
                                                                      .AppAccessLevelData
                                                                      .DID > 0
                                                                      ? true
                                                                      : false
                                                                  }
                                                                  className={`${
                                                                    programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                    "1"
                                                                      ? "GreenClass"
                                                                      : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                        "0"
                                                                      ? "RedClass"
                                                                      : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                        "2"
                                                                      ? "OrangeClass"
                                                                      : ""
                                                                  }`}
                                                                  value={
                                                                    programCriteriaQuestionDataItem.IsTargetAchieved
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    updateValueOfInputKey(
                                                                      3,
                                                                      Number(
                                                                        e.target
                                                                          .value
                                                                      ),
                                                                      programCriteriaQuestionDataItem.PID
                                                                    )
                                                                  }
                                                                >
                                                                  <option value="undefined">
                                                                    Please
                                                                    Select
                                                                  </option>
                                                                  <option value="0">
                                                                    No
                                                                  </option>
                                                                  <option value="1">
                                                                    Yes
                                                                  </option>
                                                                  <option value="2">
                                                                    N/A
                                                                  </option>
                                                                </select>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </React.Fragment>
                                                      )
                                                    )}
                                                </div>
                                              </React.Fragment>
                                            )
                                          )}
                                      </React.Fragment>
                                    )
                                  )}
                              </React.Fragment>
                            )
                          )}
                      </div>
                    )}
                  </>
                )}
              </React.Fragment>
            ))}

          {gatewaysList &&
            !ShowEditMode &&
            gatewaysList.length > 0 &&
            !gatewaysList[0].isAllGatewaysPassed && (
              <div className="lock-icon">
                <img src="images/lock-circle.svg" width="60px" height="60px" />
              </div>
            )}

          {gatewaysList &&
            !ShowEditMode &&
            gatewaysList.length > 0 &&
            gatewaysList[0].isAllGatewaysPassed && (
              <div className="lock-icon">
                <img src="images/lock-open.svg" width="60px" height="60px" />
              </div>
            )}

          {programData.Status == 0 && ShowEditMode && (
            <div
              className="re-earnable"
              style={{ float: "right", marginBottom: 10 }}
            >
              <a
                onClick={() => {
                  resetObjects(2);
                  setReEarnableModal(true);
                }}
              >
                Add Criteria
              </a>
            </div>
          )}
        </div>

        <div className="page--data" style={{ paddingTop: 0 }}>
          {sectionsList &&
            sectionsList.map((section: any, indexSection: any) => (
              <>
                {getAccessSettings(1, section.IBBDepartmentID) > 0 && (
                  <>
                    <React.Fragment key={"RE" + indexSection}>
                      {section.Type == 2 && (
                        <>
                          <div
                            className={`gate-ways-tab gate-ways-inner ${
                              section.IsAccordianOpened ? "" : "gate-way-bot"
                            }`}
                          >
                            <div
                              className="tab-title-g tab-title-gsm"
                              onClick={() => {
                                let sectionsListLocal = [...sectionsList];
                                sectionsListLocal[
                                  indexSection
                                ].IsAccordianOpened =
                                  !sectionsListLocal[indexSection]
                                    .IsAccordianOpened;
                                setSectionsList(sectionsListLocal);
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: 2,
                                }}
                              >
                                {sectionsList[0].Type == 2 && (
                                  <span>{indexSection + 1}.</span>
                                )}
                                {sectionsList[0].Type == 1 > 0 && (
                                  <span>{indexSection}.</span>
                                )}
                                <span>{section.Title}</span>
                              </div>
                            </div>
                            <div className="val-stat-main">
                              <div className="val-stat vs-c1">
                                <div className="val-ex">
                                  <span className="v-c-1">Value:</span>
                                  <span
                                    className={
                                      "v-c-2 " +
                                      GetClassNameForColorValue(
                                        section.SectionID
                                      )
                                    }
                                  >
                                    {section.Value.toLocaleString(undefined, {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                    %
                                    {AddHandToValue(section.SectionID) ==
                                    true ? (
                                      <img
                                        src="/images/hold.svg"
                                        width={18}
                                        height={18}
                                        className="on-hold-hand"
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                </div>
                                <span className="v-c-5">
                                  {section.ValueDescription}
                                </span>
                                {/* <div className="val-ex">
                          <span className="v-c-1">Status:</span>
                          <span className="v-c-3 approved">Approved</span>
                        </div> */}
                              </div>
                              {/* <div className="val-stat vs-c2">
                        <div className="val-ex">
                          <span className="v-c-5">
                            {section.ValueDescription}
                          </span>
                        </div> */}
                              {/* <div className="val-ex">
                          <span className="v-c-1">POT:</span>
                          <span className="v-c-4">$1,000,000</span>
                        </div>
                        <div className="val-ex">
                          <span className="v-c-1">Final Payout:</span>
                          <span className="v-c-5">$1,000,000</span>
                        </div> */}
                              {/* </div> */}
                            </div>
                            <div className="tab-g-exceptions">
                              {!ShowEditMode && (
                                <div className="excp-left">
                                  <div className="excp-1">
                                    <img
                                      src="images/excp.svg"
                                      width="24px"
                                      height="24px"
                                    />
                                    <span>Exceptions</span>
                                  </div>
                                  <div className="excp-2">
                                    <span
                                      className="e-y"
                                      onClick={() => {
                                        setViewException(1);
                                        setViewExceptionData(
                                          section.ExceptionData
                                        );
                                      }}
                                    >
                                      {section.exceptionCount &&
                                        section.exceptionCount[0] > 0 && (
                                          <>{section.exceptionCount[0]}</>
                                        )}
                                    </span>
                                    <span
                                      className="e-g"
                                      onClick={() => {
                                        setViewException(2);
                                        setViewExceptionData(
                                          section.ExceptionData
                                        );
                                      }}
                                    >
                                      {section.exceptionCount &&
                                        section.exceptionCount[1] > 0 && (
                                          <>{section.exceptionCount[1]}</>
                                        )}
                                    </span>
                                    <span
                                      className="e-r"
                                      onClick={() => {
                                        setViewException(3);
                                        setViewExceptionData(
                                          section.ExceptionData
                                        );
                                      }}
                                    >
                                      {section.exceptionCount &&
                                        section.exceptionCount[2] > 0 && (
                                          <>{section.exceptionCount[2]}</>
                                        )}
                                    </span>
                                  </div>
                                </div>
                              )}
                              {/* programData.Status == 0 && TODO:: MM add this check to disable the reearnable edit */}
                              {ShowEditMode && (
                                <div className="g-buttons g-buttons2">
                                  <a
                                    title="Edit"
                                    onClick={() => {
                                      setReEarnableObject(section);
                                      setReEarnableModal(true);
                                    }}
                                  >
                                    <img
                                      width="17px"
                                      height="17px"
                                      alt="Edit"
                                      src="images/edit.svg"
                                    />
                                  </a>
                                  <a
                                    title="Add"
                                    onClick={() => {
                                      setEntriesModal(true);
                                      let entriesObjectLocal = {} as any;
                                      entriesObjectLocal.SectionID =
                                        section.SectionID;
                                      entriesObjectLocal.ParentID = 0;
                                      entriesObjectLocal.PID = 0;
                                      entriesObjectLocal.Description = "2";
                                      setEntriesObject(entriesObjectLocal);
                                    }}
                                  >
                                    <img
                                      width="17px"
                                      height="17px"
                                      alt="Add"
                                      src="images/add.svg"
                                    />
                                  </a>
                                </div>
                              )}
                              <a
                                className="g-toggle-btn"
                                onClick={() => {
                                  let sectionsListLocal = [...sectionsList];
                                  sectionsListLocal[
                                    indexSection
                                  ].IsAccordianOpened =
                                    !sectionsListLocal[indexSection]
                                      .IsAccordianOpened;
                                  setSectionsList(sectionsListLocal);
                                }}
                              >
                                {section.IsAccordianOpened && (
                                  <img
                                    src="images/expand.svg"
                                    className="rotate-180"
                                    width="24px"
                                    height="24px"
                                  />
                                )}
                                {!section.IsAccordianOpened && (
                                  <img
                                    src="images/expand.svg"
                                    width="24px"
                                    height="24px"
                                  />
                                )}
                              </a>
                            </div>
                          </div>
                          {section.IsAccordianOpened && (
                            <div className="g-accord">
                              {section.ChildData &&
                                section.ChildData.map(
                                  (firstLevel: any, indexFirstLevel: any) => (
                                    <React.Fragment
                                      key={indexSection + "-" + firstLevel.PID}
                                    >
                                      <div
                                        className={`${
                                          ShowEditMode === true
                                            ? "hover-back"
                                            : ""
                                        }`}
                                      >
                                        <div className="level-1">
                                          {firstLevel.programCriteriaQuestionData ==
                                            undefined ||
                                            (firstLevel
                                              .programCriteriaQuestionData
                                              .length == 0 && (
                                              <span
                                                className={
                                                  "spn-alg " +
                                                  firstLevel.FormattingOptions
                                                }
                                              >
                                                {firstLevel.SerialNumber !=
                                                  undefined &&
                                                  firstLevel.SerialNumber !=
                                                    "" && (
                                                    <>
                                                      {firstLevel.SerialNumber}-
                                                    </>
                                                  )}{" "}
                                                {firstLevel.Title}
                                              </span>
                                            ))}
                                          {/* <span></span> */}
                                          {ShowEditMode && (
                                            <div className="g-buttons">
                                              {/* <a title="Move Down">
                                      <img
                                        width="13px"
                                        height="13px"
                                        alt="Move Down"
                                        src="images/aw-down.svg"
                                      />
                                    </a>
                                    <a title="Move Up">
                                      <img
                                        width="13px"
                                        height="13px"
                                        alt="Move Up"
                                        src="images/aw-up.svg"
                                      />
                                    </a> */}
                                              <a
                                                title="Delete"
                                                // onClick={() =>
                                                //   IBBProgramCriteriaDeleteRecord(
                                                //     firstLevel.PID
                                                //   )
                                                // }
                                                onClick={() => {
                                                  globalState.setConfirmationObject(
                                                    {
                                                      ShowPopup: true,
                                                      Heading: "Confirmation ",
                                                      Message:
                                                        "Are you sure you want to delete this record?",
                                                      ID: 1,
                                                      SelectedID:
                                                        firstLevel.PID,
                                                    }
                                                  );
                                                }}
                                              >
                                                <img
                                                  width="17px"
                                                  height="17px"
                                                  alt="Delete"
                                                  src="images/delete.svg"
                                                />
                                              </a>
                                              <a
                                                title="Edit"
                                                onClick={() => {
                                                  setEntriesModal(true);
                                                  entriesObject.SectionID =
                                                    section.SectionID;
                                                  entriesObject.ParentID =
                                                    firstLevel.ParentID;
                                                  entriesObject.Title =
                                                    firstLevel.Title;
                                                  entriesObject.Description =
                                                    firstLevel.Description;
                                                  entriesObject.SerialNumber =
                                                    firstLevel.SerialNumber;
                                                  entriesObject.PID =
                                                    firstLevel.PID;
                                                  entriesObject.IsInputLevel =
                                                    firstLevel.IsInputLevel;
                                                  entriesObject.FormattingOptions =
                                                    firstLevel.FormattingOptions;
                                                  entriesObject.SplitPercentage =
                                                    firstLevel.SplitPercentage;
                                                  assignprogramCriteriaQuestionData(
                                                    entriesObject.PID
                                                  );
                                                }}
                                              >
                                                <img
                                                  width="17px"
                                                  height="17px"
                                                  alt="Edit"
                                                  src="images/edit.svg"
                                                />
                                              </a>
                                              <a
                                                title="Add"
                                                onClick={() => {
                                                  setEntriesModal(true);
                                                  let entriesObjectLocal =
                                                    {} as any;
                                                  entriesObjectLocal.SectionID =
                                                    section.SectionID;
                                                  entriesObjectLocal.ParentID =
                                                    firstLevel.PID;
                                                  entriesObjectLocal.PID = 0;
                                                  entriesObjectLocal.Description =
                                                    "2";
                                                  setEntriesObject(
                                                    entriesObjectLocal
                                                  );
                                                }}
                                              >
                                                <img
                                                  width="17px"
                                                  height="17px"
                                                  alt="Add"
                                                  src="images/add.svg"
                                                />
                                              </a>
                                            </div>
                                          )}
                                        </div>

                                        {firstLevel.programCriteriaQuestionData &&
                                          firstLevel.programCriteriaQuestionData.map(
                                            (
                                              programCriteriaQuestionDataItem: any,
                                              indexFirstLevelInput: any
                                            ) => (
                                              <React.Fragment
                                                key={
                                                  indexSection +
                                                  "-" +
                                                  firstLevel.PID +
                                                  "-" +
                                                  programCriteriaQuestionDataItem.PID +
                                                  "-" +
                                                  indexFirstLevelInput
                                                }
                                              >
                                                <div className="level-1 t-01">
                                                  {indexFirstLevelInput ==
                                                    0 && <span></span>}
                                                  {indexFirstLevelInput > 0 && (
                                                    <span className="spn-alg"></span>
                                                  )}
                                                  <div className="t001">
                                                    {!ShowEditMode &&
                                                      scorecardData.CanAddException ==
                                                        1 &&
                                                      ((getAccessSettings(
                                                        2,
                                                        27
                                                      ) > 1 &&
                                                        globalState
                                                          .AppAccessLevelData
                                                          .DID > 0) ||
                                                        (getAccessSettings(
                                                          1,
                                                          section.IBBDepartmentID
                                                        ) > 1 &&
                                                          globalState
                                                            .AppAccessLevelData
                                                            .DID == 0)) && (
                                                        <>
                                                          {programCriteriaQuestionDataItem
                                                            .ExceptionData
                                                            ?.ConditionText !=
                                                            undefined &&
                                                          programCriteriaQuestionDataItem
                                                            .ExceptionData
                                                            ?.ConditionText !=
                                                            "" ? (
                                                            <div className="g-buttons exp-trg">
                                                              {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                "0" ||
                                                                programCriteriaQuestionDataItem
                                                                  .ExceptionData
                                                                  ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                  undefined) && (
                                                                <a
                                                                  className={`${
                                                                    programCriteriaQuestionDataItem
                                                                      .ExceptionData
                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                    undefined
                                                                      ? programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.ConditionStatus ==
                                                                        1
                                                                        ? programCriteriaQuestionDataItem
                                                                            .ExceptionData
                                                                            ?.ConditionText !=
                                                                          ""
                                                                          ? "g-excep"
                                                                          : "g-excep"
                                                                        : programCriteriaQuestionDataItem
                                                                            .ExceptionData
                                                                            ?.ConditionStatus ==
                                                                          2
                                                                        ? "r-excep"
                                                                        : "y-excep"
                                                                      : ""
                                                                  }`}
                                                                  title={
                                                                    programCriteriaQuestionDataItem
                                                                      .ExceptionData
                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                    undefined
                                                                      ? programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.Status ==
                                                                        0
                                                                        ? "Edit Exception"
                                                                        : "View Exception"
                                                                      : "Add Exception"
                                                                  }
                                                                  onClick={() => {
                                                                    assignExceptionDataToObject(
                                                                      section,
                                                                      firstLevel,
                                                                      programCriteriaQuestionDataItem
                                                                    );
                                                                  }}
                                                                >
                                                                  <img
                                                                    src="images/hold.svg"
                                                                    width="17px"
                                                                    height="17px"
                                                                  />
                                                                </a>
                                                              )}
                                                            </div>
                                                          ) : (
                                                            <div className="g-buttons exp-trg">
                                                              {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                "0" ||
                                                                programCriteriaQuestionDataItem
                                                                  .ExceptionData
                                                                  ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                  undefined) && (
                                                                <a
                                                                  className={`${
                                                                    programCriteriaQuestionDataItem
                                                                      .ExceptionData
                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                    undefined
                                                                      ? programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.Status ==
                                                                        1
                                                                        ? programCriteriaQuestionDataItem
                                                                            .ExceptionData
                                                                            ?.ConditionText !=
                                                                          ""
                                                                          ? "g-excep"
                                                                          : "g-excep"
                                                                        : programCriteriaQuestionDataItem
                                                                            .ExceptionData
                                                                            ?.Status ==
                                                                          2
                                                                        ? "r-excep"
                                                                        : "y-excep"
                                                                      : ""
                                                                  }`}
                                                                  title={
                                                                    programCriteriaQuestionDataItem
                                                                      .ExceptionData
                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                    undefined
                                                                      ? programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.Status ==
                                                                        0
                                                                        ? "Edit Exception"
                                                                        : "View Exception"
                                                                      : "Add Exception"
                                                                  }
                                                                  onClick={() => {
                                                                    assignExceptionDataToObject(
                                                                      section,
                                                                      firstLevel,
                                                                      programCriteriaQuestionDataItem
                                                                    );
                                                                  }}
                                                                >
                                                                  <img
                                                                    src="images/exception.svg"
                                                                    width="17px"
                                                                    height="17px"
                                                                  />
                                                                </a>
                                                              )}
                                                            </div>
                                                          )}
                                                        </>
                                                      )}
                                                    {indexFirstLevelInput ==
                                                      0 &&
                                                      programCriteriaQuestionDataItem.QuestionType !=
                                                        3 && (
                                                        <span
                                                          className={
                                                            "spn-alg " +
                                                            firstLevel.FormattingOptions
                                                          }
                                                        >
                                                          {firstLevel.SerialNumber !=
                                                            undefined &&
                                                            firstLevel.SerialNumber !=
                                                              "" && (
                                                              <>
                                                                {
                                                                  firstLevel.SerialNumber
                                                                }
                                                                -
                                                              </>
                                                            )}{" "}
                                                          {firstLevel.Title}
                                                        </span>
                                                      )}

                                                    {(programCriteriaQuestionDataItem.QuestionType ==
                                                      2 ||
                                                      programCriteriaQuestionDataItem.QuestionType ==
                                                        4 ||
                                                      programCriteriaQuestionDataItem.QuestionType ==
                                                        3) && (
                                                      <>
                                                        <div className="t-1 t-1-lg">
                                                          {indexFirstLevelInput ==
                                                            0 &&
                                                            programCriteriaQuestionDataItem.QuestionType ==
                                                              3 && (
                                                              <div className="t-2">
                                                                {firstLevel.SerialNumber !=
                                                                  undefined &&
                                                                  firstLevel.SerialNumber !=
                                                                    "" && (
                                                                    <>
                                                                      {
                                                                        firstLevel.SerialNumber
                                                                      }
                                                                      -
                                                                    </>
                                                                  )}{" "}
                                                                {
                                                                  firstLevel.Title
                                                                }
                                                              </div>
                                                            )}

                                                          {programCriteriaQuestionDataItem.QuestionType ==
                                                            3 && (
                                                            <div className="t-3 custom-tip">
                                                              {programCriteriaQuestionDataItem.IsShowTargetSN && (
                                                                <span className="tip-ab">
                                                                  {indexFirstLevelInput +
                                                                    1}
                                                                  .{" "}
                                                                </span>
                                                              )}
                                                              <p
                                                                className="p-top"
                                                                onClick={() =>
                                                                  hideDivAndShowInput(
                                                                    "TargetTextValue" +
                                                                      programCriteriaQuestionDataItem.PID,
                                                                    "TargetTextValueInput" +
                                                                      programCriteriaQuestionDataItem.PID
                                                                  )
                                                                }
                                                                id={
                                                                  "TargetTextValue" +
                                                                  programCriteriaQuestionDataItem.PID
                                                                }
                                                              >
                                                                {
                                                                  programCriteriaQuestionDataItem.TargetTextValue
                                                                }
                                                              </p>
                                                              <input
                                                                disabled={
                                                                  programCriteriaQuestionDataItem.QuestionType !=
                                                                    3 ||
                                                                  scorecardData.CanInputTargetsData ==
                                                                    0 ||
                                                                  globalState
                                                                    .AppAccessLevelData
                                                                    .DID > 0
                                                                    ? true
                                                                    : false
                                                                }
                                                                id={
                                                                  "TargetTextValueInput" +
                                                                  programCriteriaQuestionDataItem.PID
                                                                }
                                                                className="box-tag b-rg"
                                                                type="text"
                                                                value={
                                                                  programCriteriaQuestionDataItem.TargetTextValue
                                                                }
                                                                onBlur={(e) => {
                                                                  saveInputData(
                                                                    programCriteriaQuestionDataItem
                                                                  );
                                                                  displayDiv(
                                                                    "TargetTextValue" +
                                                                      programCriteriaQuestionDataItem.PID
                                                                  );
                                                                }}
                                                                onChange={(e) =>
                                                                  updateValueOfInputKey(
                                                                    4,
                                                                    e.target
                                                                      .value,
                                                                    programCriteriaQuestionDataItem.PID
                                                                  )
                                                                }
                                                              ></input>
                                                            </div>
                                                          )}
                                                        </div>
                                                        <div className="t-1">
                                                          {indexFirstLevelInput ==
                                                            0 &&
                                                            programCriteriaQuestionDataItem.IsShowHeader &&
                                                            ((programCriteriaQuestionDataItem.QuestionType ==
                                                              3 &&
                                                              programCriteriaQuestionDataItem.IsShowTextTarget) ||
                                                              programCriteriaQuestionDataItem.QuestionType !=
                                                                3) && (
                                                              <span className="t-2">
                                                                Target
                                                              </span>
                                                            )}
                                                          <>
                                                            {(programCriteriaQuestionDataItem.QuestionType ==
                                                              2 ||
                                                              programCriteriaQuestionDataItem.QuestionType ==
                                                                4 ||
                                                              (programCriteriaQuestionDataItem.QuestionType ==
                                                                3 &&
                                                                programCriteriaQuestionDataItem.IsShowTextTarget)) && (
                                                              <div className="t-3 t-rg custom-tip tip-center">
                                                                {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                                  1 &&
                                                                  (programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                    1 ||
                                                                    programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                      2 ||
                                                                    programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                      4) && (
                                                                    <>
                                                                      <InputMask
                                                                        Disabled={
                                                                          scorecardData.CanInputTargetsData ==
                                                                            0 ||
                                                                          globalState
                                                                            .AppAccessLevelData
                                                                            .DID >
                                                                            0
                                                                            ? true
                                                                            : false
                                                                        }
                                                                        Prefix={
                                                                          programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                          4
                                                                            ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                            : ""
                                                                        }
                                                                        Suffix={
                                                                          programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                          2
                                                                            ? "%"
                                                                            : ""
                                                                        }
                                                                        ToFixed={
                                                                          0
                                                                        }
                                                                        ClassName=""
                                                                        ColumnName="1"
                                                                        Value={Number(
                                                                          programCriteriaQuestionDataItem.TargetValue
                                                                        )}
                                                                        PID={
                                                                          programCriteriaQuestionDataItem.PID
                                                                        }
                                                                        onChangeHandler={
                                                                          InputMaskOnChangeHandler
                                                                        }
                                                                        onBlurHandler={
                                                                          InputMaskOnBlurHandler
                                                                        }
                                                                      />
                                                                    </>
                                                                  )}

                                                                {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                                  1 &&
                                                                  programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                    3 && (
                                                                    <>
                                                                      <p
                                                                        className="p-top"
                                                                        id={
                                                                          "TargetValue" +
                                                                          programCriteriaQuestionDataItem.PID
                                                                        }
                                                                        onClick={() =>
                                                                          hideDivAndShowInput(
                                                                            "TargetValue" +
                                                                              programCriteriaQuestionDataItem.PID,
                                                                            "TargetValueInput" +
                                                                              programCriteriaQuestionDataItem.PID
                                                                          )
                                                                        }
                                                                      >
                                                                        {
                                                                          programCriteriaQuestionDataItem.TargetValue
                                                                        }
                                                                      </p>
                                                                      <input
                                                                        disabled={
                                                                          scorecardData.CanInputTargetsData ==
                                                                            0 ||
                                                                          globalState
                                                                            .AppAccessLevelData
                                                                            .DID >
                                                                            0
                                                                            ? true
                                                                            : false
                                                                        }
                                                                        id={
                                                                          "TargetValueInput" +
                                                                          programCriteriaQuestionDataItem.PID
                                                                        }
                                                                        className="box-tag"
                                                                        type="text"
                                                                        value={
                                                                          programCriteriaQuestionDataItem.TargetValue
                                                                        }
                                                                        onBlur={(
                                                                          e
                                                                        ) => {
                                                                          saveInputData(
                                                                            programCriteriaQuestionDataItem
                                                                          );
                                                                          displayDiv(
                                                                            "TargetValue" +
                                                                              programCriteriaQuestionDataItem.PID
                                                                          );
                                                                        }}
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          updateValueOfInputKey(
                                                                            1,
                                                                            e
                                                                              .target
                                                                              .value,
                                                                            programCriteriaQuestionDataItem.PID
                                                                          )
                                                                        }
                                                                      ></input>
                                                                      {programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                        2 && (
                                                                        <span>
                                                                          %
                                                                        </span>
                                                                      )}
                                                                    </>
                                                                  )}

                                                                {programCriteriaQuestionDataItem.LinkTargetTo !=
                                                                  1 && (
                                                                  <>
                                                                    <span>
                                                                      {
                                                                        programCriteriaQuestionDataItem.TargetValue
                                                                      }
                                                                    </span>
                                                                    {programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                      2 && (
                                                                      <span>
                                                                        %
                                                                      </span>
                                                                    )}
                                                                  </>
                                                                )}
                                                              </div>
                                                            )}
                                                          </>
                                                        </div>

                                                        {(programCriteriaQuestionDataItem.ActualValueFormat !=
                                                          3 ||
                                                          (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                            3 &&
                                                            programCriteriaQuestionDataItem.IsShowActualNotes)) && (
                                                          <div className="t-1">
                                                            {indexFirstLevelInput ==
                                                              0 &&
                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                0 &&
                                                              programCriteriaQuestionDataItem.IsShowHeader && (
                                                                <span className="t-2">
                                                                  {
                                                                    programCriteriaQuestionDataItem.Actual1Title
                                                                  }
                                                                </span>
                                                              )}
                                                            {programCriteriaQuestionDataItem.IsHideActual ==
                                                              0 &&
                                                              programCriteriaQuestionDataItem.LinkActualTo ==
                                                                1 && (
                                                                <div className="t-3 custom-tip tip-center">
                                                                  {programCriteriaQuestionDataItem.IsShowActualNotes && (
                                                                    <>
                                                                      <p
                                                                        className="p-top"
                                                                        id={
                                                                          "Actual2Value" +
                                                                          programCriteriaQuestionDataItem.PID
                                                                        }
                                                                        onClick={() =>
                                                                          hideDivAndShowInput(
                                                                            "Actual2Value" +
                                                                              programCriteriaQuestionDataItem.PID,
                                                                            "Actual2ValueInput" +
                                                                              programCriteriaQuestionDataItem.PID
                                                                          )
                                                                        }
                                                                      >
                                                                        {
                                                                          programCriteriaQuestionDataItem.Actual2Value
                                                                        }
                                                                      </p>
                                                                      <input
                                                                        disabled={
                                                                          scorecardData.CanInputActualsData ==
                                                                            0 ||
                                                                          globalState
                                                                            .AppAccessLevelData
                                                                            .DID >
                                                                            0
                                                                            ? true
                                                                            : false
                                                                        }
                                                                        id={
                                                                          "Actual2ValueInput" +
                                                                          programCriteriaQuestionDataItem.PID
                                                                        }
                                                                        className="box-act"
                                                                        type="text"
                                                                        value={
                                                                          programCriteriaQuestionDataItem.Actual2Value
                                                                        }
                                                                        onBlur={(
                                                                          e
                                                                        ) => {
                                                                          saveInputData(
                                                                            programCriteriaQuestionDataItem
                                                                          );
                                                                          displayDiv(
                                                                            "Actual2Value" +
                                                                              programCriteriaQuestionDataItem.PID
                                                                          );
                                                                        }}
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          updateValueOfInputKey(
                                                                            5,
                                                                            e
                                                                              .target
                                                                              .value,
                                                                            programCriteriaQuestionDataItem.PID
                                                                          )
                                                                        }
                                                                      ></input>
                                                                    </>
                                                                  )}
                                                                  {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                    1 ||
                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      2 ||
                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      4) && (
                                                                    <>
                                                                      <InputMask
                                                                        Disabled={
                                                                          scorecardData.CanInputActualsData ==
                                                                            0 ||
                                                                          globalState
                                                                            .AppAccessLevelData
                                                                            .DID >
                                                                            0
                                                                            ? true
                                                                            : false
                                                                        }
                                                                        Prefix={
                                                                          programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                          4
                                                                            ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                            : ""
                                                                        }
                                                                        Suffix={
                                                                          programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                          2
                                                                            ? "%"
                                                                            : ""
                                                                        }
                                                                        ToFixed={
                                                                          0
                                                                        }
                                                                        ClassName=""
                                                                        ColumnName="2"
                                                                        Value={Number(
                                                                          programCriteriaQuestionDataItem.ActualValue
                                                                        )}
                                                                        PID={
                                                                          programCriteriaQuestionDataItem.PID
                                                                        }
                                                                        onChangeHandler={
                                                                          InputMaskOnChangeHandler
                                                                        }
                                                                        onBlurHandler={
                                                                          InputMaskOnBlurHandler
                                                                        }
                                                                      />
                                                                    </>
                                                                  )}
                                                                </div>
                                                              )}

                                                            {programCriteriaQuestionDataItem.IsHideActual ==
                                                              0 &&
                                                              programCriteriaQuestionDataItem.LinkActualTo !=
                                                                1 && (
                                                                <div className="t-3">
                                                                  <span>
                                                                    {
                                                                      programCriteriaQuestionDataItem.ActualValue
                                                                    }
                                                                  </span>
                                                                  {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                    2 && (
                                                                    <span>
                                                                      %
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              )}
                                                          </div>
                                                        )}

                                                        {programCriteriaQuestionDataItem.QuestionType ==
                                                          4 && (
                                                          <div className="t-1">
                                                            {indexFirstLevelInput ==
                                                              0 &&
                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                0 &&
                                                              programCriteriaQuestionDataItem.IsShowHeader && (
                                                                <span className="t-2">
                                                                  {
                                                                    programCriteriaQuestionDataItem.Actual2Title
                                                                  }
                                                                </span>
                                                              )}
                                                            {programCriteriaQuestionDataItem.IsHideActual ==
                                                              0 &&
                                                              programCriteriaQuestionDataItem.LinkActualTo ==
                                                                1 && (
                                                                <div className="t-3">
                                                                  {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                    1 ||
                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      2 ||
                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      4) && (
                                                                    <>
                                                                      <InputMask
                                                                        Disabled={
                                                                          scorecardData.CanInputActualsData ==
                                                                            0 ||
                                                                          globalState
                                                                            .AppAccessLevelData
                                                                            .DID >
                                                                            0
                                                                            ? true
                                                                            : false
                                                                        }
                                                                        Prefix={
                                                                          programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                          4
                                                                            ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                            : ""
                                                                        }
                                                                        Suffix={
                                                                          programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                          2
                                                                            ? "%"
                                                                            : ""
                                                                        }
                                                                        ToFixed={
                                                                          0
                                                                        }
                                                                        ClassName=""
                                                                        ColumnName="6"
                                                                        Value={Number(
                                                                          programCriteriaQuestionDataItem.Actual2Value
                                                                        )}
                                                                        PID={
                                                                          programCriteriaQuestionDataItem.PID
                                                                        }
                                                                        onChangeHandler={
                                                                          InputMaskOnChangeHandler
                                                                        }
                                                                        onBlurHandler={
                                                                          InputMaskOnBlurHandler
                                                                        }
                                                                      />
                                                                    </>
                                                                  )}
                                                                </div>
                                                              )}

                                                            {programCriteriaQuestionDataItem.IsHideActual ==
                                                              0 &&
                                                              programCriteriaQuestionDataItem.LinkActualTo !=
                                                                1 && (
                                                                <div className="t-3">
                                                                  <span>
                                                                    {
                                                                      programCriteriaQuestionDataItem.ActualValue
                                                                    }
                                                                  </span>
                                                                  {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                    2 && (
                                                                    <span>
                                                                      %
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              )}
                                                          </div>
                                                        )}

                                                        <div className="t-1">
                                                          {indexFirstLevelInput ==
                                                            0 &&
                                                            programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                              1 &&
                                                            (programCriteriaQuestionDataItem.IsHideActual ==
                                                              0 ||
                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                undefined) &&
                                                            programCriteriaQuestionDataItem.LinkActualTo ==
                                                              1 &&
                                                            (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                              1 ||
                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                4) &&
                                                            programCriteriaQuestionDataItem.IsShowHeader && (
                                                              <span className="t-2 t-2a">
                                                                {programCriteriaQuestionDataItem.Actual1Title !=
                                                                  "Actual" && (
                                                                  <span>
                                                                    {
                                                                      programCriteriaQuestionDataItem.Actual1Title
                                                                    }
                                                                    &nbsp;
                                                                  </span>
                                                                )}
                                                                %
                                                              </span>
                                                            )}
                                                          {programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                            1 &&
                                                            (programCriteriaQuestionDataItem.IsHideActual ==
                                                              0 ||
                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                undefined) &&
                                                            programCriteriaQuestionDataItem.LinkActualTo ==
                                                              1 &&
                                                            (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                              1 ||
                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                4) && (
                                                              <div className="t-emp-per">
                                                                {programCriteriaQuestionDataItem.TargetValue !=
                                                                  undefined &&
                                                                  programCriteriaQuestionDataItem.TargetValue !=
                                                                    "" &&
                                                                  programCriteriaQuestionDataItem.ActualValue !=
                                                                    undefined &&
                                                                  programCriteriaQuestionDataItem.ActualValue !=
                                                                    "" && (
                                                                    <div className="t-3">
                                                                      {programCriteriaQuestionDataItem.TargetValue !=
                                                                        0 && (
                                                                        <>
                                                                          {Number(
                                                                            (programCriteriaQuestionDataItem.ActualValue /
                                                                              programCriteriaQuestionDataItem.TargetValue) *
                                                                              100
                                                                          ).toFixed(
                                                                            2
                                                                          )}
                                                                        </>
                                                                      )}
                                                                      {programCriteriaQuestionDataItem.TargetValue ==
                                                                        0 && (
                                                                        <>
                                                                          100.00
                                                                        </>
                                                                      )}
                                                                      %
                                                                    </div>
                                                                  )}
                                                              </div>
                                                            )}
                                                        </div>

                                                        <div className="t-1">
                                                          {programCriteriaQuestionDataItem.QuestionType ==
                                                            4 &&
                                                            indexFirstLevelInput ==
                                                              0 &&
                                                            programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                              1 &&
                                                            (programCriteriaQuestionDataItem.IsHideActual ==
                                                              0 ||
                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                undefined) &&
                                                            programCriteriaQuestionDataItem.LinkActualTo ==
                                                              1 &&
                                                            (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                              1 ||
                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                4) &&
                                                            programCriteriaQuestionDataItem.IsShowHeader && (
                                                              <span className="t-2 t-2a">
                                                                {programCriteriaQuestionDataItem.Actual2Title !=
                                                                  "Actual" && (
                                                                  <span>
                                                                    {
                                                                      programCriteriaQuestionDataItem.Actual2Title
                                                                    }
                                                                    &nbsp;
                                                                  </span>
                                                                )}
                                                                %
                                                              </span>
                                                            )}
                                                          {programCriteriaQuestionDataItem.QuestionType ==
                                                            4 &&
                                                            programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                              1 &&
                                                            (programCriteriaQuestionDataItem.IsHideActual ==
                                                              0 ||
                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                undefined) &&
                                                            programCriteriaQuestionDataItem.LinkActualTo ==
                                                              1 &&
                                                            (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                              1 ||
                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                4) && (
                                                              <div className="t-emp-per">
                                                                {programCriteriaQuestionDataItem.TargetValue !=
                                                                  undefined &&
                                                                  programCriteriaQuestionDataItem.TargetValue !=
                                                                    "" &&
                                                                  programCriteriaQuestionDataItem.Actual2Value !=
                                                                    undefined &&
                                                                  programCriteriaQuestionDataItem.Actual2Value !=
                                                                    "" && (
                                                                    <div className="t-3">
                                                                      {programCriteriaQuestionDataItem.TargetValue !=
                                                                        0 && (
                                                                        <>
                                                                          {Number(
                                                                            (programCriteriaQuestionDataItem.Actual2Value /
                                                                              programCriteriaQuestionDataItem.TargetValue) *
                                                                              100
                                                                          ).toFixed(
                                                                            2
                                                                          )}
                                                                        </>
                                                                      )}
                                                                      {programCriteriaQuestionDataItem.TargetValue ==
                                                                        0 && (
                                                                        <>
                                                                          100.00
                                                                        </>
                                                                      )}
                                                                      %
                                                                    </div>
                                                                  )}
                                                              </div>
                                                            )}
                                                        </div>
                                                      </>
                                                    )}

                                                    <div className="t-1">
                                                      {indexFirstLevel >= 0 &&
                                                        programCriteriaQuestionDataItem
                                                          .ExceptionData
                                                          ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                          undefined &&
                                                        programCriteriaQuestionDataItem
                                                          .ExceptionData
                                                          ?.Status == 1 &&
                                                        programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                          1 && (
                                                          <>
                                                            <div className="t-2 e-app">
                                                              Exception Applied
                                                            </div>
                                                          </>
                                                        )}
                                                      <select
                                                        disabled={
                                                          globalState
                                                            .AppAccessLevelData
                                                            .DID > 0 ||
                                                          scorecardData.CanInputActualsData ==
                                                            0
                                                            ? true
                                                            : false
                                                        }
                                                        className={`${
                                                          programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                          "1"
                                                            ? "GreenClass"
                                                            : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                              "0"
                                                            ? "RedClass"
                                                            : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                              "2"
                                                            ? "OrangeClass"
                                                            : ""
                                                        }`}
                                                        value={
                                                          programCriteriaQuestionDataItem.IsTargetAchieved
                                                        }
                                                        onChange={(e) =>
                                                          updateValueOfInputKey(
                                                            3,
                                                            Number(
                                                              e.target.value
                                                            ),
                                                            programCriteriaQuestionDataItem.PID
                                                          )
                                                        }
                                                      >
                                                        <option value="undefined">
                                                          Please Select
                                                        </option>
                                                        <option value="0">
                                                          No
                                                        </option>
                                                        <option value="1">
                                                          Yes
                                                        </option>
                                                        <option value="2">
                                                          N/A
                                                        </option>
                                                      </select>
                                                    </div>
                                                  </div>
                                                </div>
                                              </React.Fragment>
                                            )
                                          )}
                                      </div>

                                      {firstLevel.ChildData &&
                                        firstLevel.ChildData.map(
                                          (
                                            secondLevel: any,
                                            indexSecondLevel: any
                                          ) => (
                                            <React.Fragment
                                              key={
                                                indexSection +
                                                "-" +
                                                secondLevel.PID
                                              }
                                            >
                                              <div
                                                className={`${
                                                  ShowEditMode === true
                                                    ? "hover-back"
                                                    : ""
                                                }`}
                                              >
                                                <div className="level-1 level-2">
                                                  {secondLevel.programCriteriaQuestionData ==
                                                    undefined ||
                                                    (secondLevel
                                                      .programCriteriaQuestionData
                                                      .length == 0 && (
                                                      <span
                                                        className={
                                                          secondLevel.FormattingOptions
                                                        }
                                                      >
                                                        {secondLevel.SerialNumber !=
                                                          undefined &&
                                                          secondLevel.SerialNumber !=
                                                            "" && (
                                                            <>
                                                              {
                                                                secondLevel.SerialNumber
                                                              }
                                                              -
                                                            </>
                                                          )}{" "}
                                                        {secondLevel.Title}
                                                      </span>
                                                    ))}
                                                  {ShowEditMode && (
                                                    <div className="g-buttons">
                                                      <a
                                                        title="Delete"
                                                        onClick={() => {
                                                          globalState.setConfirmationObject(
                                                            {
                                                              ShowPopup: true,
                                                              Heading:
                                                                "Confirmation ",
                                                              Message:
                                                                "Are you sure you want to delete this record?",
                                                              ID: 1,
                                                              SelectedID:
                                                                secondLevel.PID,
                                                            }
                                                          );
                                                        }}
                                                      >
                                                        <img
                                                          width="17px"
                                                          height="17px"
                                                          alt="Delete"
                                                          src="images/delete.svg"
                                                        />
                                                      </a>
                                                      <a
                                                        title="Edit"
                                                        onClick={() => {
                                                          setEntriesModal(true);
                                                          entriesObject.SectionID =
                                                            section.SectionID;
                                                          entriesObject.ParentID =
                                                            secondLevel.ParentID;
                                                          entriesObject.Title =
                                                            secondLevel.Title;
                                                          entriesObject.Description =
                                                            secondLevel.Description;
                                                          entriesObject.SerialNumber =
                                                            secondLevel.SerialNumber;
                                                          entriesObject.PID =
                                                            secondLevel.PID;
                                                          entriesObject.IsInputLevel =
                                                            secondLevel.IsInputLevel;
                                                          entriesObject.FormattingOptions =
                                                            secondLevel.FormattingOptions;
                                                          entriesObject.SplitPercentage =
                                                            secondLevel.SplitPercentage;
                                                          assignprogramCriteriaQuestionData(
                                                            entriesObject.PID
                                                          );
                                                        }}
                                                      >
                                                        <img
                                                          width="17px"
                                                          height="17px"
                                                          alt="Edit"
                                                          src="images/edit.svg"
                                                        />
                                                      </a>
                                                      <a
                                                        title="Add"
                                                        onClick={() => {
                                                          setEntriesModal(true);
                                                          let entriesObjectLocal =
                                                            {} as any;
                                                          entriesObjectLocal.SectionID =
                                                            section.SectionID;
                                                          entriesObjectLocal.ParentID =
                                                            secondLevel.PID;
                                                          entriesObjectLocal.PID = 0;
                                                          entriesObjectLocal.Description =
                                                            "2";
                                                          setEntriesObject(
                                                            entriesObjectLocal
                                                          );
                                                        }}
                                                      >
                                                        <img
                                                          width="17px"
                                                          height="17px"
                                                          alt="Add"
                                                          src="images/add.svg"
                                                        />
                                                      </a>
                                                    </div>
                                                  )}
                                                </div>

                                                {secondLevel.programCriteriaQuestionData &&
                                                  secondLevel.programCriteriaQuestionData.map(
                                                    (
                                                      programCriteriaQuestionDataItem: any,
                                                      indexSecondLevelInput: any
                                                    ) => (
                                                      <React.Fragment
                                                        key={
                                                          indexSection +
                                                          "-" +
                                                          secondLevel.PID +
                                                          "-" +
                                                          programCriteriaQuestionDataItem.PID +
                                                          "-" +
                                                          indexSecondLevelInput
                                                        }
                                                      >
                                                        <div className="level-1 level-2 t-01">
                                                          {indexSecondLevelInput ==
                                                            0 && <span></span>}
                                                          {indexSecondLevelInput >
                                                            0 && (
                                                            <span className="spn-alg"></span>
                                                          )}
                                                          <div className="t001">
                                                            {!ShowEditMode &&
                                                              scorecardData.CanAddException ==
                                                                1 &&
                                                              ((getAccessSettings(
                                                                2,
                                                                27
                                                              ) > 1 &&
                                                                globalState
                                                                  .AppAccessLevelData
                                                                  .DID > 0) ||
                                                                (getAccessSettings(
                                                                  1,
                                                                  section.IBBDepartmentID
                                                                ) > 1 &&
                                                                  globalState
                                                                    .AppAccessLevelData
                                                                    .DID ==
                                                                    0)) && (
                                                                <>
                                                                  {programCriteriaQuestionDataItem
                                                                    .ExceptionData
                                                                    ?.ConditionText !=
                                                                    undefined &&
                                                                  programCriteriaQuestionDataItem
                                                                    .ExceptionData
                                                                    ?.ConditionText !=
                                                                    "" ? (
                                                                    <div className="g-buttons exp-trg">
                                                                      {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                        "0" ||
                                                                        programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                          undefined) && (
                                                                        <a
                                                                          className={`${
                                                                            programCriteriaQuestionDataItem
                                                                              .ExceptionData
                                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                            undefined
                                                                              ? programCriteriaQuestionDataItem
                                                                                  .ExceptionData
                                                                                  ?.ConditionStatus ==
                                                                                1
                                                                                ? programCriteriaQuestionDataItem
                                                                                    .ExceptionData
                                                                                    ?.ConditionText !=
                                                                                  ""
                                                                                  ? "g-excep"
                                                                                  : "g-excep"
                                                                                : programCriteriaQuestionDataItem
                                                                                    .ExceptionData
                                                                                    ?.ConditionStatus ==
                                                                                  2
                                                                                ? "r-excep"
                                                                                : "y-excep"
                                                                              : ""
                                                                          }`}
                                                                          title={
                                                                            programCriteriaQuestionDataItem
                                                                              .ExceptionData
                                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                            undefined
                                                                              ? programCriteriaQuestionDataItem
                                                                                  .ExceptionData
                                                                                  ?.Status ==
                                                                                0
                                                                                ? "Edit Exception"
                                                                                : "View Exception"
                                                                              : "Add Exception"
                                                                          }
                                                                          onClick={() => {
                                                                            assignExceptionDataToObject(
                                                                              section,
                                                                              secondLevel,
                                                                              programCriteriaQuestionDataItem
                                                                            );
                                                                          }}
                                                                        >
                                                                          <img
                                                                            src="images/hold.svg"
                                                                            width="17px"
                                                                            height="17px"
                                                                          />
                                                                        </a>
                                                                      )}
                                                                    </div>
                                                                  ) : (
                                                                    <div className="g-buttons exp-trg">
                                                                      {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                        "0" ||
                                                                        programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                          undefined) && (
                                                                        <a
                                                                          className={`${
                                                                            programCriteriaQuestionDataItem
                                                                              .ExceptionData
                                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                            undefined
                                                                              ? programCriteriaQuestionDataItem
                                                                                  .ExceptionData
                                                                                  ?.Status ==
                                                                                1
                                                                                ? programCriteriaQuestionDataItem
                                                                                    .ExceptionData
                                                                                    ?.ConditionText !=
                                                                                  ""
                                                                                  ? "g-excep"
                                                                                  : "g-excep"
                                                                                : programCriteriaQuestionDataItem
                                                                                    .ExceptionData
                                                                                    ?.Status ==
                                                                                  2
                                                                                ? "r-excep"
                                                                                : "y-excep"
                                                                              : ""
                                                                          }`}
                                                                          title={
                                                                            programCriteriaQuestionDataItem
                                                                              .ExceptionData
                                                                              ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                            undefined
                                                                              ? programCriteriaQuestionDataItem
                                                                                  .ExceptionData
                                                                                  ?.Status ==
                                                                                0
                                                                                ? "Edit Exception"
                                                                                : "View Exception"
                                                                              : "Add Exception"
                                                                          }
                                                                          onClick={() => {
                                                                            assignExceptionDataToObject(
                                                                              section,
                                                                              secondLevel,
                                                                              programCriteriaQuestionDataItem
                                                                            );
                                                                          }}
                                                                        >
                                                                          <img
                                                                            src="images/exception.svg"
                                                                            width="17px"
                                                                            height="17px"
                                                                          />
                                                                        </a>
                                                                      )}
                                                                    </div>
                                                                  )}
                                                                </>
                                                              )}
                                                            {indexSecondLevelInput ==
                                                              0 &&
                                                              programCriteriaQuestionDataItem.QuestionType !=
                                                                3 && (
                                                                <>
                                                                  <span
                                                                    className={
                                                                      "spn-alg " +
                                                                      secondLevel.FormattingOptions
                                                                    }
                                                                  >
                                                                    {secondLevel.SerialNumber !=
                                                                      undefined &&
                                                                      secondLevel.SerialNumber !=
                                                                        "" && (
                                                                        <>
                                                                          {
                                                                            secondLevel.SerialNumber
                                                                          }
                                                                          -
                                                                        </>
                                                                      )}{" "}
                                                                    {
                                                                      secondLevel.Title
                                                                    }
                                                                  </span>
                                                                  {programCriteriaQuestionDataItem.DataLevelType ==
                                                                    2 && (
                                                                    <div className="g-buttons mar-lt10">
                                                                      <a
                                                                        onClick={() => {
                                                                          setShowRetailerLevelData(
                                                                            programCriteriaQuestionDataItem
                                                                          );
                                                                        }}
                                                                      >
                                                                        {showRetailerLevelDataIDs.indexOf(
                                                                          programCriteriaQuestionDataItem.IBBProgramCriteriaQuestionID
                                                                        ) >
                                                                        -1 ? (
                                                                          <img
                                                                            width="12px"
                                                                            height="3px"
                                                                            alt="hide"
                                                                            src="images/minus.svg"
                                                                          />
                                                                        ) : (
                                                                          <img
                                                                            width="17px"
                                                                            height="17px"
                                                                            alt="Add"
                                                                            src="images/add.svg"
                                                                          />
                                                                        )}
                                                                      </a>
                                                                    </div>
                                                                  )}
                                                                </>
                                                              )}

                                                            {(programCriteriaQuestionDataItem.QuestionType ==
                                                              2 ||
                                                              programCriteriaQuestionDataItem.QuestionType ==
                                                                4 ||
                                                              programCriteriaQuestionDataItem.QuestionType ==
                                                                3) && (
                                                              <>
                                                                <div className="t-1 t-1-lg">
                                                                  {indexSecondLevelInput ==
                                                                    0 &&
                                                                    programCriteriaQuestionDataItem.QuestionType ==
                                                                      3 && (
                                                                      <div className="t-2">
                                                                        {secondLevel.SerialNumber !=
                                                                          undefined &&
                                                                          secondLevel.SerialNumber !=
                                                                            "" && (
                                                                            <>
                                                                              {
                                                                                secondLevel.SerialNumber
                                                                              }
                                                                              -
                                                                            </>
                                                                          )}{" "}
                                                                        {
                                                                          secondLevel.Title
                                                                        }
                                                                      </div>
                                                                    )}

                                                                  {programCriteriaQuestionDataItem.QuestionType ==
                                                                    3 && (
                                                                    <div className="t-3 custom-tip">
                                                                      {programCriteriaQuestionDataItem.IsShowTargetSN && (
                                                                        <span className="tip-ab">
                                                                          {indexSecondLevelInput +
                                                                            1}
                                                                          .{" "}
                                                                        </span>
                                                                      )}
                                                                      <p
                                                                        className="p-top"
                                                                        id={
                                                                          "TargetTextValue" +
                                                                          programCriteriaQuestionDataItem.PID
                                                                        }
                                                                        onClick={() =>
                                                                          hideDivAndShowInput(
                                                                            "TargetTextValue" +
                                                                              programCriteriaQuestionDataItem.PID,
                                                                            "TargetTextValueInput" +
                                                                              programCriteriaQuestionDataItem.PID
                                                                          )
                                                                        }
                                                                      >
                                                                        {
                                                                          programCriteriaQuestionDataItem.TargetTextValue
                                                                        }
                                                                      </p>
                                                                      <input
                                                                        disabled={
                                                                          scorecardData.CanInputTargetsData ==
                                                                            0 ||
                                                                          globalState
                                                                            .AppAccessLevelData
                                                                            .DID >
                                                                            0
                                                                            ? true
                                                                            : false
                                                                        }
                                                                        id={
                                                                          "TargetTextValueInput" +
                                                                          programCriteriaQuestionDataItem.PID
                                                                        }
                                                                        className="box-tag b-rg"
                                                                        type="text"
                                                                        value={
                                                                          programCriteriaQuestionDataItem.TargetTextValue
                                                                        }
                                                                        onBlur={(
                                                                          e
                                                                        ) => {
                                                                          saveInputData(
                                                                            programCriteriaQuestionDataItem
                                                                          );
                                                                          displayDiv(
                                                                            "TargetTextValue" +
                                                                              programCriteriaQuestionDataItem.PID
                                                                          );
                                                                        }}
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          updateValueOfInputKey(
                                                                            4,
                                                                            e
                                                                              .target
                                                                              .value,
                                                                            programCriteriaQuestionDataItem.PID
                                                                          )
                                                                        }
                                                                      ></input>
                                                                    </div>
                                                                  )}
                                                                </div>

                                                                <div className="t-1">
                                                                  {indexSecondLevelInput ==
                                                                    0 &&
                                                                    programCriteriaQuestionDataItem.IsShowHeader &&
                                                                    ((programCriteriaQuestionDataItem.QuestionType ==
                                                                      3 &&
                                                                      programCriteriaQuestionDataItem.IsShowTextTarget) ||
                                                                      programCriteriaQuestionDataItem.QuestionType !=
                                                                        3) && (
                                                                      <span className="t-2">
                                                                        Target
                                                                      </span>
                                                                    )}
                                                                  <>
                                                                    {(programCriteriaQuestionDataItem.QuestionType ==
                                                                      2 ||
                                                                      programCriteriaQuestionDataItem.QuestionType ==
                                                                        4 ||
                                                                      (programCriteriaQuestionDataItem.QuestionType ==
                                                                        3 &&
                                                                        programCriteriaQuestionDataItem.IsShowTextTarget)) && (
                                                                      <div className="t-3 t-rg custom-tip tip-center">
                                                                        {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                                          1 &&
                                                                          (programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                            1 ||
                                                                            programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                              2 ||
                                                                            programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                              4) && (
                                                                            <>
                                                                              <InputMask
                                                                                Disabled={
                                                                                  programCriteriaQuestionDataItem.QuestionType !=
                                                                                    3 ||
                                                                                  scorecardData.CanInputTargetsData ==
                                                                                    0 ||
                                                                                  globalState
                                                                                    .AppAccessLevelData
                                                                                    .DID >
                                                                                    0
                                                                                    ? true
                                                                                    : false
                                                                                }
                                                                                Prefix={
                                                                                  programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                  4
                                                                                    ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                                    : ""
                                                                                }
                                                                                Suffix={
                                                                                  programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                  2
                                                                                    ? "%"
                                                                                    : ""
                                                                                }
                                                                                ToFixed={
                                                                                  0
                                                                                }
                                                                                ClassName=""
                                                                                ColumnName="1"
                                                                                Value={Number(
                                                                                  programCriteriaQuestionDataItem.TargetValue
                                                                                )}
                                                                                PID={
                                                                                  programCriteriaQuestionDataItem.PID
                                                                                }
                                                                                onChangeHandler={
                                                                                  InputMaskOnChangeHandler
                                                                                }
                                                                                onBlurHandler={
                                                                                  InputMaskOnBlurHandler
                                                                                }
                                                                              />
                                                                            </>
                                                                          )}

                                                                        {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                                          1 &&
                                                                          programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                            3 && (
                                                                            <>
                                                                              <p
                                                                                className="p-top"
                                                                                id={
                                                                                  "TargetValue" +
                                                                                  programCriteriaQuestionDataItem.PID
                                                                                }
                                                                                onClick={() =>
                                                                                  hideDivAndShowInput(
                                                                                    "TargetValue" +
                                                                                      programCriteriaQuestionDataItem.PID,
                                                                                    "TargetValueInput" +
                                                                                      programCriteriaQuestionDataItem.PID
                                                                                  )
                                                                                }
                                                                              >
                                                                                {
                                                                                  programCriteriaQuestionDataItem.TargetValue
                                                                                }
                                                                              </p>
                                                                              <input
                                                                                disabled={
                                                                                  programCriteriaQuestionDataItem.QuestionType !=
                                                                                    3 ||
                                                                                  scorecardData.CanInputTargetsData ==
                                                                                    0 ||
                                                                                  globalState
                                                                                    .AppAccessLevelData
                                                                                    .DID >
                                                                                    0
                                                                                    ? true
                                                                                    : false
                                                                                }
                                                                                id={
                                                                                  "TargetValueInput" +
                                                                                  programCriteriaQuestionDataItem.PID
                                                                                }
                                                                                className="box-tag"
                                                                                type="text"
                                                                                value={
                                                                                  programCriteriaQuestionDataItem.TargetValue
                                                                                }
                                                                                onBlur={(
                                                                                  e
                                                                                ) => {
                                                                                  saveInputData(
                                                                                    programCriteriaQuestionDataItem
                                                                                  );
                                                                                  displayDiv(
                                                                                    "TargetValue" +
                                                                                      programCriteriaQuestionDataItem.PID
                                                                                  );
                                                                                }}
                                                                                onChange={(
                                                                                  e
                                                                                ) =>
                                                                                  updateValueOfInputKey(
                                                                                    1,
                                                                                    e
                                                                                      .target
                                                                                      .value,
                                                                                    programCriteriaQuestionDataItem.PID
                                                                                  )
                                                                                }
                                                                              ></input>
                                                                            </>
                                                                          )}

                                                                        {programCriteriaQuestionDataItem.LinkTargetTo !=
                                                                          1 && (
                                                                          <>
                                                                            <span>
                                                                              {
                                                                                programCriteriaQuestionDataItem.TargetValue
                                                                              }
                                                                            </span>
                                                                            {programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                              2 && (
                                                                              <span>
                                                                                %
                                                                              </span>
                                                                            )}
                                                                          </>
                                                                        )}
                                                                      </div>
                                                                    )}
                                                                  </>
                                                                </div>

                                                                {(programCriteriaQuestionDataItem.ActualValueFormat !=
                                                                  3 ||
                                                                  (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                    3 &&
                                                                    programCriteriaQuestionDataItem.IsShowActualNotes)) && (
                                                                  <div className="t-1">
                                                                    {indexSecondLevelInput ==
                                                                      0 &&
                                                                      programCriteriaQuestionDataItem.IsHideActual ==
                                                                        0 &&
                                                                      programCriteriaQuestionDataItem.IsShowHeader && (
                                                                        <span className="t-2">
                                                                          {
                                                                            programCriteriaQuestionDataItem.Actual1Title
                                                                          }
                                                                        </span>
                                                                      )}
                                                                    {programCriteriaQuestionDataItem.IsHideActual ==
                                                                      0 &&
                                                                      programCriteriaQuestionDataItem.LinkActualTo ==
                                                                        1 && (
                                                                        <div className="t-3 custom-tip tip-center">
                                                                          {programCriteriaQuestionDataItem.IsShowActualNotes && (
                                                                            <>
                                                                              <p
                                                                                className="p-top"
                                                                                id={
                                                                                  "Actual2Value" +
                                                                                  programCriteriaQuestionDataItem.PID
                                                                                }
                                                                                onClick={() =>
                                                                                  hideDivAndShowInput(
                                                                                    "Actual2Value" +
                                                                                      programCriteriaQuestionDataItem.PID,
                                                                                    "Actual2ValueInput" +
                                                                                      programCriteriaQuestionDataItem.PID
                                                                                  )
                                                                                }
                                                                              >
                                                                                {
                                                                                  programCriteriaQuestionDataItem.Actual2Value
                                                                                }
                                                                              </p>
                                                                              <input
                                                                                disabled={
                                                                                  scorecardData.CanInputActualsData ==
                                                                                    0 ||
                                                                                  globalState
                                                                                    .AppAccessLevelData
                                                                                    .DID >
                                                                                    0
                                                                                    ? true
                                                                                    : false
                                                                                }
                                                                                id={
                                                                                  "Actual2ValueInput" +
                                                                                  programCriteriaQuestionDataItem.PID
                                                                                }
                                                                                className="box-act"
                                                                                type="text"
                                                                                value={
                                                                                  programCriteriaQuestionDataItem.Actual2Value
                                                                                }
                                                                                onBlur={(
                                                                                  e
                                                                                ) => {
                                                                                  saveInputData(
                                                                                    programCriteriaQuestionDataItem
                                                                                  );
                                                                                  displayDiv(
                                                                                    "Actual2Value" +
                                                                                      programCriteriaQuestionDataItem.PID
                                                                                  );
                                                                                }}
                                                                                onChange={(
                                                                                  e
                                                                                ) =>
                                                                                  updateValueOfInputKey(
                                                                                    5,
                                                                                    e
                                                                                      .target
                                                                                      .value,
                                                                                    programCriteriaQuestionDataItem.PID
                                                                                  )
                                                                                }
                                                                              ></input>
                                                                            </>
                                                                          )}
                                                                          {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                            1 ||
                                                                            programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              2 ||
                                                                            programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              4) && (
                                                                            <>
                                                                              <InputMask
                                                                                Disabled={
                                                                                  scorecardData.CanInputActualsData ==
                                                                                    0 ||
                                                                                  globalState
                                                                                    .AppAccessLevelData
                                                                                    .DID >
                                                                                    0
                                                                                    ? true
                                                                                    : false
                                                                                }
                                                                                Prefix={
                                                                                  programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                  4
                                                                                    ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                                    : ""
                                                                                }
                                                                                Suffix={
                                                                                  programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                  2
                                                                                    ? "%"
                                                                                    : ""
                                                                                }
                                                                                ToFixed={
                                                                                  0
                                                                                }
                                                                                ClassName=""
                                                                                ColumnName="2"
                                                                                Value={Number(
                                                                                  programCriteriaQuestionDataItem.ActualValue
                                                                                )}
                                                                                PID={
                                                                                  programCriteriaQuestionDataItem.PID
                                                                                }
                                                                                onChangeHandler={
                                                                                  InputMaskOnChangeHandler
                                                                                }
                                                                                onBlurHandler={
                                                                                  InputMaskOnBlurHandler
                                                                                }
                                                                              />
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                      )}

                                                                    {programCriteriaQuestionDataItem.IsHideActual ==
                                                                      0 &&
                                                                      programCriteriaQuestionDataItem.LinkActualTo !=
                                                                        1 && (
                                                                        <div className="t-3">
                                                                          <span>
                                                                            {
                                                                              programCriteriaQuestionDataItem.ActualValue
                                                                            }
                                                                          </span>
                                                                          {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                            2 && (
                                                                            <span>
                                                                              %
                                                                            </span>
                                                                          )}
                                                                        </div>
                                                                      )}
                                                                  </div>
                                                                )}

                                                                {programCriteriaQuestionDataItem.QuestionType ==
                                                                  4 && (
                                                                  <div className="t-1">
                                                                    {indexSecondLevelInput ==
                                                                      0 &&
                                                                      programCriteriaQuestionDataItem.IsHideActual ==
                                                                        0 &&
                                                                      programCriteriaQuestionDataItem.IsShowHeader && (
                                                                        <span className="t-2">
                                                                          {
                                                                            programCriteriaQuestionDataItem.Actual2Title
                                                                          }
                                                                        </span>
                                                                      )}
                                                                    {programCriteriaQuestionDataItem.IsHideActual ==
                                                                      0 &&
                                                                      programCriteriaQuestionDataItem.LinkActualTo ==
                                                                        1 && (
                                                                        <div className="t-3">
                                                                          {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                            1 ||
                                                                            programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              2 ||
                                                                            programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              4) && (
                                                                            <>
                                                                              <InputMask
                                                                                Disabled={
                                                                                  scorecardData.CanInputActualsData ==
                                                                                    0 ||
                                                                                  globalState
                                                                                    .AppAccessLevelData
                                                                                    .DID >
                                                                                    0
                                                                                    ? true
                                                                                    : false
                                                                                }
                                                                                Prefix={
                                                                                  programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                  4
                                                                                    ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                                    : ""
                                                                                }
                                                                                Suffix={
                                                                                  programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                  2
                                                                                    ? "%"
                                                                                    : ""
                                                                                }
                                                                                ToFixed={
                                                                                  0
                                                                                }
                                                                                ClassName=""
                                                                                ColumnName="6"
                                                                                Value={Number(
                                                                                  programCriteriaQuestionDataItem.Actual2Value
                                                                                )}
                                                                                PID={
                                                                                  programCriteriaQuestionDataItem.PID
                                                                                }
                                                                                onChangeHandler={
                                                                                  InputMaskOnChangeHandler
                                                                                }
                                                                                onBlurHandler={
                                                                                  InputMaskOnBlurHandler
                                                                                }
                                                                              />
                                                                            </>
                                                                          )}
                                                                        </div>
                                                                      )}

                                                                    {programCriteriaQuestionDataItem.IsHideActual ==
                                                                      0 &&
                                                                      programCriteriaQuestionDataItem.LinkActualTo !=
                                                                        1 && (
                                                                        <div className="t-3">
                                                                          <span>
                                                                            {
                                                                              programCriteriaQuestionDataItem.ActualValue
                                                                            }
                                                                          </span>
                                                                          {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                            2 && (
                                                                            <span>
                                                                              %
                                                                            </span>
                                                                          )}
                                                                        </div>
                                                                      )}
                                                                  </div>
                                                                )}

                                                                <div className="t-1">
                                                                  {indexSecondLevelInput ==
                                                                    0 &&
                                                                    programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                      1 &&
                                                                    (programCriteriaQuestionDataItem.IsHideActual ==
                                                                      0 ||
                                                                      programCriteriaQuestionDataItem.IsHideActual ==
                                                                        undefined) &&
                                                                    programCriteriaQuestionDataItem.LinkActualTo ==
                                                                      1 &&
                                                                    (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      1 ||
                                                                      programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        4) &&
                                                                    programCriteriaQuestionDataItem.IsShowHeader && (
                                                                      <span className="t-2 t-2a">
                                                                        {programCriteriaQuestionDataItem.Actual1Title !=
                                                                          "Actual" && (
                                                                          <span>
                                                                            {
                                                                              programCriteriaQuestionDataItem.Actual1Title
                                                                            }
                                                                            &nbsp;
                                                                          </span>
                                                                        )}
                                                                        %
                                                                      </span>
                                                                    )}
                                                                  {programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                    1 &&
                                                                    (programCriteriaQuestionDataItem.IsHideActual ==
                                                                      0 ||
                                                                      programCriteriaQuestionDataItem.IsHideActual ==
                                                                        undefined) &&
                                                                    programCriteriaQuestionDataItem.LinkActualTo ==
                                                                      1 &&
                                                                    (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      1 ||
                                                                      programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        4) && (
                                                                      <div className="t-emp-per">
                                                                        {programCriteriaQuestionDataItem.TargetValue !=
                                                                          undefined &&
                                                                          programCriteriaQuestionDataItem.TargetValue !=
                                                                            "" &&
                                                                          programCriteriaQuestionDataItem.ActualValue !=
                                                                            undefined &&
                                                                          programCriteriaQuestionDataItem.ActualValue !=
                                                                            "" && (
                                                                            <div className="t-3">
                                                                              {programCriteriaQuestionDataItem.TargetValue !=
                                                                                0 && (
                                                                                <>
                                                                                  {Number(
                                                                                    (programCriteriaQuestionDataItem.ActualValue /
                                                                                      programCriteriaQuestionDataItem.TargetValue) *
                                                                                      100
                                                                                  ).toFixed(
                                                                                    2
                                                                                  )}
                                                                                </>
                                                                              )}
                                                                              {programCriteriaQuestionDataItem.TargetValue ==
                                                                                0 && (
                                                                                <>
                                                                                  100.00
                                                                                </>
                                                                              )}
                                                                              %
                                                                            </div>
                                                                          )}
                                                                      </div>
                                                                    )}
                                                                </div>

                                                                <div className="t-1">
                                                                  {programCriteriaQuestionDataItem.QuestionType ==
                                                                    4 &&
                                                                    indexSecondLevelInput ==
                                                                      0 &&
                                                                    programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                      1 &&
                                                                    (programCriteriaQuestionDataItem.IsHideActual ==
                                                                      0 ||
                                                                      programCriteriaQuestionDataItem.IsHideActual ==
                                                                        undefined) &&
                                                                    programCriteriaQuestionDataItem.LinkActualTo ==
                                                                      1 &&
                                                                    (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      1 ||
                                                                      programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        4) &&
                                                                    programCriteriaQuestionDataItem.IsShowHeader && (
                                                                      <span className="t-2 t-2a">
                                                                        {programCriteriaQuestionDataItem.Actual2Title !=
                                                                          "Actual" && (
                                                                          <span>
                                                                            {
                                                                              programCriteriaQuestionDataItem.Actual2Title
                                                                            }
                                                                            &nbsp;
                                                                          </span>
                                                                        )}
                                                                        %
                                                                      </span>
                                                                    )}
                                                                  {programCriteriaQuestionDataItem.QuestionType ==
                                                                    4 &&
                                                                    programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                      1 &&
                                                                    (programCriteriaQuestionDataItem.IsHideActual ==
                                                                      0 ||
                                                                      programCriteriaQuestionDataItem.IsHideActual ==
                                                                        undefined) &&
                                                                    programCriteriaQuestionDataItem.LinkActualTo ==
                                                                      1 &&
                                                                    (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                      1 ||
                                                                      programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                        4) && (
                                                                      <div className="t-emp-per">
                                                                        {programCriteriaQuestionDataItem.TargetValue !=
                                                                          undefined &&
                                                                          programCriteriaQuestionDataItem.TargetValue !=
                                                                            "" &&
                                                                          programCriteriaQuestionDataItem.Actual2Value !=
                                                                            undefined &&
                                                                          programCriteriaQuestionDataItem.Actual2Value !=
                                                                            "" && (
                                                                            <div className="t-3">
                                                                              {programCriteriaQuestionDataItem.TargetValue !=
                                                                                0 && (
                                                                                <>
                                                                                  {Number(
                                                                                    (programCriteriaQuestionDataItem.Actual2Value /
                                                                                      programCriteriaQuestionDataItem.TargetValue) *
                                                                                      100
                                                                                  ).toFixed(
                                                                                    2
                                                                                  )}
                                                                                </>
                                                                              )}
                                                                              {programCriteriaQuestionDataItem.TargetValue ==
                                                                                0 && (
                                                                                <>
                                                                                  100.00
                                                                                </>
                                                                              )}
                                                                              %
                                                                            </div>
                                                                          )}
                                                                      </div>
                                                                    )}
                                                                </div>
                                                              </>
                                                            )}

                                                            <div className="t-1">
                                                              {indexSecondLevelInput ==
                                                                0 && (
                                                                <>
                                                                  <div className="t-2 t-02"></div>
                                                                </>
                                                              )}
                                                              {indexSecondLevel >=
                                                                0 &&
                                                                programCriteriaQuestionDataItem
                                                                  .ExceptionData
                                                                  ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                  undefined &&
                                                                programCriteriaQuestionDataItem
                                                                  .ExceptionData
                                                                  ?.Status ==
                                                                  1 &&
                                                                programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                  1 && (
                                                                  <>
                                                                    <div className="t-2 e-app">
                                                                      Exception
                                                                      Applied
                                                                    </div>
                                                                  </>
                                                                )}
                                                              <div className="t-3 t-003">
                                                                <select
                                                                  disabled={
                                                                    globalState
                                                                      .AppAccessLevelData
                                                                      .DID >
                                                                      0 ||
                                                                    scorecardData.CanInputActualsData ==
                                                                      0
                                                                      ? true
                                                                      : false
                                                                  }
                                                                  className={`${
                                                                    programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                    "1"
                                                                      ? "GreenClass"
                                                                      : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                        "0"
                                                                      ? "RedClass"
                                                                      : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                        "2"
                                                                      ? "OrangeClass"
                                                                      : ""
                                                                  }`}
                                                                  value={
                                                                    programCriteriaQuestionDataItem.IsTargetAchieved
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    updateValueOfInputKey(
                                                                      3,
                                                                      Number(
                                                                        e.target
                                                                          .value
                                                                      ),
                                                                      programCriteriaQuestionDataItem.PID
                                                                    )
                                                                  }
                                                                >
                                                                  <option value="undefined">
                                                                    Please
                                                                    Select
                                                                  </option>
                                                                  <option value="0">
                                                                    No
                                                                  </option>
                                                                  <option value="1">
                                                                    Yes
                                                                  </option>
                                                                  <option value="2">
                                                                    N/A
                                                                  </option>
                                                                </select>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        {showRetailerLevelDataIDs.indexOf(
                                                          programCriteriaQuestionDataItem.IBBProgramCriteriaQuestionID
                                                        ) > -1 && (
                                                          <>
                                                            {programCriteriaQuestionInputDataRetailerLevel &&
                                                              programCriteriaQuestionInputDataRetailerLevel.map(
                                                                (
                                                                  retailer: any,
                                                                  retailerIndex: any
                                                                ) => (
                                                                  <>
                                                                    {retailer.IBBProgramCriteriaQuestionID ==
                                                                      programCriteriaQuestionDataItem.PID && (
                                                                      <div
                                                                        className="level-1 level-2 t-01"
                                                                        key={
                                                                          retailer.IBBProgramCriteriaQuestionID +
                                                                          "-" +
                                                                          retailer.IBBProgramCriteriaQuestionInputID
                                                                        }
                                                                      >
                                                                        <span></span>
                                                                        <div className="t001">
                                                                          <span className="spn-alg slg-child">
                                                                            {
                                                                              retailer.ObjectName
                                                                            }
                                                                          </span>
                                                                          <div className="t-1">
                                                                            <div className="t-3 t-rg custom-tip tip-center">
                                                                              <InputMask
                                                                                Disabled={
                                                                                  programCriteriaQuestionDataItem.QuestionType !=
                                                                                    3 ||
                                                                                  scorecardData.CanInputTargetsData ==
                                                                                    0 ||
                                                                                  globalState
                                                                                    .AppAccessLevelData
                                                                                    .DID >
                                                                                    0
                                                                                    ? true
                                                                                    : false
                                                                                }
                                                                                Prefix={
                                                                                  programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                  4
                                                                                    ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                                    : ""
                                                                                }
                                                                                Suffix={
                                                                                  programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                  2
                                                                                    ? "%"
                                                                                    : ""
                                                                                }
                                                                                ToFixed={
                                                                                  0
                                                                                }
                                                                                ClassName=""
                                                                                ColumnName="1"
                                                                                Value={Number(
                                                                                  retailer.Target1
                                                                                )}
                                                                                PID={
                                                                                  retailer.IBBProgramCriteriaQuestionInputID
                                                                                }
                                                                                onChangeHandler={
                                                                                  InputMaskOnChangeHandler
                                                                                }
                                                                                onBlurHandler={
                                                                                  InputMaskOnBlurHandler
                                                                                }
                                                                              />
                                                                            </div>
                                                                          </div>
                                                                          {programCriteriaQuestionDataItem.IsHideActual ==
                                                                            0 && (
                                                                            <div className="t-1">
                                                                              <div className="t-3 t-rg custom-tip tip-center">
                                                                                <InputMask
                                                                                  Disabled={
                                                                                    scorecardData.CanInputActualsData ==
                                                                                      0 ||
                                                                                    globalState
                                                                                      .AppAccessLevelData
                                                                                      .DID >
                                                                                      0
                                                                                      ? true
                                                                                      : false
                                                                                  }
                                                                                  Prefix={
                                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                    4
                                                                                      ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                                      : ""
                                                                                  }
                                                                                  Suffix={
                                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                    2
                                                                                      ? "%"
                                                                                      : ""
                                                                                  }
                                                                                  ToFixed={
                                                                                    0
                                                                                  }
                                                                                  ClassName=""
                                                                                  ColumnName="1"
                                                                                  Value={Number(
                                                                                    retailer.Actual1
                                                                                  )}
                                                                                  PID={
                                                                                    retailer.IBBProgramCriteriaQuestionInputID
                                                                                  }
                                                                                  onChangeHandler={
                                                                                    InputMaskOnChangeHandler
                                                                                  }
                                                                                  onBlurHandler={
                                                                                    InputMaskOnBlurHandler
                                                                                  }
                                                                                />
                                                                              </div>
                                                                            </div>
                                                                          )}
                                                                          {programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                            1 &&
                                                                            programCriteriaQuestionDataItem.ActualValueFormat !=
                                                                              2 && (
                                                                              <div className="t-1">
                                                                                <div className="t-emp-per">
                                                                                  {retailer.Actual1 !=
                                                                                    "" &&
                                                                                    retailer.Target1 !=
                                                                                      "" && (
                                                                                      <>
                                                                                        {Number(
                                                                                          (retailer.Actual1 /
                                                                                            retailer.Target1) *
                                                                                            100
                                                                                        ).toFixed(
                                                                                          2
                                                                                        )}

                                                                                        %
                                                                                      </>
                                                                                    )}
                                                                                </div>
                                                                              </div>
                                                                            )}
                                                                          <div className="t-1">
                                                                            <div className="t-3 t-003">
                                                                              <select
                                                                                disabled={
                                                                                  globalState
                                                                                    .AppAccessLevelData
                                                                                    .DID >
                                                                                    0 ||
                                                                                  scorecardData.CanInputActualsData ==
                                                                                    0
                                                                                    ? true
                                                                                    : false
                                                                                }
                                                                                className={`${
                                                                                  retailer.FinalResult ==
                                                                                  "1"
                                                                                    ? "GreenClass"
                                                                                    : retailer.FinalResult ==
                                                                                      "0"
                                                                                    ? "RedClass"
                                                                                    : retailer.FinalResult ==
                                                                                      "2"
                                                                                    ? "OrangeClass"
                                                                                    : ""
                                                                                }`}
                                                                                value={
                                                                                  retailer.FinalResult
                                                                                }
                                                                                onChange={(
                                                                                  e
                                                                                ) =>
                                                                                  updateValueOfInputKey(
                                                                                    3,
                                                                                    Number(
                                                                                      e
                                                                                        .target
                                                                                        .value
                                                                                    ),
                                                                                    retailer.IBBProgramCriteriaQuestionInputID
                                                                                  )
                                                                                }
                                                                              >
                                                                                <option value="undefined">
                                                                                  Please
                                                                                  Select
                                                                                </option>
                                                                                <option value="0">
                                                                                  No
                                                                                </option>
                                                                                <option value="1">
                                                                                  Yes
                                                                                </option>
                                                                                <option value="2">
                                                                                  N/A
                                                                                </option>
                                                                              </select>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    )}
                                                                  </>
                                                                )
                                                              )}
                                                          </>
                                                        )}
                                                      </React.Fragment>
                                                    )
                                                  )}
                                              </div>

                                              {secondLevel.ChildData &&
                                                secondLevel.ChildData.map(
                                                  (
                                                    thirdLevel: any,
                                                    indexThirdLevel: any
                                                  ) => (
                                                    <React.Fragment
                                                      key={
                                                        indexSection +
                                                        "-" +
                                                        thirdLevel.PID
                                                      }
                                                    >
                                                      <div
                                                        className={`${
                                                          ShowEditMode === true
                                                            ? "hover-back"
                                                            : ""
                                                        }`}
                                                      >
                                                        <div className="level-1 level-3">
                                                          {thirdLevel.programCriteriaQuestionData ==
                                                            undefined ||
                                                            (thirdLevel
                                                              .programCriteriaQuestionData
                                                              .length == 0 && (
                                                              <span
                                                                className={
                                                                  thirdLevel.FormattingOptions
                                                                }
                                                              >
                                                                {thirdLevel.SerialNumber !=
                                                                  undefined &&
                                                                  thirdLevel.SerialNumber !=
                                                                    "" && (
                                                                    <>
                                                                      {
                                                                        thirdLevel.SerialNumber
                                                                      }
                                                                      -
                                                                    </>
                                                                  )}{" "}
                                                                {
                                                                  thirdLevel.Title
                                                                }
                                                              </span>
                                                            ))}
                                                          {ShowEditMode && (
                                                            <div className="g-buttons">
                                                              {/* <a title="Move Down">
                                                      <img
                                                        width="13px"
                                                        height="13px"
                                                        alt="Move Down"
                                                        src="images/aw-down.svg"
                                                      />
                                                    </a>
                                                    <a title="Move Up">
                                                      <img
                                                        width="13px"
                                                        height="13px"
                                                        alt="Move Up"
                                                        src="images/aw-up.svg"
                                                      />
                                                    </a> */}
                                                              <a
                                                                title="Delete"
                                                                // onClick={() =>
                                                                //   IBBProgramCriteriaDeleteRecord(
                                                                //     thirdLevel.PID
                                                                //   )
                                                                // }
                                                                onClick={() => {
                                                                  globalState.setConfirmationObject(
                                                                    {
                                                                      ShowPopup:
                                                                        true,
                                                                      Heading:
                                                                        "Confirmation ",
                                                                      Message:
                                                                        "Are you sure you want to delete this record?",
                                                                      ID: 1,
                                                                      SelectedID:
                                                                        thirdLevel.PID,
                                                                    }
                                                                  );
                                                                }}
                                                              >
                                                                <img
                                                                  width="17px"
                                                                  height="17px"
                                                                  alt="Delete"
                                                                  src="images/delete.svg"
                                                                />
                                                              </a>
                                                              <a
                                                                title="Edit"
                                                                onClick={() => {
                                                                  setEntriesModal(
                                                                    true
                                                                  );
                                                                  entriesObject.SectionID =
                                                                    section.SectionID;
                                                                  entriesObject.ParentID =
                                                                    thirdLevel.ParentID;
                                                                  entriesObject.Title =
                                                                    thirdLevel.Title;
                                                                  entriesObject.Description =
                                                                    thirdLevel.Description;
                                                                  entriesObject.SerialNumber =
                                                                    thirdLevel.SerialNumber;
                                                                  entriesObject.PID =
                                                                    thirdLevel.PID;
                                                                  entriesObject.IsInputLevel =
                                                                    thirdLevel.IsInputLevel;
                                                                  entriesObject.FormattingOptions =
                                                                    thirdLevel.FormattingOptions;
                                                                  entriesObject.SplitPercentage =
                                                                    thirdLevel.SplitPercentage;
                                                                  assignprogramCriteriaQuestionData(
                                                                    entriesObject.PID
                                                                  );
                                                                }}
                                                              >
                                                                <img
                                                                  width="17px"
                                                                  height="17px"
                                                                  alt="Edit"
                                                                  src="images/edit.svg"
                                                                />
                                                              </a>
                                                              <a
                                                                className="no-display"
                                                                title="Add"
                                                                onClick={() => {
                                                                  setEntriesModal(
                                                                    true
                                                                  );
                                                                  let entriesObjectLocal =
                                                                    {} as any;
                                                                  entriesObjectLocal.SectionID =
                                                                    section.SectionID;
                                                                  entriesObjectLocal.ParentID =
                                                                    thirdLevel.PID;
                                                                  entriesObjectLocal.PID = 0;
                                                                  entriesObjectLocal.Description =
                                                                    "2";
                                                                  setEntriesObject(
                                                                    entriesObjectLocal
                                                                  );
                                                                }}
                                                              >
                                                                <img
                                                                  width="17px"
                                                                  height="17px"
                                                                  alt="Add"
                                                                  src="images/add.svg"
                                                                />
                                                              </a>
                                                            </div>
                                                          )}
                                                        </div>

                                                        {thirdLevel.programCriteriaQuestionData &&
                                                          thirdLevel.programCriteriaQuestionData.map(
                                                            (
                                                              programCriteriaQuestionDataItem: any,
                                                              indexThirdLevelInput: any
                                                            ) => (
                                                              <React.Fragment
                                                                key={
                                                                  indexSection +
                                                                  "-" +
                                                                  thirdLevel.PID +
                                                                  "-" +
                                                                  programCriteriaQuestionDataItem.PID +
                                                                  "-" +
                                                                  indexThirdLevelInput
                                                                }
                                                              >
                                                                <div className="level-1 level-3 t-01">
                                                                  {indexThirdLevelInput ==
                                                                    0 && (
                                                                    <span></span>
                                                                  )}
                                                                  {indexThirdLevelInput >
                                                                    0 && (
                                                                    <span className="spn-alg"></span>
                                                                  )}
                                                                  <div className="t001">
                                                                    {!ShowEditMode &&
                                                                      scorecardData.CanAddException ==
                                                                        1 &&
                                                                      ((getAccessSettings(
                                                                        2,
                                                                        27
                                                                      ) > 1 &&
                                                                        globalState
                                                                          .AppAccessLevelData
                                                                          .DID >
                                                                          0) ||
                                                                        (getAccessSettings(
                                                                          1,
                                                                          section.IBBDepartmentID
                                                                        ) > 1 &&
                                                                          globalState
                                                                            .AppAccessLevelData
                                                                            .DID ==
                                                                            0)) && (
                                                                        <>
                                                                          {programCriteriaQuestionDataItem
                                                                            .ExceptionData
                                                                            ?.ConditionText !=
                                                                            undefined &&
                                                                          programCriteriaQuestionDataItem
                                                                            .ExceptionData
                                                                            ?.ConditionText !=
                                                                            "" ? (
                                                                            <div className="g-buttons exp-trg">
                                                                              {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                                "0" ||
                                                                                programCriteriaQuestionDataItem
                                                                                  .ExceptionData
                                                                                  ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                                  undefined) && (
                                                                                <a
                                                                                  className={`${
                                                                                    programCriteriaQuestionDataItem
                                                                                      .ExceptionData
                                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                                    undefined
                                                                                      ? programCriteriaQuestionDataItem
                                                                                          .ExceptionData
                                                                                          ?.ConditionStatus ==
                                                                                        1
                                                                                        ? programCriteriaQuestionDataItem
                                                                                            .ExceptionData
                                                                                            ?.ConditionText !=
                                                                                          ""
                                                                                          ? "g-excep"
                                                                                          : "g-excep"
                                                                                        : programCriteriaQuestionDataItem
                                                                                            .ExceptionData
                                                                                            ?.ConditionStatus ==
                                                                                          2
                                                                                        ? "r-excep"
                                                                                        : "y-excep"
                                                                                      : ""
                                                                                  }`}
                                                                                  title={
                                                                                    programCriteriaQuestionDataItem
                                                                                      .ExceptionData
                                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                                    undefined
                                                                                      ? programCriteriaQuestionDataItem
                                                                                          .ExceptionData
                                                                                          ?.Status ==
                                                                                        0
                                                                                        ? "Edit Exception"
                                                                                        : "View Exception"
                                                                                      : "Add Exception"
                                                                                  }
                                                                                  onClick={() => {
                                                                                    assignExceptionDataToObject(
                                                                                      section,
                                                                                      thirdLevel,
                                                                                      programCriteriaQuestionDataItem
                                                                                    );
                                                                                  }}
                                                                                >
                                                                                  <img
                                                                                    src="images/hold.svg"
                                                                                    width="17px"
                                                                                    height="17px"
                                                                                  />
                                                                                </a>
                                                                              )}
                                                                            </div>
                                                                          ) : (
                                                                            <div className="g-buttons exp-trg">
                                                                              {(programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                                "0" ||
                                                                                programCriteriaQuestionDataItem
                                                                                  .ExceptionData
                                                                                  ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                                  undefined) && (
                                                                                <a
                                                                                  className={`${
                                                                                    programCriteriaQuestionDataItem
                                                                                      .ExceptionData
                                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                                    undefined
                                                                                      ? programCriteriaQuestionDataItem
                                                                                          .ExceptionData
                                                                                          ?.Status ==
                                                                                        1
                                                                                        ? programCriteriaQuestionDataItem
                                                                                            .ExceptionData
                                                                                            ?.ConditionText !=
                                                                                          ""
                                                                                          ? "g-excep"
                                                                                          : "g-excep"
                                                                                        : programCriteriaQuestionDataItem
                                                                                            .ExceptionData
                                                                                            ?.Status ==
                                                                                          2
                                                                                        ? "r-excep"
                                                                                        : "y-excep"
                                                                                      : ""
                                                                                  }`}
                                                                                  title={
                                                                                    programCriteriaQuestionDataItem
                                                                                      .ExceptionData
                                                                                      ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                                    undefined
                                                                                      ? programCriteriaQuestionDataItem
                                                                                          .ExceptionData
                                                                                          ?.Status ==
                                                                                        0
                                                                                        ? "Edit Exception"
                                                                                        : "View Exception"
                                                                                      : "Add Exception"
                                                                                  }
                                                                                  onClick={() => {
                                                                                    assignExceptionDataToObject(
                                                                                      section,
                                                                                      thirdLevel,
                                                                                      programCriteriaQuestionDataItem
                                                                                    );
                                                                                  }}
                                                                                >
                                                                                  <img
                                                                                    src="images/exception.svg"
                                                                                    width="17px"
                                                                                    height="17px"
                                                                                  />
                                                                                </a>
                                                                              )}
                                                                            </div>
                                                                          )}
                                                                        </>
                                                                      )}
                                                                    {indexThirdLevelInput ==
                                                                      0 &&
                                                                      programCriteriaQuestionDataItem.QuestionType !=
                                                                        3 && (
                                                                        <span
                                                                          className={
                                                                            "spn-alg " +
                                                                            thirdLevel.FormattingOptions
                                                                          }
                                                                        >
                                                                          {thirdLevel.SerialNumber !=
                                                                            undefined &&
                                                                            thirdLevel.SerialNumber !=
                                                                              "" && (
                                                                              <>
                                                                                {
                                                                                  thirdLevel.SerialNumber
                                                                                }

                                                                                -
                                                                              </>
                                                                            )}{" "}
                                                                          {
                                                                            thirdLevel.Title
                                                                          }
                                                                        </span>
                                                                      )}

                                                                    {(programCriteriaQuestionDataItem.QuestionType ==
                                                                      2 ||
                                                                      programCriteriaQuestionDataItem.QuestionType ==
                                                                        4 ||
                                                                      programCriteriaQuestionDataItem.QuestionType ==
                                                                        3) && (
                                                                      <>
                                                                        <div className="t-1 t-1-lg">
                                                                          {indexThirdLevelInput ==
                                                                            0 &&
                                                                            programCriteriaQuestionDataItem.QuestionType ==
                                                                              3 && (
                                                                              <div className="t-2">
                                                                                {thirdLevel.SerialNumber !=
                                                                                  undefined &&
                                                                                  thirdLevel.SerialNumber !=
                                                                                    "" && (
                                                                                    <>
                                                                                      {
                                                                                        thirdLevel.SerialNumber
                                                                                      }

                                                                                      -
                                                                                    </>
                                                                                  )}{" "}
                                                                                {
                                                                                  thirdLevel.Title
                                                                                }
                                                                              </div>
                                                                            )}

                                                                          {programCriteriaQuestionDataItem.QuestionType ==
                                                                            3 && (
                                                                            <div className="t-3 custom-tip">
                                                                              {programCriteriaQuestionDataItem.IsShowTargetSN && (
                                                                                <span className="tip-ab">
                                                                                  {indexThirdLevelInput +
                                                                                    1}

                                                                                  .{" "}
                                                                                </span>
                                                                              )}
                                                                              <p
                                                                                className="p-top"
                                                                                id={
                                                                                  "TargetTextValue" +
                                                                                  programCriteriaQuestionDataItem.PID
                                                                                }
                                                                                onClick={() =>
                                                                                  hideDivAndShowInput(
                                                                                    "TargetTextValue" +
                                                                                      programCriteriaQuestionDataItem.PID,
                                                                                    "TargetTextValueInput" +
                                                                                      programCriteriaQuestionDataItem.PID
                                                                                  )
                                                                                }
                                                                              >
                                                                                {
                                                                                  programCriteriaQuestionDataItem.TargetTextValue
                                                                                }
                                                                              </p>
                                                                              <input
                                                                                disabled={
                                                                                  programCriteriaQuestionDataItem.QuestionType !=
                                                                                    3 ||
                                                                                  scorecardData.CanInputTargetsData ==
                                                                                    0 ||
                                                                                  globalState
                                                                                    .AppAccessLevelData
                                                                                    .DID >
                                                                                    0
                                                                                    ? true
                                                                                    : false
                                                                                }
                                                                                id={
                                                                                  "TargetTextValueInput" +
                                                                                  programCriteriaQuestionDataItem.PID
                                                                                }
                                                                                className="box-tag b-rg"
                                                                                type="text"
                                                                                value={
                                                                                  programCriteriaQuestionDataItem.TargetTextValue
                                                                                }
                                                                                onBlur={(
                                                                                  e
                                                                                ) => {
                                                                                  saveInputData(
                                                                                    programCriteriaQuestionDataItem
                                                                                  );
                                                                                  displayDiv(
                                                                                    "TargetTextValue" +
                                                                                      programCriteriaQuestionDataItem.PID
                                                                                  );
                                                                                }}
                                                                                onChange={(
                                                                                  e
                                                                                ) =>
                                                                                  updateValueOfInputKey(
                                                                                    4,
                                                                                    e
                                                                                      .target
                                                                                      .value,
                                                                                    programCriteriaQuestionDataItem.PID
                                                                                  )
                                                                                }
                                                                              ></input>
                                                                            </div>
                                                                          )}
                                                                        </div>

                                                                        <div className="t-1">
                                                                          {indexThirdLevelInput ==
                                                                            0 &&
                                                                            programCriteriaQuestionDataItem.IsShowHeader &&
                                                                            ((programCriteriaQuestionDataItem.QuestionType ==
                                                                              3 &&
                                                                              programCriteriaQuestionDataItem.IsShowTextTarget) ||
                                                                              programCriteriaQuestionDataItem.QuestionType !=
                                                                                3) && (
                                                                              <span className="t-2">
                                                                                Target
                                                                              </span>
                                                                            )}
                                                                          <>
                                                                            {(programCriteriaQuestionDataItem.QuestionType ==
                                                                              2 ||
                                                                              programCriteriaQuestionDataItem.QuestionType ==
                                                                                4 ||
                                                                              (programCriteriaQuestionDataItem.QuestionType ==
                                                                                3 &&
                                                                                programCriteriaQuestionDataItem.IsShowTextTarget)) && (
                                                                              <div className="t-3 t-rg custom-tip tip-center">
                                                                                {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                                                  1 &&
                                                                                  (programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                    1 ||
                                                                                    programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                      2 ||
                                                                                    programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                      4) && (
                                                                                    <>
                                                                                      <InputMask
                                                                                        Disabled={
                                                                                          programCriteriaQuestionDataItem.QuestionType !=
                                                                                            3 ||
                                                                                          scorecardData.CanInputTargetsData ==
                                                                                            0 ||
                                                                                          globalState
                                                                                            .AppAccessLevelData
                                                                                            .DID >
                                                                                            0
                                                                                            ? true
                                                                                            : false
                                                                                        }
                                                                                        Prefix={
                                                                                          programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                          4
                                                                                            ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                                            : ""
                                                                                        }
                                                                                        Suffix={
                                                                                          programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                          2
                                                                                            ? "%"
                                                                                            : ""
                                                                                        }
                                                                                        ToFixed={
                                                                                          0
                                                                                        }
                                                                                        ClassName=""
                                                                                        ColumnName="1"
                                                                                        Value={Number(
                                                                                          programCriteriaQuestionDataItem.TargetValue
                                                                                        )}
                                                                                        PID={
                                                                                          programCriteriaQuestionDataItem.PID
                                                                                        }
                                                                                        onChangeHandler={
                                                                                          InputMaskOnChangeHandler
                                                                                        }
                                                                                        onBlurHandler={
                                                                                          InputMaskOnBlurHandler
                                                                                        }
                                                                                      />
                                                                                    </>
                                                                                  )}

                                                                                {programCriteriaQuestionDataItem.LinkTargetTo ==
                                                                                  1 &&
                                                                                  programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                    3 && (
                                                                                    <>
                                                                                      <p
                                                                                        className="p-top"
                                                                                        id={
                                                                                          "TargetValue" +
                                                                                          programCriteriaQuestionDataItem.PID
                                                                                        }
                                                                                        onClick={() =>
                                                                                          hideDivAndShowInput(
                                                                                            "TargetValue" +
                                                                                              programCriteriaQuestionDataItem.PID,
                                                                                            "TargetValueInput" +
                                                                                              programCriteriaQuestionDataItem.PID
                                                                                          )
                                                                                        }
                                                                                      >
                                                                                        {
                                                                                          programCriteriaQuestionDataItem.TargetValue
                                                                                        }
                                                                                      </p>
                                                                                      <input
                                                                                        disabled={
                                                                                          programCriteriaQuestionDataItem.QuestionType !=
                                                                                            3 ||
                                                                                          scorecardData.CanInputTargetsData ==
                                                                                            0 ||
                                                                                          globalState
                                                                                            .AppAccessLevelData
                                                                                            .DID >
                                                                                            0
                                                                                            ? true
                                                                                            : false
                                                                                        }
                                                                                        id={
                                                                                          "TargetValueInput" +
                                                                                          programCriteriaQuestionDataItem.PID
                                                                                        }
                                                                                        className="box-tag"
                                                                                        type="text"
                                                                                        value={
                                                                                          programCriteriaQuestionDataItem.TargetValue
                                                                                        }
                                                                                        onBlur={(
                                                                                          e
                                                                                        ) => {
                                                                                          saveInputData(
                                                                                            programCriteriaQuestionDataItem
                                                                                          );
                                                                                          displayDiv(
                                                                                            "TargetValue" +
                                                                                              programCriteriaQuestionDataItem.PID
                                                                                          );
                                                                                        }}
                                                                                        onChange={(
                                                                                          e
                                                                                        ) =>
                                                                                          updateValueOfInputKey(
                                                                                            1,
                                                                                            e
                                                                                              .target
                                                                                              .value,
                                                                                            programCriteriaQuestionDataItem.PID
                                                                                          )
                                                                                        }
                                                                                      ></input>
                                                                                      {programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                        2 && (
                                                                                        <span>
                                                                                          %
                                                                                        </span>
                                                                                      )}
                                                                                    </>
                                                                                  )}

                                                                                {programCriteriaQuestionDataItem.LinkTargetTo !=
                                                                                  1 && (
                                                                                  <>
                                                                                    <span>
                                                                                      {
                                                                                        programCriteriaQuestionDataItem.TargetValue
                                                                                      }
                                                                                    </span>
                                                                                    {programCriteriaQuestionDataItem.TargetValueFormat ==
                                                                                      2 && (
                                                                                      <span>
                                                                                        %
                                                                                      </span>
                                                                                    )}
                                                                                  </>
                                                                                )}
                                                                              </div>
                                                                            )}
                                                                          </>
                                                                        </div>

                                                                        {(programCriteriaQuestionDataItem.ActualValueFormat !=
                                                                          3 ||
                                                                          (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                            3 &&
                                                                            programCriteriaQuestionDataItem.IsShowActualNotes)) && (
                                                                          <div className="t-1">
                                                                            {indexThirdLevelInput ==
                                                                              0 &&
                                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                                0 &&
                                                                              programCriteriaQuestionDataItem.IsShowHeader && (
                                                                                <span className="t-2">
                                                                                  {
                                                                                    programCriteriaQuestionDataItem.Actual1Title
                                                                                  }
                                                                                </span>
                                                                              )}
                                                                            {programCriteriaQuestionDataItem.IsHideActual ==
                                                                              0 &&
                                                                              programCriteriaQuestionDataItem.LinkActualTo ==
                                                                                1 && (
                                                                                <div className="t-3 custom-tip tip-center">
                                                                                  {programCriteriaQuestionDataItem.IsShowActualNotes && (
                                                                                    <>
                                                                                      <p
                                                                                        className="p-top"
                                                                                        id={
                                                                                          "Actual2Value" +
                                                                                          programCriteriaQuestionDataItem.PID
                                                                                        }
                                                                                        onClick={() =>
                                                                                          hideDivAndShowInput(
                                                                                            "Actual2Value" +
                                                                                              programCriteriaQuestionDataItem.PID,
                                                                                            "Actual2ValueInput" +
                                                                                              programCriteriaQuestionDataItem.PID
                                                                                          )
                                                                                        }
                                                                                      >
                                                                                        {
                                                                                          programCriteriaQuestionDataItem.Actual2Value
                                                                                        }
                                                                                      </p>
                                                                                      <input
                                                                                        disabled={
                                                                                          scorecardData.CanInputActualsData ==
                                                                                            0 ||
                                                                                          globalState
                                                                                            .AppAccessLevelData
                                                                                            .DID >
                                                                                            0
                                                                                            ? true
                                                                                            : false
                                                                                        }
                                                                                        id={
                                                                                          "Actual2ValueInput" +
                                                                                          programCriteriaQuestionDataItem.PID
                                                                                        }
                                                                                        className="box-act"
                                                                                        type="text"
                                                                                        value={
                                                                                          programCriteriaQuestionDataItem.Actual2Value
                                                                                        }
                                                                                        onBlur={(
                                                                                          e
                                                                                        ) => {
                                                                                          saveInputData(
                                                                                            programCriteriaQuestionDataItem
                                                                                          );
                                                                                          displayDiv(
                                                                                            "Actual2Value" +
                                                                                              programCriteriaQuestionDataItem.PID
                                                                                          );
                                                                                        }}
                                                                                        onChange={(
                                                                                          e
                                                                                        ) =>
                                                                                          updateValueOfInputKey(
                                                                                            5,
                                                                                            e
                                                                                              .target
                                                                                              .value,
                                                                                            programCriteriaQuestionDataItem.PID
                                                                                          )
                                                                                        }
                                                                                      ></input>
                                                                                    </>
                                                                                  )}
                                                                                  {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                    1 ||
                                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                      2 ||
                                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                      4) && (
                                                                                    <>
                                                                                      <InputMask
                                                                                        Disabled={
                                                                                          scorecardData.CanInputActualsData ==
                                                                                            0 ||
                                                                                          globalState
                                                                                            .AppAccessLevelData
                                                                                            .DID >
                                                                                            0
                                                                                            ? true
                                                                                            : false
                                                                                        }
                                                                                        Prefix={
                                                                                          programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                          4
                                                                                            ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                                            : ""
                                                                                        }
                                                                                        Suffix={
                                                                                          programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                          2
                                                                                            ? "%"
                                                                                            : ""
                                                                                        }
                                                                                        ToFixed={
                                                                                          0
                                                                                        }
                                                                                        ClassName=""
                                                                                        ColumnName="2"
                                                                                        Value={Number(
                                                                                          programCriteriaQuestionDataItem.ActualValue
                                                                                        )}
                                                                                        PID={
                                                                                          programCriteriaQuestionDataItem.PID
                                                                                        }
                                                                                        onChangeHandler={
                                                                                          InputMaskOnChangeHandler
                                                                                        }
                                                                                        onBlurHandler={
                                                                                          InputMaskOnBlurHandler
                                                                                        }
                                                                                      />
                                                                                    </>
                                                                                  )}
                                                                                </div>
                                                                              )}

                                                                            {programCriteriaQuestionDataItem.IsHideActual ==
                                                                              0 &&
                                                                              programCriteriaQuestionDataItem.LinkActualTo !=
                                                                                1 && (
                                                                                <div className="t-3">
                                                                                  <span>
                                                                                    {
                                                                                      programCriteriaQuestionDataItem.ActualValue
                                                                                    }
                                                                                  </span>
                                                                                  {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                    2 && (
                                                                                    <span>
                                                                                      %
                                                                                    </span>
                                                                                  )}
                                                                                </div>
                                                                              )}
                                                                          </div>
                                                                        )}

                                                                        {programCriteriaQuestionDataItem.QuestionType ==
                                                                          4 && (
                                                                          <div className="t-1">
                                                                            {indexThirdLevelInput ==
                                                                              0 &&
                                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                                0 &&
                                                                              programCriteriaQuestionDataItem.IsShowHeader && (
                                                                                <span className="t-2">
                                                                                  {
                                                                                    programCriteriaQuestionDataItem.Actual2Title
                                                                                  }
                                                                                </span>
                                                                              )}
                                                                            {programCriteriaQuestionDataItem.IsHideActual ==
                                                                              0 &&
                                                                              programCriteriaQuestionDataItem.LinkActualTo ==
                                                                                1 && (
                                                                                <div className="t-3">
                                                                                  {(programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                    1 ||
                                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                      2 ||
                                                                                    programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                      4) && (
                                                                                    <>
                                                                                      <InputMask
                                                                                        Disabled={
                                                                                          scorecardData.CanInputActualsData ==
                                                                                            0 ||
                                                                                          globalState
                                                                                            .AppAccessLevelData
                                                                                            .DID >
                                                                                            0
                                                                                            ? true
                                                                                            : false
                                                                                        }
                                                                                        Prefix={
                                                                                          programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                          4
                                                                                            ? programCriteriaQuestionDataItem.CurrencyIcon
                                                                                            : ""
                                                                                        }
                                                                                        Suffix={
                                                                                          programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                          2
                                                                                            ? "%"
                                                                                            : ""
                                                                                        }
                                                                                        ToFixed={
                                                                                          0
                                                                                        }
                                                                                        ClassName=""
                                                                                        ColumnName="6"
                                                                                        Value={Number(
                                                                                          programCriteriaQuestionDataItem.Actual2Value
                                                                                        )}
                                                                                        PID={
                                                                                          programCriteriaQuestionDataItem.PID
                                                                                        }
                                                                                        onChangeHandler={
                                                                                          InputMaskOnChangeHandler
                                                                                        }
                                                                                        onBlurHandler={
                                                                                          InputMaskOnBlurHandler
                                                                                        }
                                                                                      />
                                                                                    </>
                                                                                  )}
                                                                                </div>
                                                                              )}

                                                                            {programCriteriaQuestionDataItem.IsHideActual ==
                                                                              0 &&
                                                                              programCriteriaQuestionDataItem.LinkActualTo !=
                                                                                1 && (
                                                                                <div className="t-3">
                                                                                  <span>
                                                                                    {
                                                                                      programCriteriaQuestionDataItem.ActualValue
                                                                                    }
                                                                                  </span>
                                                                                  {programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                    2 && (
                                                                                    <span>
                                                                                      %
                                                                                    </span>
                                                                                  )}
                                                                                </div>
                                                                              )}
                                                                          </div>
                                                                        )}
                                                                        <div className="t-1">
                                                                          {indexThirdLevelInput ==
                                                                            0 &&
                                                                            programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                              1 &&
                                                                            (programCriteriaQuestionDataItem.IsHideActual ==
                                                                              0 ||
                                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                                undefined) &&
                                                                            programCriteriaQuestionDataItem.LinkActualTo ==
                                                                              1 &&
                                                                            (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              1 ||
                                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                4) &&
                                                                            programCriteriaQuestionDataItem.IsShowHeader && (
                                                                              <span className="t-2 t-2a">
                                                                                {programCriteriaQuestionDataItem.Actual1Title !=
                                                                                  "Actual" && (
                                                                                  <span>
                                                                                    {
                                                                                      programCriteriaQuestionDataItem.Actual1Title
                                                                                    }
                                                                                    &nbsp;
                                                                                  </span>
                                                                                )}

                                                                                %
                                                                              </span>
                                                                            )}
                                                                          {programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                            1 &&
                                                                            (programCriteriaQuestionDataItem.IsHideActual ==
                                                                              0 ||
                                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                                undefined) &&
                                                                            programCriteriaQuestionDataItem.LinkActualTo ==
                                                                              1 &&
                                                                            (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              1 ||
                                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                4) && (
                                                                              <div className="t-emp-per">
                                                                                {programCriteriaQuestionDataItem.TargetValue !=
                                                                                  undefined &&
                                                                                  programCriteriaQuestionDataItem.TargetValue !=
                                                                                    "" &&
                                                                                  programCriteriaQuestionDataItem.ActualValue !=
                                                                                    undefined &&
                                                                                  programCriteriaQuestionDataItem.ActualValue !=
                                                                                    "" && (
                                                                                    <div className="t-3">
                                                                                      {programCriteriaQuestionDataItem.TargetValue !=
                                                                                        0 && (
                                                                                        <>
                                                                                          {Number(
                                                                                            (programCriteriaQuestionDataItem.ActualValue /
                                                                                              programCriteriaQuestionDataItem.TargetValue) *
                                                                                              100
                                                                                          ).toFixed(
                                                                                            2
                                                                                          )}
                                                                                        </>
                                                                                      )}
                                                                                      {programCriteriaQuestionDataItem.TargetValue ==
                                                                                        0 && (
                                                                                        <>
                                                                                          100.00
                                                                                        </>
                                                                                      )}

                                                                                      %
                                                                                    </div>
                                                                                  )}
                                                                              </div>
                                                                            )}
                                                                        </div>

                                                                        <div className="t-1">
                                                                          {programCriteriaQuestionDataItem.QuestionType ==
                                                                            4 &&
                                                                            indexThirdLevelInput ==
                                                                              0 &&
                                                                            programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                              1 &&
                                                                            (programCriteriaQuestionDataItem.IsHideActual ==
                                                                              0 ||
                                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                                undefined) &&
                                                                            programCriteriaQuestionDataItem.LinkActualTo ==
                                                                              1 &&
                                                                            (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              1 ||
                                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                4) &&
                                                                            programCriteriaQuestionDataItem.IsShowHeader && (
                                                                              <span className="t-2 t-2a">
                                                                                {programCriteriaQuestionDataItem.Actual2Title !=
                                                                                  "Actual" && (
                                                                                  <span>
                                                                                    {
                                                                                      programCriteriaQuestionDataItem.Actual2Title
                                                                                    }
                                                                                    &nbsp;
                                                                                  </span>
                                                                                )}

                                                                                %
                                                                              </span>
                                                                            )}
                                                                          {programCriteriaQuestionDataItem.QuestionType ==
                                                                            4 &&
                                                                            programCriteriaQuestionDataItem.IsDisplayPercentage ==
                                                                              1 &&
                                                                            (programCriteriaQuestionDataItem.IsHideActual ==
                                                                              0 ||
                                                                              programCriteriaQuestionDataItem.IsHideActual ==
                                                                                undefined) &&
                                                                            programCriteriaQuestionDataItem.LinkActualTo ==
                                                                              1 &&
                                                                            (programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                              1 ||
                                                                              programCriteriaQuestionDataItem.ActualValueFormat ==
                                                                                4) && (
                                                                              <div className="t-emp-per">
                                                                                {programCriteriaQuestionDataItem.TargetValue !=
                                                                                  undefined &&
                                                                                  programCriteriaQuestionDataItem.TargetValue !=
                                                                                    "" &&
                                                                                  programCriteriaQuestionDataItem.Actual2Value !=
                                                                                    undefined &&
                                                                                  programCriteriaQuestionDataItem.Actual2Value !=
                                                                                    "" && (
                                                                                    <div className="t-3">
                                                                                      {programCriteriaQuestionDataItem.TargetValue !=
                                                                                        0 && (
                                                                                        <>
                                                                                          {Number(
                                                                                            (programCriteriaQuestionDataItem.Actual2Value /
                                                                                              programCriteriaQuestionDataItem.TargetValue) *
                                                                                              100
                                                                                          ).toFixed(
                                                                                            2
                                                                                          )}
                                                                                        </>
                                                                                      )}
                                                                                      {programCriteriaQuestionDataItem.TargetValue ==
                                                                                        0 && (
                                                                                        <>
                                                                                          100.00
                                                                                        </>
                                                                                      )}

                                                                                      %
                                                                                    </div>
                                                                                  )}
                                                                              </div>
                                                                            )}
                                                                        </div>
                                                                      </>
                                                                    )}

                                                                    <div className="t-1">
                                                                      {indexThirdLevel >=
                                                                        0 &&
                                                                        programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.IBBProgramCriteriaQuestionInputExceptionID !=
                                                                          undefined &&
                                                                        programCriteriaQuestionDataItem
                                                                          .ExceptionData
                                                                          ?.Status ==
                                                                          1 &&
                                                                        programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                          1 && (
                                                                          <>
                                                                            <div className="t-2 e-app">
                                                                              Exception
                                                                              Applied
                                                                            </div>
                                                                          </>
                                                                        )}
                                                                      <select
                                                                        disabled={
                                                                          globalState
                                                                            .AppAccessLevelData
                                                                            .DID >
                                                                            0 ||
                                                                          scorecardData.CanInputActualsData ==
                                                                            0
                                                                            ? true
                                                                            : false
                                                                        }
                                                                        className={`${
                                                                          programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                          "1"
                                                                            ? "GreenClass"
                                                                            : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                              "0"
                                                                            ? "RedClass"
                                                                            : programCriteriaQuestionDataItem.IsTargetAchieved ==
                                                                              "2"
                                                                            ? "OrangeClass"
                                                                            : ""
                                                                        }`}
                                                                        value={
                                                                          programCriteriaQuestionDataItem.IsTargetAchieved
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          updateValueOfInputKey(
                                                                            3,
                                                                            Number(
                                                                              e
                                                                                .target
                                                                                .value
                                                                            ),
                                                                            programCriteriaQuestionDataItem.PID
                                                                          )
                                                                        }
                                                                      >
                                                                        <option value="undefined">
                                                                          Please
                                                                          Select
                                                                        </option>
                                                                        <option value="0">
                                                                          No
                                                                        </option>
                                                                        <option value="1">
                                                                          Yes
                                                                        </option>
                                                                        <option value="2">
                                                                          N/A
                                                                        </option>
                                                                      </select>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </React.Fragment>
                                                            )
                                                          )}
                                                      </div>
                                                    </React.Fragment>
                                                  )
                                                )}
                                            </React.Fragment>
                                          )
                                        )}
                                    </React.Fragment>
                                  )
                                )}
                              {globalState.AppAccessLevelData.DID == 0 && (
                                <div className="section-table mb-10 exception-up score-excep">
                                  {exceptionsData &&
                                    exceptionsData.map(
                                      (item: any, index: any) => (
                                        <React.Fragment
                                          key={item.SectionTypeName}
                                        >
                                          {item.SectionTypeName ==
                                            "CRITERIA EXCEPTIONS" &&
                                            item.Data &&
                                            item.Data.map(
                                              (
                                                itemException: any,
                                                indexException: any
                                              ) => (
                                                <React.Fragment
                                                  key={
                                                    itemException.IBBProgramCriteriaQuestionInputExceptionID
                                                  }
                                                >
                                                  {itemException.IBBProgramSectionID ==
                                                    section.SectionID &&
                                                    itemException.IBBScorecardID ==
                                                      scorecardFilter.IBBScorecardID && (
                                                      <div className="buis-case case-back plr-20">
                                                        <div className="exception-grid">
                                                          <div className="exceptions-left">
                                                            <div className="flex-items buis-head justify-btw">
                                                              <div>
                                                                <span>
                                                                  Financial
                                                                  Value:{" "}
                                                                  {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                                    -1
                                                                  )}
                                                                  {itemException.FinancialValue.toLocaleString(
                                                                    undefined,
                                                                    {
                                                                      minimumFractionDigits: 0,
                                                                      maximumFractionDigits: 0,
                                                                    }
                                                                  )}
                                                                </span>{" "}
                                                                <span>
                                                                  Approved
                                                                  Value:{" "}
                                                                  {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                                    -1
                                                                  )}
                                                                  {itemException.ApprovedValue.toLocaleString(
                                                                    undefined,
                                                                    {
                                                                      minimumFractionDigits: 0,
                                                                      maximumFractionDigits: 0,
                                                                    }
                                                                  )}
                                                                </span>{" "}
                                                                <span
                                                                  className={`
                               ${itemException.Status == 1 ? "sig-green" : ""}
                               ${itemException.Status == 2 ? "sig-red" : ""}
                          `}
                                                                >
                                                                  Status:{" "}
                                                                  {
                                                                    itemException.StatusName
                                                                  }
                                                                </span>
                                                              </div>
                                                              {itemException.ConditionText ==
                                                                "" &&
                                                                getAccessSettings(
                                                                  2,
                                                                  27
                                                                ) > 1 && (
                                                                  <a
                                                                    onClick={() => {
                                                                      let conditionDataLocal =
                                                                        {} as any;
                                                                      conditionDataLocal.IBBScorecardID =
                                                                        itemException.IBBScorecardID;
                                                                      conditionDataLocal.IBBProgramCriteriaQuestionInputExceptionID =
                                                                        itemException.IBBProgramCriteriaQuestionInputExceptionID;
                                                                      conditionDataLocal.Amount =
                                                                        itemException.FinancialValue;
                                                                      conditionDataLocal.Status = 0;

                                                                      setConditionData(
                                                                        conditionDataLocal
                                                                      );
                                                                      setConditionModal(
                                                                        true
                                                                      );
                                                                    }}
                                                                    className="btn-primary btn-condition"
                                                                    title="Add Condition"
                                                                  >
                                                                    Conditional
                                                                    Hold
                                                                  </a>
                                                                )}
                                                            </div>
                                                            <span>
                                                              <b>
                                                                Business Case:
                                                              </b>
                                                            </span>
                                                            <span className="flex-items">
                                                              <span className="b-excep-wrap">
                                                                {
                                                                  itemException.BusinessCase
                                                                }
                                                              </span>
                                                            </span>
                                                            <div className="flex-items supp-doc">
                                                              <span>
                                                                Supporting
                                                                Documents:
                                                              </span>
                                                              <>
                                                                {exceptionsDocuments &&
                                                                  exceptionsDocuments.map(
                                                                    (
                                                                      ItemAttachment: any,
                                                                      indexAttachment: any
                                                                    ) => (
                                                                      <>
                                                                        {itemException.IBBProgramCriteriaQuestionInputID ==
                                                                          ItemAttachment.ObjectID && (
                                                                          <span
                                                                            title={
                                                                              ItemAttachment.Name
                                                                            }
                                                                            key={
                                                                              ItemAttachment.ObjectID +
                                                                              "" +
                                                                              indexAttachment
                                                                            }
                                                                          >
                                                                            <a
                                                                              href={
                                                                                ItemAttachment.FileURLRaw
                                                                              }
                                                                              target="blank"
                                                                            >
                                                                              <img
                                                                                src="images/pdf.svg"
                                                                                width="40px"
                                                                                height="40px"
                                                                              />
                                                                            </a>
                                                                          </span>
                                                                        )}
                                                                      </>
                                                                    )
                                                                  )}
                                                              </>
                                                            </div>
                                                            {itemException.ConditionText !=
                                                              "" && (
                                                              <>
                                                                <span>
                                                                  <b>
                                                                    Condition:
                                                                  </b>{" "}
                                                                  <span className="added-by-txt">
                                                                    Added by{" "}
                                                                    {
                                                                      itemException.ConditionAddedByName
                                                                    }{" "}
                                                                    on{" "}
                                                                    {moment(
                                                                      itemException.AddedOnTime
                                                                    ).format(
                                                                      "DD/MM/YYYY HH:MM"
                                                                    )}
                                                                  </span>
                                                                </span>
                                                                <div className="flex-items">
                                                                  <span className="spn-text-width">
                                                                    {
                                                                      itemException.ConditionText
                                                                    }
                                                                  </span>
                                                                  {itemException.ConditionStatus ==
                                                                    0 &&
                                                                    getAccessSettings(
                                                                      2,
                                                                      27
                                                                    ) > 1 && (
                                                                      <>
                                                                        <a
                                                                          className="btn-primary btn-grid"
                                                                          onClick={() => {
                                                                            let conditionDataLocal =
                                                                              {} as any;
                                                                            conditionDataLocal.IBBConditionID =
                                                                              itemException.IBBConditionID;
                                                                            conditionDataLocal.IBBScorecardID =
                                                                              itemException.IBBScorecardID;
                                                                            conditionDataLocal.IBBProgramCriteriaQuestionInputExceptionID =
                                                                              itemException.IBBProgramCriteriaQuestionInputExceptionID;
                                                                            conditionDataLocal.Amount =
                                                                              itemException.FinancialValue;
                                                                            conditionDataLocal.Status = 0;
                                                                            conditionDataLocal.ConditionText =
                                                                              itemException.ConditionText;
                                                                            conditionDataLocal.Deadline =
                                                                              itemException.Deadline;

                                                                            setConditionData(
                                                                              conditionDataLocal
                                                                            );
                                                                            setConditionModal(
                                                                              true
                                                                            );
                                                                          }}
                                                                          title={
                                                                            "Edit"
                                                                          }
                                                                        >
                                                                          <img
                                                                            src="images/edit.svg"
                                                                            width={
                                                                              15
                                                                            }
                                                                            height={
                                                                              15
                                                                            }
                                                                          />
                                                                        </a>

                                                                        <a
                                                                          className="btn-primary btn-grid"
                                                                          onClick={() => {
                                                                            globalState.setConfirmationObject(
                                                                              {
                                                                                ShowPopup:
                                                                                  true,
                                                                                Heading:
                                                                                  "Confirmation ",
                                                                                Message:
                                                                                  "Are you sure you want to delete this record?",
                                                                                ID: 101,
                                                                                SelectedID:
                                                                                  itemException.IBBConditionID,
                                                                              }
                                                                            );
                                                                          }}
                                                                          title="Delete"
                                                                        >
                                                                          <img
                                                                            src="images/delete.svg"
                                                                            width={
                                                                              15
                                                                            }
                                                                            height={
                                                                              15
                                                                            }
                                                                          />
                                                                        </a>
                                                                      </>
                                                                    )}
                                                                </div>
                                                                <span>
                                                                  <b>
                                                                    Deadline:
                                                                  </b>
                                                                </span>
                                                                <div className="flex-items">
                                                                  <span className="spn-text-width">
                                                                    {moment(
                                                                      itemException.Deadline
                                                                    ).format(
                                                                      "DD/MM/YYYY"
                                                                    )}
                                                                  </span>
                                                                </div>
                                                              </>
                                                            )}
                                                          </div>
                                                          <div className="pg-importers appr-grid grid-signoff">
                                                            <div className="appr-main">
                                                              <div className="exceptions-right">
                                                                <div className="req-by">
                                                                  <div className="req-left">
                                                                    <span className="req-title show-block">
                                                                      Requested
                                                                      By
                                                                    </span>
                                                                    <span className="req-val">
                                                                      {
                                                                        itemException.RequestedBy
                                                                      }
                                                                    </span>
                                                                  </div>
                                                                  <div className="req-right"></div>
                                                                </div>
                                                                <span
                                                                  className="req-title"
                                                                  style={{
                                                                    paddingLeft: 10,
                                                                    marginBottom: 5,
                                                                  }}
                                                                >
                                                                  Operational
                                                                  Approval
                                                                </span>
                                                                <div className="excp-approval">
                                                                  <ApprovalsScreen
                                                                    approvalObjectType={
                                                                      17
                                                                    }
                                                                    IBBProgramID={
                                                                      scorecardFilter.ProgramID
                                                                    }
                                                                    QuarterID={
                                                                      scorecardFilter.QuarterID
                                                                    }
                                                                    IBBProgramSectionID={
                                                                      0
                                                                    }
                                                                    ApprovalTextType={
                                                                      1
                                                                    }
                                                                    approvalObjectID={
                                                                      itemException.IBBProgramCriteriaQuestionInputExceptionID
                                                                    }
                                                                    uploadObjectType={
                                                                      AppContext.FileUploadObjectTypeExceptionApprovalFile
                                                                    }
                                                                    requiredApprovalUser={
                                                                      requiredApprovalUser
                                                                    }
                                                                    triggerApprovalParent={
                                                                      triggerApprovalParent
                                                                    }
                                                                  ></ApprovalsScreen>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                </React.Fragment>
                                              )
                                            )}
                                        </React.Fragment>
                                      )
                                    )}
                                </div>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  </>
                )}
              </>
            ))}
        </div>

        {/* || globalState.ManageAdmin */}
        {scorecardData.Status >= 0 &&
          scorecardSectionData.length > 0 &&
          ((getAccessSettings(2, 26) > 0 &&
            globalState.AppAccessLevelData.DID > 0) ||
            globalState.AppAccessLevelData.DID == 0) && (
            <div className="page--data pad-t0">
              <div
                className={`section-table score-table ${
                  scorecardData.Status < 5 &&
                  globalState.AppAccessLevelData.DID > 0
                    ? "sm-score-table-w"
                    : ""
                } ${
                  scorecardData.Status >= 5 &&
                  scorecardData.Status < 8 &&
                  globalState.AppAccessLevelData.DID > 0
                    ? "smd-score-table-w"
                    : ""
                }`}
              >
                {scorecardSectionData.length > 0 && (
                  <table
                    className="part-head trend-table fixed-table"
                    id="tblData"
                  >
                    <thead>
                      <tr>
                        <th>Criteria</th>
                        <th>Weighting</th>
                        {(scorecardData.Status >= 5 ||
                          globalState.AppAccessLevelData.DID == 0) && (
                          <>
                            <th>Fund Available $</th>
                            <th className="spe-col"></th>
                            <th>Initial Achievement %</th>
                            <th>Initial Achievement $</th>
                            {(scorecardData.Status >= 8 ||
                              globalState.AppAccessLevelData.DID == 0) && (
                              <>
                                <th className="spe-col"></th>
                                <th>Final Achievement %</th>
                                <th>Final Achievement $</th>
                                <th className="spe-col"></th>
                                <th>Conditional Hold %</th>
                                <th>Conditional Hold $</th>
                              </>
                            )}

                            {(scorecardData.Status >= 10 ||
                              globalState.AppAccessLevelData.DID == 0) && (
                              <>
                                <th className="spe-col"></th>
                                <th>Quarter Result %</th>
                                <th>Quarter Result $</th>
                              </>
                            )}
                          </>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {scorecardSectionData &&
                        scorecardSectionData.map((item: any, index: any) => (
                          <React.Fragment key={"sectioncalcdata" + index}>
                            {item.IBBProgramSectionID <= 10000001 && (
                              <tr
                                className={`${
                                  item.IBBProgramSectionID == 10000001
                                    ? "JLRBold"
                                    : ""
                                }`}
                              >
                                <td>
                                  {item.IBBProgramSectionID < 10000001 && (
                                    <> {index + 1}.</>
                                  )}{" "}
                                  {item.IBBProgramSectionName}
                                </td>
                                <td className="text-right">
                                  {item.PercentageAvailable?.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                    }
                                  )}
                                  %
                                </td>
                                {(scorecardData.Status >= 5 ||
                                  globalState.AppAccessLevelData.DID == 0) && (
                                  <>
                                    <td className="text-right">
                                      $
                                      {item.POTInUSD?.toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        }
                                      )}
                                    </td>
                                    <td className="spe-col"></td>
                                    <td className="text-right">
                                      {item.PercentageAchievedActual?.toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                        }
                                      )}
                                      %
                                    </td>
                                    <td className="text-right">
                                      $
                                      {item.USDAchievedActual?.toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        }
                                      )}
                                    </td>
                                    {(scorecardData.Status >= 8 ||
                                      globalState.AppAccessLevelData.DID ==
                                        0) && (
                                      <>
                                        <td className="spe-col"></td>

                                        <td
                                          className={`${
                                            item.ConditionalHoldPercentage >
                                              0 &&
                                            item.IBBProgramSectionID < 10000001
                                              ? "red-bo yellow-back text-right"
                                              : item.ExceptionPercentage > 0 &&
                                                item.IBBProgramSectionID <
                                                  10000001 &&
                                                item.ExceptionStatus == 0
                                              ? "red-back text-right"
                                              : item.ExceptionPercentage > 0 &&
                                                item.IBBProgramSectionID <
                                                  10000001
                                              ? "yellow-back text-right"
                                              : "text-right"
                                          }`}
                                        >
                                          {(item.PercentageAchieved > 0 ||
                                            item.ExceptionPercentage == 0) && (
                                            <>
                                              {item.PercentageAchieved?.toLocaleString(
                                                undefined,
                                                {
                                                  minimumFractionDigits: 2,
                                                }
                                              )}
                                            </>
                                          )}
                                          {item.PercentageAchieved == 0 &&
                                            item.ExceptionPercentage > 0 && (
                                              <>
                                                {item.ExceptionStatus == 0 && (
                                                  <>0.00</>
                                                )}
                                                {item.ExceptionStatus != 0 && (
                                                  <>
                                                    {item.ExceptionPercentage?.toLocaleString(
                                                      undefined,
                                                      {
                                                        minimumFractionDigits: 2,
                                                      }
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            )}
                                          %
                                        </td>
                                        <td
                                          className={`${
                                            item.ConditionalHoldPercentage >
                                              0 &&
                                            item.IBBProgramSectionID < 10000001
                                              ? "red-bo yellow-back text-right"
                                              : item.ExceptionPercentage > 0 &&
                                                item.IBBProgramSectionID <
                                                  10000001 &&
                                                item.ExceptionStatus == 0
                                              ? "red-back text-right"
                                              : item.ExceptionPercentage > 0 &&
                                                item.IBBProgramSectionID <
                                                  10000001
                                              ? "yellow-back text-right"
                                              : "text-right"
                                          }`}
                                        >
                                          $
                                          {(item.USDAchieved > 0 ||
                                            item.ExceptionPercentage == 0) && (
                                            <>
                                              {item.USDAchieved?.toLocaleString(
                                                undefined,
                                                {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 0,
                                                }
                                              )}
                                            </>
                                          )}
                                          {item.USDAchieved == 0 &&
                                            item.ExceptionPercentage > 0 && (
                                              <>
                                                {item.ExceptionStatus == 0 && (
                                                  <>0</>
                                                )}
                                                {item.ExceptionStatus != 0 && (
                                                  <>
                                                    {item.ExceptionInUSD?.toLocaleString(
                                                      undefined,
                                                      {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0,
                                                      }
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            )}
                                        </td>
                                        <td className="spe-col"></td>

                                        <td
                                          className={`${
                                            item.ConditionalHoldPercentage >
                                              0 &&
                                            item.IBBProgramSectionID <
                                              10000001 &&
                                            item.ConditionalHoldStatus == 0
                                              ? "red-back text-right"
                                              : "text-right"
                                          }`}
                                        >
                                          {item.ConditionalHoldPercentage >
                                            0 && (
                                            <>
                                              {item.ConditionalHoldPercentage?.toLocaleString(
                                                undefined,
                                                {
                                                  minimumFractionDigits: 2,
                                                }
                                              )}
                                              %
                                            </>
                                          )}
                                        </td>
                                        <td
                                          className={`${
                                            item.ConditionalHoldPercentage >
                                              0 &&
                                            item.IBBProgramSectionID <
                                              10000001 &&
                                            item.ConditionalHoldStatus == 0
                                              ? "red-back text-right"
                                              : "text-right"
                                          }`}
                                        >
                                          {item.ConditionalHoldPercentage >
                                            0 && (
                                            <>
                                              $
                                              {item.ConditionalHoldInUSD?.toLocaleString(
                                                undefined,
                                                {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 0,
                                                }
                                              )}
                                            </>
                                          )}
                                        </td>
                                      </>
                                    )}
                                    {(scorecardData.Status >= 10 ||
                                      globalState.AppAccessLevelData.DID ==
                                        0) && (
                                      <>
                                        <td className="spe-col"></td>

                                        {item.IBBProgramSectionID <
                                          10000001 && (
                                          <>
                                            <td
                                              className={`${
                                                item.ConditionalHoldPercentage >
                                                  0 &&
                                                item.IBBProgramSectionID <
                                                  10000001 &&
                                                item.ConditionalHoldStatus == 0
                                                  ? "red-back text-right"
                                                  : item.ConditionalHoldPercentage >
                                                      0 &&
                                                    item.IBBProgramSectionID <
                                                      10000001
                                                  ? "yellow-back text-right"
                                                  : item.ExceptionPercentage >
                                                      0 &&
                                                    item.IBBProgramSectionID <
                                                      10000001 &&
                                                    item.ExceptionStatus == 0
                                                  ? "red-back text-right"
                                                  : item.ExceptionPercentage >
                                                      0 &&
                                                    item.IBBProgramSectionID <
                                                      10000001
                                                  ? "yellow-back text-right"
                                                  : "text-right"
                                              }`}
                                            >
                                              {(item.PercentageAchieved > 0 ||
                                                item.ExceptionPercentage ==
                                                  0) && (
                                                <>
                                                  {item.PercentageAchieved?.toLocaleString(
                                                    undefined,
                                                    {
                                                      minimumFractionDigits: 2,
                                                    }
                                                  )}
                                                </>
                                              )}
                                              {item.PercentageAchieved == 0 &&
                                                item.ExceptionPercentage >
                                                  0 && (
                                                  <>
                                                    {(item.ExceptionStatus ==
                                                      0 ||
                                                      (item.ConditionalHoldStatus ==
                                                        0 &&
                                                        item.ConditionalHoldPercentage >
                                                          0)) && <>0.00</>}
                                                    {((item.ExceptionStatus !=
                                                      0 &&
                                                      item.ConditionalHoldPercentage ==
                                                        0) ||
                                                      (item.ConditionalHoldStatus !=
                                                        0 &&
                                                        item.ConditionalHoldPercentage >
                                                          0)) && (
                                                      <>
                                                        {item.ExceptionPercentage?.toLocaleString(
                                                          undefined,
                                                          {
                                                            minimumFractionDigits: 2,
                                                          }
                                                        )}
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                              %
                                            </td>
                                            <td
                                              className={`${
                                                item.ConditionalHoldPercentage >
                                                  0 &&
                                                item.IBBProgramSectionID <
                                                  10000001 &&
                                                item.ConditionalHoldStatus == 0
                                                  ? "red-back text-right"
                                                  : item.ConditionalHoldPercentage >
                                                      0 &&
                                                    item.IBBProgramSectionID <
                                                      10000001
                                                  ? "yellow-back text-right"
                                                  : item.ExceptionPercentage >
                                                      0 &&
                                                    item.IBBProgramSectionID <
                                                      10000001 &&
                                                    item.ExceptionStatus == 0
                                                  ? "red-back text-right"
                                                  : item.ExceptionPercentage >
                                                      0 &&
                                                    item.IBBProgramSectionID <
                                                      10000001
                                                  ? "yellow-back text-right"
                                                  : "text-right"
                                              }`}
                                            >
                                              $
                                              {(item.USDAchieved > 0 ||
                                                item.ExceptionPercentage ==
                                                  0) && (
                                                <>
                                                  {item.USDAchieved?.toLocaleString(
                                                    undefined,
                                                    {
                                                      minimumFractionDigits: 0,
                                                      maximumFractionDigits: 0,
                                                    }
                                                  )}
                                                </>
                                              )}
                                              {item.USDAchieved == 0 &&
                                                item.ExceptionPercentage >
                                                  0 && (
                                                  <>
                                                    {(item.ExceptionStatus ==
                                                      0 ||
                                                      (item.ConditionalHoldStatus ==
                                                        0 &&
                                                        item.ConditionalHoldPercentage >
                                                          0)) && <>0</>}
                                                    {((item.ExceptionStatus !=
                                                      0 &&
                                                      item.ConditionalHoldPercentage ==
                                                        0) ||
                                                      (item.ConditionalHoldStatus !=
                                                        0 &&
                                                        item.ConditionalHoldPercentage >
                                                          0)) && (
                                                      <>
                                                        {item.ExceptionInUSD?.toLocaleString(
                                                          undefined,
                                                          {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0,
                                                          }
                                                        )}
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                            </td>
                                          </>
                                        )}

                                        {item.IBBProgramSectionID ==
                                          10000001 && (
                                          <>
                                            <td className="text-right">
                                              <>
                                                {item.QuarterResultPercentageAchieved?.toLocaleString(
                                                  undefined,
                                                  {
                                                    minimumFractionDigits: 2,
                                                  }
                                                )}
                                              </>
                                              %
                                            </td>
                                            <td className="text-right">
                                              $
                                              {item.QuarterResultInUSDAchieved?.toLocaleString(
                                                undefined,
                                                {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 0,
                                                }
                                              )}
                                            </td>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>
                )}
                {scorecardSectionData.length > 0 &&
                  (scorecardData.Status >= 5 ||
                    globalState.AppAccessLevelData.DID == 0) && (
                    <table
                      className="part-head trend-table fixed-table"
                      id="tblData"
                    >
                      <tbody>
                        <tr className="sm-empty-tr">
                          <td></td>
                          <td></td>
                          <td></td>

                          <td className="spe-col"></td>
                          <td></td>
                          <td></td>
                          {(scorecardData.Status >= 8 ||
                            globalState.AppAccessLevelData.DID == 0) && (
                            <>
                              <td className="spe-col"></td>
                              <td></td>
                              <td></td>
                              <td className="spe-col"></td>
                              <td></td>
                              <td></td>
                            </>
                          )}
                          {(scorecardData.Status >= 10 ||
                            globalState.AppAccessLevelData.DID == 0) && (
                            <>
                              <td className="spe-col"></td>
                              <td></td>
                              <td></td>
                            </>
                          )}
                        </tr>
                        <tr className="row-usd">
                          <td className="trans-back-c"></td>
                          <td className="dark-td">USD</td>
                          <td className="dark-td"></td>
                          <td className="spe-col"></td>
                          <td className="dark-td"></td>
                          <td className="dark-td"></td>
                          {(scorecardData.Status >= 8 ||
                            globalState.AppAccessLevelData.DID == 0) && (
                            <>
                              <td className="spe-col"></td>
                              <td className="dark-td"></td>
                              <td className="dark-td"></td>

                              <td className="spe-col"></td>
                              <td className="dark-td"></td>
                              <td className="dark-td"></td>
                            </>
                          )}
                          {(scorecardData.Status >= 10 ||
                            globalState.AppAccessLevelData.DID == 0) && (
                            <>
                              <td className="spe-col"></td>
                              <td className="dark-td"></td>
                              <td className="dark-td"></td>
                            </>
                          )}
                        </tr>
                        {scorecardSectionData &&
                          scorecardSectionData.map((item: any, index: any) => (
                            <React.Fragment key={"sectioncalcdata" + index}>
                              {item.IBBProgramSectionID > 10000001 &&
                                item.IBBProgramSectionID < 10000005 && (
                                  <tr
                                    className={`${
                                      item.IBBProgramSectionID == 10000004
                                        ? "JLRBold"
                                        : ""
                                    }`}
                                  >
                                    <td className="trans-back-c"></td>
                                    <td className="text-right brd-left">
                                      {item.IBBProgramSectionName}
                                    </td>
                                    <td className="text-right">
                                      $
                                      {item.IBBProgramSectionID == 10000002 && (
                                        <>
                                          {item.JaguarPOTInUSD?.toLocaleString(
                                            undefined,
                                            {
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            }
                                          )}
                                        </>
                                      )}
                                      {item.IBBProgramSectionID == 10000003 && (
                                        <>
                                          {item.LandRoverPOTInUSD?.toLocaleString(
                                            undefined,
                                            {
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            }
                                          )}
                                        </>
                                      )}
                                      {item.IBBProgramSectionID == 10000004 && (
                                        <>
                                          {item.POTInUSD?.toLocaleString(
                                            undefined,
                                            {
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            }
                                          )}
                                        </>
                                      )}
                                    </td>
                                    <td className="spe-col"></td>
                                    <td className="text-right">
                                      {item.PercentageAchievedActual?.toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 2,
                                        }
                                      )}
                                      %
                                    </td>
                                    <td className="text-right">
                                      $
                                      {item.USDAchievedActual?.toLocaleString(
                                        undefined,
                                        {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        }
                                      )}
                                    </td>
                                    {(scorecardData.Status >= 8 ||
                                      globalState.AppAccessLevelData.DID ==
                                        0) && (
                                      <>
                                        <td className="spe-col"></td>

                                        <td className="text-right">
                                          {item.PercentageAchieved?.toLocaleString(
                                            undefined,
                                            {
                                              minimumFractionDigits: 2,
                                            }
                                          )}
                                          %
                                        </td>
                                        <td className="text-right">
                                          $
                                          {item.USDAchieved?.toLocaleString(
                                            undefined,
                                            {
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            }
                                          )}
                                        </td>

                                        <td className="spe-col"></td>

                                        <td className="text-right">
                                          {item.ConditionalHoldInUSD > 0 && (
                                            <>
                                              {item.ConditionalHoldPercentage?.toLocaleString(
                                                undefined,
                                                {
                                                  minimumFractionDigits: 2,
                                                }
                                              )}
                                              %
                                            </>
                                          )}
                                        </td>
                                        <td className="text-right">
                                          {item.ConditionalHoldInUSD > 0 && (
                                            <>
                                              $
                                              {item.ConditionalHoldInUSD?.toLocaleString(
                                                undefined,
                                                {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 0,
                                                }
                                              )}
                                            </>
                                          )}
                                        </td>
                                      </>
                                    )}
                                    {(scorecardData.Status >= 10 ||
                                      globalState.AppAccessLevelData.DID ==
                                        0) && (
                                      <>
                                        <td className="spe-col"></td>
                                        <td className="text-right">
                                          {item.QuarterResultPercentageAchieved?.toLocaleString(
                                            undefined,
                                            {
                                              minimumFractionDigits: 2,
                                            }
                                          )}
                                          %
                                        </td>
                                        <td className="text-right">
                                          $
                                          {item.QuarterResultInUSDAchieved?.toLocaleString(
                                            undefined,
                                            {
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            }
                                          )}
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                )}
                            </React.Fragment>
                          ))}

                        {scorecardData.CurrencyID != 1 && (
                          <>
                            <tr className="sm-empty-tr sm-empty-tr-2">
                              <td></td>
                              <td></td>
                              <td></td>
                              <td className="spe-col"></td>
                              <td></td>
                              <td></td>
                              {(scorecardData.Status >= 8 ||
                                globalState.AppAccessLevelData.DID == 0) && (
                                <>
                                  <td className="spe-col"></td>
                                  <td></td>
                                  <td></td>

                                  <td className="spe-col"></td>
                                  <td></td>
                                  <td></td>
                                </>
                              )}
                              {(scorecardData.Status >= 10 ||
                                globalState.AppAccessLevelData.DID == 0) && (
                                <>
                                  <td className="spe-col"></td>
                                  <td></td>
                                  <td></td>
                                </>
                              )}
                            </tr>
                            <tr className="row-usd">
                              <td className="trans-back-c"></td>
                              <td className="dark-td">Euro</td>
                              <td className="dark-td"></td>
                              <td className="spe-col"></td>
                              <td className="dark-td"></td>
                              <td className="dark-td"></td>
                              {(scorecardData.Status >= 8 ||
                                globalState.AppAccessLevelData.DID == 0) && (
                                <>
                                  <td className="spe-col"></td>
                                  <td className="dark-td"></td>
                                  <td className="dark-td"></td>

                                  <td className="spe-col"></td>
                                  <td className="dark-td"></td>
                                  <td className="dark-td"></td>
                                </>
                              )}
                              {(scorecardData.Status >= 10 ||
                                globalState.AppAccessLevelData.DID == 0) && (
                                <>
                                  <td className="spe-col"></td>
                                  <td className="dark-td"></td>
                                  <td className="dark-td"></td>
                                </>
                              )}
                            </tr>
                            {scorecardSectionData &&
                              scorecardSectionData.map(
                                (item: any, index: any) => (
                                  <React.Fragment
                                    key={"sectioncalcdata" + index}
                                  >
                                    {item.IBBProgramSectionID > 10000004 &&
                                      item.IBBProgramSectionID < 10000008 && (
                                        <tr
                                          className={`${
                                            item.IBBProgramSectionID == 10000007
                                              ? "JLRBold"
                                              : ""
                                          }`}
                                        >
                                          <td className="trans-back-c"></td>
                                          <td className="text-right brd-left">
                                            {item.IBBProgramSectionName}
                                          </td>
                                          <td className="text-right">
                                            {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                              scorecardData.CurrencyID
                                            )}
                                            {item.IBBProgramSectionID ==
                                              10000005 && (
                                              <>
                                                {item.JaguarPOTInLC?.toLocaleString(
                                                  undefined,
                                                  {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                  }
                                                )}
                                              </>
                                            )}
                                            {item.IBBProgramSectionID ==
                                              10000006 && (
                                              <>
                                                {item.LandRoverPOTInLC?.toLocaleString(
                                                  undefined,
                                                  {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                  }
                                                )}
                                              </>
                                            )}
                                            {item.IBBProgramSectionID ==
                                              10000007 && (
                                              <>
                                                {(
                                                  item.JaguarPOTInLC +
                                                  item.LandRoverPOTInLC
                                                )?.toLocaleString(undefined, {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 0,
                                                })}
                                              </>
                                            )}
                                          </td>
                                          <td className="spe-col"></td>

                                          <td className="text-right">
                                            {item.PercentageAchievedActual?.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 2,
                                              }
                                            )}
                                            %
                                          </td>
                                          <td className="text-right">
                                            {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                              scorecardData.CurrencyID
                                            )}
                                            {item.USDAchievedActual?.toLocaleString(
                                              undefined,
                                              {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0,
                                              }
                                            )}
                                          </td>
                                          {(scorecardData.Status >= 8 ||
                                            globalState.AppAccessLevelData
                                              .DID == 0) && (
                                            <>
                                              <td className="spe-col"></td>

                                              <td className="text-right">
                                                {item.PercentageAchieved?.toLocaleString(
                                                  undefined,
                                                  {
                                                    minimumFractionDigits: 2,
                                                  }
                                                )}
                                                %
                                              </td>
                                              <td className="text-right">
                                                {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                  scorecardData.CurrencyID
                                                )}
                                                {item.USDAchieved?.toLocaleString(
                                                  undefined,
                                                  {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                  }
                                                )}
                                              </td>

                                              <td className="spe-col"></td>

                                              <td className="text-right">
                                                {item.ConditionalHoldInUSD >
                                                  0 && (
                                                  <>
                                                    {item.ConditionalHoldPercentage?.toLocaleString(
                                                      undefined,
                                                      {
                                                        minimumFractionDigits: 2,
                                                      }
                                                    )}
                                                    %
                                                  </>
                                                )}
                                              </td>
                                              <td className="text-right">
                                                {item.ConditionalHoldInUSD >
                                                  0 && (
                                                  <>
                                                    {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                      scorecardData.CurrencyID
                                                    )}
                                                    {item.ConditionalHoldInUSD?.toLocaleString(
                                                      undefined,
                                                      {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0,
                                                      }
                                                    )}
                                                  </>
                                                )}
                                              </td>
                                            </>
                                          )}
                                          {(scorecardData.Status >= 10 ||
                                            globalState.AppAccessLevelData
                                              .DID == 0) && (
                                            <>
                                              <td className="spe-col"></td>

                                              <td className="text-right">
                                                {item.QuarterResultPercentageAchieved?.toLocaleString(
                                                  undefined,
                                                  {
                                                    minimumFractionDigits: 2,
                                                  }
                                                )}
                                                %
                                              </td>
                                              <td className="text-right">
                                                {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                                  scorecardData.CurrencyID
                                                )}
                                                {item.QuarterResultInUSDAchieved?.toLocaleString(
                                                  undefined,
                                                  {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                  }
                                                )}
                                              </td>
                                            </>
                                          )}
                                        </tr>
                                      )}
                                  </React.Fragment>
                                )
                              )}
                          </>
                        )}
                      </tbody>
                    </table>
                  )}
              </div>
            </div>
          )}
      </div>

      {reEarnableModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Add Section</h3>
                <a
                  className="close-help"
                  onClick={() => setReEarnableModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>

              {reEarnableObject.Type == 2 && (
                <>
                  <div className="help-row">
                    <p>Functional Area:</p>
                    <select
                      key={"DepartmentDDL"}
                      className="input-field select-field"
                      value={reEarnableObject.IBBDepartmentID}
                      onChange={(e) => {
                        setReEarnableObject((prevState: any) => ({
                          ...prevState,
                          IBBDepartmentID: e.target.value,
                        }));
                      }}
                    >
                      <option value="0">Please Select</option>
                      {departmentList &&
                        departmentList.map((item: any, index: any) => (
                          <React.Fragment key={"departmentlist" + index}>
                            <option
                              value={item.IBBDepartmentID}
                              key={"department" + item.IBBDepartmentID}
                            >
                              {item.Name}
                            </option>
                          </React.Fragment>
                        ))}
                    </select>
                  </div>
                </>
              )}

              <div className="help-row">
                <p>Title:</p>
                <input
                  value={reEarnableObject.Title}
                  onChange={(e) =>
                    setReEarnableObject((prevState: any) => ({
                      ...prevState,
                      Title: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>
              <div className="help-row">
                <p>Short Title:</p>
                <input
                  value={reEarnableObject.ShortTitle}
                  onChange={(e) =>
                    setReEarnableObject((prevState: any) => ({
                      ...prevState,
                      ShortTitle: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>
              <div className="help-row">
                <p>Description:</p>
                <input
                  value={reEarnableObject.Description}
                  onChange={(e) =>
                    setReEarnableObject((prevState: any) => ({
                      ...prevState,
                      Description: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>
              {reEarnableObject.Type == 2 && (
                <>
                  <div className="help-row">
                    <p>Value:</p>
                    <input
                      value={reEarnableObject.Value}
                      onChange={(e) =>
                        setReEarnableObject((prevState: any) => ({
                          ...prevState,
                          Value: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </div>
                  <div className="help-row">
                    <p>Value Description:</p>
                    <input
                      value={reEarnableObject.ValueDescription}
                      onChange={(e) =>
                        setReEarnableObject((prevState: any) => ({
                          ...prevState,
                          ValueDescription: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </div>
                  <div className="help-row">
                    <p>Order By:</p>
                    <input
                      value={reEarnableObject.PTOrderBy}
                      onChange={(e) =>
                        setReEarnableObject((prevState: any) => ({
                          ...prevState,
                          PTOrderBy: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </div>
                  <div className="help-row">
                    <p>Weightage:</p>
                    <select
                      className="input-field select-field"
                      value={reEarnableObject.ExtraTextField1}
                      onChange={(e) =>
                        setReEarnableObject((prevState: any) => ({
                          ...prevState,
                          ExtraTextField1: e.target.value,
                        }))
                      }
                    >
                      <option value="-1">Please Select</option>
                      <option value="0">Split Percentage</option>
                      <option value="1">All Or Nothing</option>
                    </select>
                  </div>
                </>
              )}
              <div className="help-btns">
                <a onClick={() => saveReEarnableData()}>Save</a>
                <a onClick={() => setReEarnableModal(false)}>Cancel</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {entriesModal && (
        <div className="popup-help">
          <div className="help-popup-display ibb-nodes rows-pop">
            <div className="help-inner">
              <div className="help-head">
                <h3>Entries</h3>
                <a
                  className="close-help"
                  onClick={() => setEntriesModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="row-styles">
                <div className="row-left">
                  <div className="help-row">
                    <p>Title:</p>
                    <input
                      value={entriesObject.Title}
                      onChange={(e) =>
                        setEntriesObject((prevState: any) => ({
                          ...prevState,
                          Title: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </div>
                  <div className="help-row">
                    <p>Brand:</p>
                    <select
                      className="input-field select-field"
                      value={entriesObject.Description}
                      onChange={(e) =>
                        setEntriesObject((prevState: any) => ({
                          ...prevState,
                          Description: e.target.value,
                        }))
                      }
                    >
                      <option value="2">All Brands</option>
                      <option value="3">PFI Brand 3</option>
                      <option value="4">PFI Brand 4</option>
                    </select>
                  </div>
                  <div className="help-row">
                    <p>Serial Number:</p>
                    <input
                      value={entriesObject.SerialNumber}
                      onChange={(e) =>
                        setEntriesObject((prevState: any) => ({
                          ...prevState,
                          SerialNumber: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </div>
                  <div className="help-row">
                    <p>Split Percentage:</p>
                    <input
                      value={entriesObject.SplitPercentage}
                      onChange={(e) =>
                        setEntriesObject((prevState: any) => ({
                          ...prevState,
                          SplitPercentage: e.target.value,
                        }))
                      }
                      type="number"
                    />
                  </div>
                  <div className="help-row">
                    <p>Input Level:</p>
                    <input
                      type="checkbox"
                      className="input-check"
                      checked={entriesObject.IsInputLevel}
                      onChange={(e) =>
                        setEntriesObject((prevState: any) => ({
                          ...prevState,
                          IsInputLevel: !entriesObject.IsInputLevel,
                        }))
                      }
                    />
                  </div>
                  {entriesObject.IsInputLevel && (
                    <>
                      <div className="help-row">
                        <p>Question Type:</p>
                        <select
                          className="input-field select-field"
                          value={entriesObject.QuestionType}
                          onChange={(e) =>
                            setEntriesObject((prevState: any) => ({
                              ...prevState,
                              QuestionType: e.target.value,
                            }))
                          }
                        >
                          <option value="0">Please Select</option>
                          <option value="1">Yes/No</option>
                          <option value="2">Target Based</option>
                          <option value="3">Action Based</option>
                          <option value="4">Target Based Double Actuals</option>
                        </select>
                      </div>

                      <div className="help-row">
                        <p>Data Level:</p>
                        <select
                          className="input-field select-field"
                          value={entriesObject.DataLevelType}
                          onChange={(e) =>
                            setEntriesObject((prevState: any) => ({
                              ...prevState,
                              DataLevelType: e.target.value,
                            }))
                          }
                        >
                          <option value="0">Please Select</option>
                          <option value="1">Importer</option>
                          {/* <option value="2">Retailer</option> */}
                          {/* <option value="3">Month</option>  */}
                        </select>
                      </div>

                      {(entriesObject.QuestionType == 2 ||
                        entriesObject.QuestionType == 4) && (
                        <>
                          <div className="help-row">
                            <p>Target Value Format:</p>
                            <select
                              className="input-field select-field"
                              value={entriesObject.TargetValueFormat}
                              onChange={(e) =>
                                setEntriesObject((prevState: any) => ({
                                  ...prevState,
                                  TargetValueFormat: e.target.value,
                                }))
                              }
                            >
                              <option value="0">Please Select</option>
                              <option value="1">Number</option>
                              <option value="2">Percentage</option>
                              <option value="4">Currency</option>
                            </select>
                          </div>
                          {entriesObject.TargetValueFormat == 4 && (
                            <div className="help-row">
                              <p>Currency Type:</p>
                              <select
                                className="input-field select-field"
                                value={entriesObject.Name}
                                onChange={(e) =>
                                  setEntriesObject((prevState: any) => ({
                                    ...prevState,
                                    Name: e.target.value,
                                  }))
                                }
                              >
                                <option value="">Please Select</option>
                                <option value="$">Dollar ($)</option>
                                <option value="€">Euro (€)</option>
                                <option value="£">Pound (£)</option>
                              </select>
                            </div>
                          )}
                          <div className="help-row">
                            <p>Link Target to:</p>
                            <select
                              className="input-field select-field"
                              value={entriesObject.LinkTargetTo}
                              onChange={(e) =>
                                setEntriesObject((prevState: any) => ({
                                  ...prevState,
                                  LinkTargetTo: e.target.value,
                                }))
                              }
                            >
                              <option value="0">Please Select</option>
                              <option value="1">Input</option>
                              {/* <option value="2">Alpha from SPT</option>
                              <option value="3">Bravo from BP</option>
                              <option value="4">Charlie from AMT</option> */}
                            </select>
                          </div>
                          <div className="help-row">
                            <p>Hide Actual:</p>
                            <input
                              type="checkbox"
                              className="input-check"
                              checked={entriesObject.IsHideActual}
                              onChange={(e) =>
                                setEntriesObject((prevState: any) => ({
                                  ...prevState,
                                  IsHideActual: !entriesObject.IsHideActual,
                                }))
                              }
                            />
                          </div>
                          {!entriesObject.IsHideActual && (
                            <>
                              <div className="help-row">
                                <p>Actual Value Format:</p>
                                <select
                                  className="input-field select-field"
                                  value={entriesObject.ActualValueFormat}
                                  onChange={(e) =>
                                    setEntriesObject((prevState: any) => ({
                                      ...prevState,
                                      ActualValueFormat: e.target.value,
                                    }))
                                  }
                                >
                                  <option value="0">Please Select</option>
                                  <option value="1">Number</option>
                                  <option value="2">Percentage</option>
                                  <option value="4">Currency</option>
                                </select>
                              </div>
                              <div className="help-row">
                                <p>Link Actual to:</p>
                                <select
                                  className="input-field select-field"
                                  value={entriesObject.LinkActualTo}
                                  onChange={(e) =>
                                    setEntriesObject((prevState: any) => ({
                                      ...prevState,
                                      LinkActualTo: e.target.value,
                                    }))
                                  }
                                >
                                  <option value="0">Please Select</option>
                                  <option value="1">Input</option>
                                  {/* <option value="2">Alpha from SPT</option>
                                  <option value="3">Bravo from BP</option>
                                  <option value="4">Charlie from AMT</option> */}
                                </select>
                              </div>
                              <div className="help-row">
                                <p>Display Percentage:</p>
                                <input
                                  type="checkbox"
                                  className="input-check"
                                  checked={entriesObject.IsDisplayPercentage}
                                  onChange={(e) =>
                                    setEntriesObject((prevState: any) => ({
                                      ...prevState,
                                      IsDisplayPercentage:
                                        !entriesObject.IsDisplayPercentage,
                                    }))
                                  }
                                />
                              </div>
                              <div className="help-row">
                                <p>Show Header:</p>
                                <input
                                  type="checkbox"
                                  className="input-check"
                                  checked={entriesObject.IsShowHeader}
                                  onChange={(e) =>
                                    setEntriesObject((prevState: any) => ({
                                      ...prevState,
                                      IsShowHeader: !entriesObject.IsShowHeader,
                                    }))
                                  }
                                />
                              </div>
                            </>
                          )}
                        </>
                      )}

                      {entriesObject.QuestionType == 3 && (
                        <>
                          <div className="help-row">
                            <p>Number of Actions:</p>
                            <input
                              type="number"
                              value={entriesObject.NumberOfTargets}
                              onChange={(e) =>
                                setEntriesObject((prevState: any) => ({
                                  ...prevState,
                                  NumberOfTargets: e.target.value,
                                }))
                              }
                            ></input>
                          </div>

                          <div className="help-row">
                            <p>Serial Number:</p>
                            <input
                              type="checkbox"
                              className="input-check"
                              checked={entriesObject.IsShowTargetSN}
                              onChange={(e) =>
                                setEntriesObject((prevState: any) => ({
                                  ...prevState,
                                  IsShowTargetSN: !entriesObject.IsShowTargetSN,
                                }))
                              }
                            />
                          </div>

                          <div className="help-row">
                            <p>Action Target:</p>
                            <input
                              type="checkbox"
                              className="input-check"
                              checked={entriesObject.IsShowTextTarget}
                              onChange={(e) =>
                                setEntriesObject((prevState: any) => ({
                                  ...prevState,
                                  IsShowTextTarget:
                                    !entriesObject.IsShowTextTarget,
                                }))
                              }
                            />
                          </div>

                          <div className="help-row">
                            <p>Actual Notes:</p>
                            <input
                              type="checkbox"
                              className="input-check"
                              checked={entriesObject.IsShowActualNotes}
                              onChange={(e) =>
                                setEntriesObject((prevState: any) => ({
                                  ...prevState,
                                  IsShowActualNotes:
                                    !entriesObject.IsShowActualNotes,
                                }))
                              }
                            />
                          </div>
                        </>
                      )}

                      {entriesObject.QuestionType == 4 &&
                        !entriesObject.IsHideActual && (
                          <>
                            <div className="help-row">
                              <p>Actual 1 Title:</p>
                              <input
                                value={entriesObject.Actual1Title}
                                onChange={(e) =>
                                  setEntriesObject((prevState: any) => ({
                                    ...prevState,
                                    Actual1Title: e.target.value,
                                  }))
                                }
                                type="text"
                              />
                            </div>
                            <div className="help-row">
                              <p>Actual 1 Pass (%):</p>
                              <input
                                value={entriesObject.Actual1PassPercentage}
                                onChange={(e) =>
                                  setEntriesObject((prevState: any) => ({
                                    ...prevState,
                                    Actual1PassPercentage: e.target.value,
                                  }))
                                }
                                type="number"
                              />
                            </div>
                            <div className="help-row">
                              <p>Actual 2 Title:</p>
                              <input
                                value={entriesObject.Actual2Title}
                                onChange={(e) =>
                                  setEntriesObject((prevState: any) => ({
                                    ...prevState,
                                    Actual2Title: e.target.value,
                                  }))
                                }
                                type="text"
                              />
                            </div>
                            <div className="help-row">
                              <p>Actual 2 Pass (%):</p>
                              <input
                                value={entriesObject.Actual2PassPercentage}
                                onChange={(e) =>
                                  setEntriesObject((prevState: any) => ({
                                    ...prevState,
                                    Actual2PassPercentage: e.target.value,
                                  }))
                                }
                                type="number"
                              />
                            </div>
                          </>
                        )}
                    </>
                  )}
                </div>
                <div className="row-right">
                  <div className="help-row">
                    {formattingOptionsArray1 &&
                      formattingOptionsArray1.map((Item: any, index: any) => (
                        <div className="row-box">
                          <React.Fragment key={index}>
                            {index == 0 && (
                              <div className="row-title">Text Styles</div>
                            )}
                            <div className="styles-checks">
                              <input
                                type="checkbox"
                                name="formatingClassName1"
                                value={Item.ClassName}
                                defaultChecked={isThisChecked(
                                  entriesObject.FormattingOptions,
                                  Item.ClassName
                                )}
                                id={"ck1" + index}
                                onClick={() => selectOnlyOne(1, "ck1", index)}
                              />
                              <span>{Item.Name}</span>
                            </div>
                          </React.Fragment>
                        </div>
                      ))}
                    {formattingOptionsArray2 &&
                      formattingOptionsArray2.map((Item: any, index: any) => (
                        <div className="row-box">
                          <React.Fragment key={index}>
                            {index == 0 && (
                              <div className="row-title">Alignment</div>
                            )}
                            <div className="styles-checks">
                              <input
                                type="checkbox"
                                name="formatingClassName2"
                                value={Item.ClassName}
                                defaultChecked={isThisChecked(
                                  entriesObject.FormattingOptions,
                                  Item.ClassName
                                )}
                                id={"ck2" + index}
                                onClick={() => selectOnlyOne(2, "ck2", index)}
                              />
                              <span>{Item.Name}</span>
                            </div>
                          </React.Fragment>
                        </div>
                      ))}
                    {formattingOptionsArray3 &&
                      formattingOptionsArray3.map((Item: any, index: any) => (
                        <div className="row-box">
                          <React.Fragment key={index}>
                            {index == 0 && (
                              <div className="row-title">Width</div>
                            )}
                            <div className="styles-checks">
                              <input
                                type="checkbox"
                                name="formatingClassName3"
                                value={Item.ClassName}
                                defaultChecked={isThisChecked(
                                  entriesObject.FormattingOptions,
                                  Item.ClassName
                                )}
                                id={"ck3" + index}
                                onClick={() => selectOnlyOne(3, "ck3", index)}
                              />
                              <span>{Item.Name}</span>
                            </div>
                          </React.Fragment>
                        </div>
                      ))}
                    {formattingOptionsArray4 &&
                      formattingOptionsArray4.map((Item: any, index: any) => (
                        <div className="row-box">
                          <React.Fragment key={index}>
                            {index == 0 && (
                              <div className="row-title">Border</div>
                            )}
                            <div className="styles-checks">
                              <input
                                type="checkbox"
                                name="formatingClassName4"
                                value={Item.ClassName}
                                defaultChecked={isThisChecked(
                                  entriesObject.FormattingOptions,
                                  Item.ClassName
                                )}
                                id={"ck4" + index}
                                onClick={() => selectOnlyOne(4, "ck4", index)}
                              />
                              <span>{Item.Name}</span>
                            </div>
                          </React.Fragment>
                        </div>
                      ))}
                    {formattingOptionsArray5 &&
                      formattingOptionsArray5.map((Item: any, index: any) => (
                        <div className="row-box">
                          <React.Fragment key={index}>
                            {index == 0 && (
                              <div className="row-title">Font Size</div>
                            )}
                            <div className="styles-checks">
                              <input
                                type="checkbox"
                                name="formatingClassName5"
                                value={Item.ClassName}
                                defaultChecked={isThisChecked(
                                  entriesObject.FormattingOptions,
                                  Item.ClassName
                                )}
                                id={"ck5" + index}
                                onClick={() => selectOnlyOne(5, "ck5", index)}
                              />
                              <span>{Item.Name}</span>
                            </div>
                          </React.Fragment>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="help-btns">
                {/* {entriesObject.PID > 0 && (
                  <a onClick={() => updateEntriesData()}>Update</a>
                )}
                {entriesObject.PID == 0 && (
                  <a onClick={() => saveEntriesData()}>Save</a>
                )} */}
                <a onClick={() => saveEntriesData()}>Save</a>
                <a onClick={() => setEntriesModal(false)}>Cancel</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {copyModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Copy Data</h3>
                <a className="close-help" onClick={() => setCopyModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="flex-container plr-20">
                <div className="flex-items flex-33">
                  <MainTopFilters
                    ScreenID={-4000}
                    MainTopFiltersCallBack={MainTopFiltersCallBack}
                  />
                </div>
              </div>
              <div className="help-btns">
                <a onClick={() => setCopyModal(false)}>Copy</a>
                <a onClick={() => setCopyModal(false)}>Cancel</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {AddException && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Exception</h3>
                <a
                  className="close-help"
                  onClick={() => setAddException(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">
                <div className="exceptions-left">
                  <div className="flex-approval">
                    {((getAccessSettings(2, 26) > 0 &&
                      globalState.AppAccessLevelData.DID > 0) ||
                      globalState.AppAccessLevelData.DID == 0) && (
                      <div className="flex-items buis-head">
                        <span>
                          Financial Value: $
                          {exceptionObject.FinancialValue?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }
                          )}
                        </span>
                      </div>
                    )}
                    {/* {(exceptionObject.IBBProgramCriteriaQuestionInputExceptionID >
                      0 && globalState.AppAccessLevelData.DID == 0) && (
                      <a
                        href={
                          "exceptions?pid=" +
                          scorecardFilter.ProgramID +
                          "&qid=" +
                          scorecardFilter.QuarterID +
                          "&exsid=" +
                          exceptionObject.Status +
                          "&exid=" +
                          exceptionObject.IBBProgramCriteriaQuestionInputExceptionID
                        }
                        target="_blank"
                      >
                        Go To Approval
                      </a>
                    )} */}
                  </div>

                  <span className="buis-head">Business Case</span>
                  <textarea
                    className="rows-6"
                    rows={6}
                    value={exceptionObject.BusinessCase}
                    onChange={(e) => {
                      setExceptionObject((prevState: any) => ({
                        ...prevState,
                        BusinessCase: e.target.value,
                      }));
                    }}
                  ></textarea>
                  {exceptionObject.UpdatedStatus == 0 && (
                    <div className="flex-items supp-doc">
                      <span>Supporting Documents:</span>

                      {showDragdrop && (
                        <div className="order-drag">
                          <DragDrop
                            ParentFeatures={dragDropFeatures}
                            DragDropCallback={handleDragDropCallback}
                            TriggerChild={triggerChild}
                          />
                        </div>
                      )}

                      {/* <p>Drag Drop Here or Click to Upload</p>
                  <div className="help-btns">
                    <a>Upload</a>
                  </div> */}
                    </div>
                  )}
                  {exceptionObject.IBBProgramCriteriaQuestionInputExceptionID !=
                    undefined &&
                    exceptionObject.IBBProgramCriteriaQuestionInputExceptionID !=
                      0 &&
                    exceptionObject.ConditionText != "" && (
                      <>
                        <span>
                          <b>Condition:</b>
                        </span>
                        <div className="flex-items">
                          <span className="spn-text-width">
                            {exceptionObject.ConditionText}
                          </span>
                        </div>
                      </>
                    )}
                </div>
              </div>
              <div className="help-btns">
                {exceptionObject.UpdatedStatus == 0 && (
                  <>
                    <a
                      onClick={() => {
                        IBBProgramCriteriaQuestionInputExceptionSaveCustom();
                        showPopUpForSaveFiles();
                      }}
                    >
                      Submit
                    </a>
                    {exceptionObject.IBBProgramCriteriaQuestionInputExceptionID !=
                      undefined &&
                      exceptionObject.IBBProgramCriteriaQuestionInputExceptionID !=
                        0 && (
                        <a
                          onClick={() => {
                            IBBProgramCriteriaQuestionInputExceptionDeleteRecordCustom();
                          }}
                        >
                          Delete
                        </a>
                      )}
                  </>
                )}
                <a onClick={() => setAddException(false)}>Cancel</a>
              </div>
            </div>
          </div>
        </div>
      )}

      {ViewException > 0 && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>View Exception</h3>
                <a className="close-help" onClick={() => setViewException(0)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>

              <div className="page--data view-exp-scroll">
                {ViewExceptionData &&
                  ViewExceptionData.map((Item: any, index: any) => (
                    <div
                      className="buis-case case-back plr-20"
                      key={"ViewException" + index}
                    >
                      <div
                        className="exception-grid"
                        style={{ gridTemplateColumns: "1fr" }}
                      >
                        <div className="exceptions-left">
                          <div className="flex-approval">
                            <span className="buis-head">
                              {Item.Name}
                              {/* {Item.Name} REASON FOR EXCEPTION */}
                            </span>
                            {/* {(globalState.AppAccessLevelData.DID == 0) &&
                            <a
                              href={
                                "exceptions?pid=" +
                                scorecardFilter.ProgramID +
                                "&qid=" +
                                scorecardFilter.QuarterID +
                                "&exsid=" +
                                Item.Status +
                                "&exid=" +
                                Item.IBBProgramCriteriaQuestionInputExceptionID
                              }
                              target="_blank"
                            >
                              Go To Approval
                            </a>
                            } */}
                          </div>
                          {((getAccessSettings(2, 26) > 0 &&
                            globalState.AppAccessLevelData.DID > 0) ||
                            globalState.AppAccessLevelData.DID == 0) && (
                            <div className="flex-items buis-head">
                              <span>
                                Financial Value: $
                                {Item.FinancialValue?.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </span>{" "}
                              <span>
                                Approved Value: $
                                {Item.ApprovedValue?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </span>{" "}
                              <span className="">
                                Status: {Item.StatusName}
                              </span>
                            </div>
                          )}
                          <span>
                            <b>Business Case:</b>
                          </span>
                          <span className="flex-items">
                            <span className="b-excep-wrap">
                              {Item.BusinessCase}
                            </span>
                          </span>
                          <div className="flex-items supp-doc">
                            <span>Supporting Documents:</span>
                            <>
                              {programCriteriaQuestionInputExceptionAttachmentData &&
                                programCriteriaQuestionInputExceptionAttachmentData.map(
                                  (
                                    ItemAttachment: any,
                                    indexAttachment: any
                                  ) => (
                                    <>
                                      {Item.IBBProgramCriteriaQuestionInputID ==
                                        ItemAttachment.ObjectID && (
                                        <span
                                          title={ItemAttachment.Name}
                                          key={
                                            ItemAttachment.ObjectID +
                                            "" +
                                            indexAttachment
                                          }
                                        >
                                          <a
                                            href={ItemAttachment.FileURL}
                                            target="blank"
                                          >
                                            <img
                                              src="images/pdf.svg"
                                              width="40px"
                                              height="40px"
                                            />
                                          </a>
                                        </span>
                                      )}
                                    </>
                                  )
                                )}
                            </>
                          </div>
                          {Item.ConditionText != "" && (
                            <>
                              <span>
                                <b>Condition:</b>
                              </span>
                              <div className="flex-items">
                                <span className="spn-text-width">
                                  {Item.ConditionText}
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {conditionModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Condition</h3>
                <a
                  className="close-help"
                  onClick={() => setConditionModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>

              <div className="buis-case plr-20">
                <span className="buis-head">Condition:</span>
                <textarea
                  value={conditionData.ConditionText}
                  onChange={(e) => {
                    setConditionData((prevState: any) => ({
                      ...prevState,
                      ConditionText: e.target.value,
                    }));
                  }}
                ></textarea>
              </div>
              <div className="buis-case plr-20">
                <span className="buis-head">Deadline:</span>
                <input
                  type="date"
                  value={moment(conditionData.Deadline).format("YYYY-MM-DD")}
                  onChange={(e) => {
                    setConditionData((prevState: any) => ({
                      ...prevState,
                      Deadline: e.target.value,
                    }));
                  }}
                ></input>
              </div>
              <div className="help-btns">
                <a
                  onClick={() => {
                    IBBConditionSaveCustom();
                  }}
                >
                  Save
                </a>
                <a onClick={() => setConditionModal(false)}>Cancel</a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Scorecard;
